
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("jdUP6", function(module, exports) {
const $e0175a3940f41f50$export$566f0440891acc8e = 'agentRemoteEditReviewData';
module.exports["AGENT_REMOTE_EDIT_REVIEW_DATA"] = $e0175a3940f41f50$export$566f0440891acc8e;

});

parcelRegister("1UwGp", function(module, exports) {

var $cha5E = parcelRequire("cha5E");

const $22ccc8966380428f$export$4a5bff77b793bc98 = 'agentEditChromeData';
const $22ccc8966380428f$export$7de800288c4c9af3 = 2000;
const $22ccc8966380428f$export$f5234c7b620d4724 = true;
const $22ccc8966380428f$export$c622006374915603 = ()=>({
        autoDismissAfterMs: (0, $cha5E.expVal)('platform_editor_agent_be_streaming', 'highlightDurationMs', $22ccc8966380428f$export$7de800288c4c9af3),
        telepointerEnabled: !(0, $cha5E.expVal)('platform_editor_agent_be_streaming', 'telepointerDisabled', !$22ccc8966380428f$export$f5234c7b620d4724)
    });
module.exports["AGENT_EDIT_CHROME_DATA"] = $22ccc8966380428f$export$4a5bff77b793bc98;
module.exports["AGENT_EDIT_CHROME_DEFAULT_AUTO_DISMISS_AFTER_MS"] = $22ccc8966380428f$export$7de800288c4c9af3;
module.exports["AGENT_EDIT_CHROME_DEFAULT_TELEPOINTER_ENABLED"] = $22ccc8966380428f$export$f5234c7b620d4724;
module.exports["getAgentEditChromeDynamicConfig"] = $22ccc8966380428f$export$c622006374915603;

});

parcelRegister("lVJ72", function(module, exports) {
/**
 * ADF mark types ignored when deciding whether agent-edited content changed:
 *
 *   - `breakout` — a layout-width mark (`mode: wide | full-width`) that a
 *     whole-node/whole-doc replace (e.g. `replaceDoc`) can drop, re-add or
 *     re-value without the reviewable *content* changing.
 *
 * Module-private (not exported) so this file has a single public runtime export
 * (Volt strict-mode rule), and so callers cannot diverge from the one comparison
 * definition below.
 */ const $22d0cd6cce048d4e$var$IGNORED_MARK_TYPES = new Set([
    'breakout'
]);
/**
 * Deep-normalise ADF JSON for change comparison so two structures that differ
 * ONLY by ignorable metadata compare equal. Specifically it:
 *
 *   - strips every `localId` (at any nesting): an ephemeral, per-node identity
 *     stamp that lives both as a node attribute (`attrs.localId`) and as a
 *     `fragment` mark attribute. A whole-node/whole-doc replace (e.g.
 *     `replaceDoc`) re-emits content with FRESH localIds, so content that is
 *     otherwise identical legitimately carries different localIds.
 *   - drops ignorable marks (`IGNORED_MARK_TYPES`, e.g. `breakout`) from every
 *     `marks` array, and removes a `marks` key that becomes empty so `marks: []`
 *     and an absent `marks` compare equal.
 *
 * Removing these regardless of nesting handles all carriers without needing to
 * know the schema.
 */ const $22d0cd6cce048d4e$var$normaliseForChangeCompare = (value)=>{
    if (Array.isArray(value)) return value.map($22d0cd6cce048d4e$var$normaliseForChangeCompare);
    if (value && typeof value === 'object') {
        const result = {};
        for (const [key, child] of Object.entries(value)){
            if (key === 'localId') continue;
            if (key === 'marks' && Array.isArray(child)) {
                const kept = child.filter((mark)=>!(mark && typeof mark === 'object' && $22d0cd6cce048d4e$var$IGNORED_MARK_TYPES.has(mark.type)));
                // Drop an empty `marks` array so `marks: []` == absent `marks`.
                if (kept.length > 0) result[key] = kept.map($22d0cd6cce048d4e$var$normaliseForChangeCompare);
                continue;
            }
            result[key] = $22d0cd6cce048d4e$var$normaliseForChangeCompare(child);
        }
        return result;
    }
    return value;
};
const $22d0cd6cce048d4e$export$aaa518e03f140665 = (a, b)=>{
    if (a === b) return true;
    if (a.openStart !== b.openStart || a.openEnd !== b.openEnd) return false;
    // `Fragment.toJSON()` returns `null` for empty content; normalise so two
    // empty slices (whatever their provenance) still compare equal.
    const aContent = $22d0cd6cce048d4e$var$normaliseForChangeCompare(a.content.toJSON() ?? null);
    const bContent = $22d0cd6cce048d4e$var$normaliseForChangeCompare(b.content.toJSON() ?? null);
    return JSON.stringify(aContent) === JSON.stringify(bContent);
};
module.exports["slicesEqualIgnoringLocalId"] = $22d0cd6cce048d4e$export$aaa518e03f140665;

});

parcelRegister("jNalm", function(module, exports) {

var $krYZG = parcelRequire("krYZG");


var $6pnwK = parcelRequire("6pnwK");


var $44cyU = parcelRequire("44cyU");

const $c2f1117a8d6f30fe$export$ae829ec7b2625219 = (eventDispatch, onSave)=>{
    if (!onSave) return;
    return (0, $44cyU.keymap)({
        Enter (state, _dispatch, editorView) {
            if (editorView && $c2f1117a8d6f30fe$var$canSaveOnEnter(editorView)) {
                eventDispatch((0, $6pnwK.analyticsEventKey), $c2f1117a8d6f30fe$var$analyticsPayload(state));
                onSave(editorView);
                return true;
            }
            return false;
        }
    });
};
function $c2f1117a8d6f30fe$var$canSaveOnEnter(editorView) {
    const { $cursor: $cursor } = editorView.state.selection;
    const { decisionItem: decisionItem, paragraph: paragraph, taskItem: taskItem } = editorView.state.schema.nodes;
    return !$cursor || $cursor.parent.type === paragraph && $cursor.depth === 1 || $cursor.parent.type === decisionItem && !$c2f1117a8d6f30fe$var$isEmptyAtCursor($cursor) || $cursor.parent.type === taskItem && !$c2f1117a8d6f30fe$var$isEmptyAtCursor($cursor);
}
function $c2f1117a8d6f30fe$var$isEmptyAtCursor($cursor) {
    const { content: content } = $cursor.parent;
    return !(content && content.size);
}
const $c2f1117a8d6f30fe$var$analyticsPayload = (state)=>({
        payload: {
            action: (0, $krYZG.ACTION).STOPPED,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).EDITOR,
            actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).SAVE,
            attributes: {
                inputMethod: (0, $krYZG.INPUT_METHOD).SHORTCUT,
                documentSize: state.doc.nodeSize
            },
            eventType: (0, $krYZG.EVENT_TYPE).UI
        }
    });
const $c2f1117a8d6f30fe$export$8ba1e5775ae443a6 = ({ config: onSave })=>({
        name: 'saveOnEnter',
        pmPlugins () {
            return [
                {
                    name: 'saveOnEnter',
                    plugin: ({ dispatch: dispatch })=>$c2f1117a8d6f30fe$export$ae829ec7b2625219(dispatch, onSave)
                }
            ];
        }
    });
module.exports["saveOnEnterPlugin"] = $c2f1117a8d6f30fe$export$8ba1e5775ae443a6;

});

parcelRegister("gIRc3", function(module, exports) {

var $5aU9U = parcelRequire("5aU9U");


var $eOaGc = parcelRequire("eOaGc");

const $2d26fccd79180fad$export$28ee9acdd4691fa9 = 'override-document';
class $2d26fccd79180fad$export$d790696cf3da3aa0 extends (0, $5aU9U.Step) {
    apply(doc) {
        this.oldDocumentSize = doc.content.size;
        return (0, $eOaGc.StepResult).ok(this.nextDocument);
    }
    map() {
        return new $2d26fccd79180fad$export$d790696cf3da3aa0({
            nextDocument: this.nextDocument,
            inverted: this.inverted
        });
    }
    getMap() {
        if (!this.nextDocument || !this.oldDocumentSize) return new (0, $eOaGc.StepMap)([
            0,
            0,
            0
        ]);
        const oldSize = this.oldDocumentSize;
        const nextDocumentSize = this.nextDocument.content.size;
        return new (0, $eOaGc.StepMap)([
            0,
            oldSize,
            nextDocumentSize
        ]);
    }
    invert(doc) {
        return new $2d26fccd79180fad$export$d790696cf3da3aa0({
            nextDocument: doc,
            inverted: true
        });
    }
    toJSON() {
        return {
            stepType: $2d26fccd79180fad$export$28ee9acdd4691fa9,
            inverted: this.inverted,
            nextDocument: this.nextDocument.toJSON()
        };
    }
    static fromJSON(schema, json) {
        if (!json || json.stepType !== $2d26fccd79180fad$export$28ee9acdd4691fa9) throw new RangeError('Invalid overrideDocument step OverrideDocumentStep.fromJSON');
        return new $2d26fccd79180fad$export$d790696cf3da3aa0({
            inverted: json.inverted,
            nextDocument: schema.nodeFromJSON(json.nextDocument)
        });
    }
    constructor(opts){
        super();
        this.inverted = false;
        this.nextDocument = void 0;
        this.oldDocumentSize = 0;
        const { inverted: inverted, nextDocument: nextDocument } = opts;
        if (nextDocument.type.name !== 'doc') throw new Error('nextDocument should be the entire prosemirror doc node and not only its content.');
        this.nextDocument = nextDocument;
        this.inverted = Boolean(inverted);
    }
}
(0, $5aU9U.Step).jsonID($2d26fccd79180fad$export$28ee9acdd4691fa9, $2d26fccd79180fad$export$d790696cf3da3aa0);
module.exports["OverrideDocumentStep"] = $2d26fccd79180fad$export$d790696cf3da3aa0;

});

parcelRegister("aqgkf", function(module, exports) {
$parcel$export(module.exports, "InsertTypeAheadStages", () => (parcelRequire("gT4iv")).InsertTypeAheadStages);
$parcel$export(module.exports, "InsertTypeAheadStep", () => (parcelRequire("gT4iv")).InsertTypeAheadStep);
$parcel$export(module.exports, "SetAttrsStep", () => (parcelRequire("1A89X")).SetAttrsStep);
$parcel$export(module.exports, "AnalyticsStep", () => (parcelRequire("l5rX3")).AnalyticsStep);
$parcel$export(module.exports, "LinkMetaStep", () => (parcelRequire("73Kv0")).LinkMetaStep);
$parcel$export(module.exports, "OverrideDocumentStep", () => (parcelRequire("gIRc3")).OverrideDocumentStep);
$parcel$export(module.exports, "BatchAttrsStep", () => (parcelRequire("hdvEd")).BatchAttrsStep);
/* eslint-disable @atlaskit/editor/no-re-export */ // eslint-disable-next-line @atlaskit/volt-strict-mode/no-re-exports -- Public compatibility re-export.

var $gT4iv = parcelRequire("gT4iv");


var $1A89X = parcelRequire("1A89X");


var $l5rX3 = parcelRequire("l5rX3");


var $73Kv0 = parcelRequire("73Kv0");


var $gIRc3 = parcelRequire("gIRc3");


var $hdvEd = parcelRequire("hdvEd");


});

parcelRegister("aOSDg", function(module, exports) {
$parcel$export(module.exports, "TableSortOrder", () => (parcelRequire("6faDz")).SortOrder);
$parcel$export(module.exports, "TableSortStep", () => (parcelRequire("kVd8s")).TableSortStep);
$parcel$export(module.exports, "AddColumnStep", () => (parcelRequire("cTqvh")).AddColumnStep);
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $6faDz = parcelRequire("6faDz");


var $kVd8s = parcelRequire("kVd8s");


var $cTqvh = parcelRequire("cTqvh");


});

parcelRegister("gh55E", function(module, exports) {

var $krYZG = parcelRequire("krYZG");


var $iLrhi = parcelRequire("iLrhi");


var $2lPWP = parcelRequire("2lPWP");


var $eOaGc = parcelRequire("eOaGc");


var $iDrrr = parcelRequire("iDrrr");


var $7TcbF = parcelRequire("7TcbF");


var $ieeJu = parcelRequire("ieeJu");


var $jkcNT = parcelRequire("jkcNT");





var $8ROsu = parcelRequire("8ROsu");


var $26lLV = parcelRequire("26lLV");

const $7cf676f4d1e8bc54$export$8c408a1f4e12c948 = (state, tr, featureFlags, editorAnalyticsApi)=>{
    return (error)=>{
        const browserExtensions = (0, $26lLV.sniffUserBrowserExtensions)({
            extensions: [
                'grammarly'
            ]
        });
        const payload = {
            action: (0, $krYZG.ACTION).SYNCHRONY_ERROR,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).EDITOR,
            eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
            attributes: {
                error: error,
                browserExtensions: browserExtensions
            }
        };
        if (featureFlags.synchronyErrorDocStructure) // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        payload.attributes.docStructure = (0, $8ROsu.getDocStructure)(state.doc, {
            compact: true
        });
        editorAnalyticsApi?.attachAnalyticsEvent(payload)(tr);
        return tr;
    };
};
const $7cf676f4d1e8bc54$export$6f3f7a1f93aa6704 = (reason, agentType, error)=>({
        action: (0, $krYZG.ACTION).AGENT_EDIT_SHIMMER_NOT_SHOWN,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).COLLAB,
        eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
        attributes: {
            reason: reason,
            // Spread conditionally so absent context isn't emitted as `undefined` (the teardown path has no
            // single agent, and non-throw reasons have no error).
            ...agentType ? {
                agentType: agentType
            } : {},
            ...error ? {
                error: `${error.name}: ${error.message}`
            } : {}
        }
    });
const $7cf676f4d1e8bc54$export$31cf0e3f119813a1 = (state, tr)=>{
    return (type, editorAnalyticsApi)=>{
        editorAnalyticsApi?.attachAnalyticsEvent({
            action: type === 'error' ? (0, $krYZG.ACTION).SYNCHRONY_ENTITY_ERROR : (0, $krYZG.ACTION).SYNCHRONY_DISCONNECTED,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).EDITOR,
            eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
            attributes: {
                // https://developer.mozilla.org/en-US/docs/Web/API/NavigatorOnLine/onLine
                onLine: navigator.onLine,
                visibilityState: document.visibilityState
            }
        })(tr);
        return tr;
    };
};



var $l5rX3 = parcelRequire("l5rX3");

// Ignored via go/ees005
// eslint-disable-next-line import/no-namespace

var $aqgkf = parcelRequire("aqgkf");


var $aOSDg = parcelRequire("aOSDg");


var $1UwGp = parcelRequire("1UwGp");


var $jdUP6 = parcelRequire("jdUP6");


var $kCECX = parcelRequire("kCECX");


var $5aU9U = parcelRequire("5aU9U");


var $cha5E = parcelRequire("cha5E");


var $4o0zT = parcelRequire("4o0zT");












var $lVJ72 = parcelRequire("lVJ72");


var $jv11C = parcelRequire("jv11C");










const $2955bb74975a5428$export$18d4026d1ea86bb1 = new (0, $kCECX.PluginKey)('collabEditPlugin');


const $f6a9255fd4845490$var$isAgentRemoteStep = (step)=>typeof step === 'object' && step !== null && typeof step.agentType === 'string';
const $f6a9255fd4845490$export$2f1374fb6d9abffc = (json, view)=>{
    const agentStep = json.find($f6a9255fd4845490$var$isAgentRemoteStep);
    if (!agentStep) return null;
    const actorUserId = typeof agentStep.userId === 'string' ? agentStep.userId : undefined;
    const collabPluginState = (0, $2955bb74975a5428$export$18d4026d1ea86bb1).getState(view.state);
    const localSessionId = collabPluginState?.sessionId;
    const localUserId = localSessionId ? collabPluginState?.activeParticipants?.get(localSessionId)?.userId : undefined;
    return {
        agentId: typeof agentStep.agentId === 'string' ? agentStep.agentId : undefined,
        agentType: agentStep.agentType,
        actorUserId: actorUserId,
        isLocalUserRequester: actorUserId !== undefined && localUserId !== undefined && actorUserId === localUserId
    };
};

















// When an agent step lands we cover the top-level block(s) it wrote with a skeleton-loader shimmer
// (plus a Rovo agent telepointer at the end of the range), then remove it on a timer to reveal the
// content. Gated behind the `platform_editor_agent_be_streaming` experiment. `shimmerDurationMs` and
// `highlightDurationMs` size the skeleton and purple-highlight phases and toggle independently: `0` on
// either skips that phase, `0` on both shows nothing.
let $4607a4f054ecad4b$var$agentShimmerIdCounter = 0;
const $4607a4f054ecad4b$export$6e1942fa8b890756 = (step)=>{
    let neutral = true;
    step.getMap().forEach((oldStart, oldEnd, newStart, newEnd)=>{
        if (oldEnd - oldStart !== newEnd - newStart) neutral = false;
    });
    return neutral;
};
const $4607a4f054ecad4b$export$c78340582aaebc79 = (step)=>{
    if (step instanceof (0, $eOaGc.AddMarkStep) || step instanceof (0, $eOaGc.RemoveMarkStep)) return {
        from: step.from,
        to: step.to
    };
    return null;
};
// Top-level block/position helpers over a doc. Kept at module scope (rather than re-created as
// closures on every call) so they are defined once, reusable, and unit-testable. Each clamps into
// valid document coordinates before resolving.
const $4607a4f054ecad4b$var$clampToDoc = (doc, pos)=>Math.min(Math.max(pos, 1), doc.content.size);
const $4607a4f054ecad4b$var$topLevelBlockIndexAt = (doc, pos)=>doc.resolve($4607a4f054ecad4b$var$clampToDoc(doc, pos)).index(0);
// Start of the content of the top-level block containing `pos`, so the whole block is covered.
const $4607a4f054ecad4b$var$topLevelBlockContentStart = (doc, pos)=>{
    const $pos = doc.resolve($4607a4f054ecad4b$var$clampToDoc(doc, pos));
    return $pos.depth >= 1 ? $pos.start(1) : pos;
};
// End of the content of the top-level block containing `pos`, so the whole block is covered.
const $4607a4f054ecad4b$var$topLevelBlockContentEnd = (doc, pos)=>{
    const $pos = doc.resolve($4607a4f054ecad4b$var$clampToDoc(doc, pos));
    return $pos.depth >= 1 ? $pos.end(1) : pos;
};
/**
 * Derive the shimmer ranges for the agent-authored steps in a received batch, in final-doc
 * coordinates. `agentType` present ⇒ agent-authored (per the NCS↔Editor steps contract). Each
 * emitted range is expanded to the whole top-level block(s) the agent touched, which the plugin
 * covers with the skeleton shimmer. Ranges with no new content (pure deletions) are dropped.
 *
 * Steps whose new content is in the same or directly-adjacent top-level block are coalesced into one
 * range, so an edit that arrives as several steps in a region shimmers as a single unit. Edits
 * separated by an untouched block stay independent.
 *
 * Correctness: the range math assumes `tr` is a linear 1:1 apply of `steps`. Under the native collab
 * plugin, `receiveTransaction` rebases incoming steps over unconfirmed local steps when they exist;
 * that only invalidates our positions if a local step shifted positions, so we skip solely when a
 * rebased local step changed sizes (a rare, safe degrade). Any unexpected error also degrades to no
 * shimmer, so this never throws into the shared remote-step handler.
 */ const $4607a4f054ecad4b$var$deriveAgentShimmerRanges = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
json, steps, tr, view, shimmerDurationMs, highlightDurationMs, telepointerEnabled, // Called when an agent-authored batch did NOT get the shimmer and applied instantly, so the
// caller can fire the `agentEditShimmerNotShown` operational event. Not called when both phases are
// off (config) or the batch has no agent steps; those aren't "not shown" cases.
onNotShown)=>{
    // The two phases toggle independently: `shimmerDurationMs` sizes the skeleton, `highlightDurationMs`
    // sizes the purple highlight, and `0` on either skips just that phase. Nothing to reveal only when
    // both are off.
    if (shimmerDurationMs <= 0 && highlightDurationMs <= 0) return [];
    // Start in the skeleton phase when it's enabled, otherwise straight into the purple highlight phase
    // (skeleton toggled off, highlight on).
    const initialPhase = shimmerDurationMs > 0 ? 'skeleton' : 'highlight';
    // Telepointer label = the agent's type upper-cased (e.g. `mcp` → "MCP"), falling back to a generic
    // "Agent"; `undefined` when the telepointer is disabled, so the plugin skips it. `agentType` is the
    // same on every step of an agent batch, so read it from the first agent-authored step.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const agentType = json.find((step)=>typeof step?.agentType === 'string')?.agentType;
    // No agent-authored steps in this batch — nothing to shimmer, and not a "not shown" case.
    if (agentType === undefined) return [];
    const telepointerLabel = telepointerEnabled ? agentType.toUpperCase() || 'Agent' : undefined;
    // When the batch was rebased over local unconfirmed steps, our index-based range math is only
    // valid if those local steps shifted no positions. Attribute-only steps (e.g. `localId`) and
    // same-size replacements are position-neutral, so the shimmer stays correct. Skip only when a
    // local step actually changed sizes (a genuine concurrent content edit).
    if (Number(tr.getMeta('rebased')) > 0) {
        const unconfirmed = (0, $7TcbF.getCollabState)(view.state)?.unconfirmed ?? [];
        if (unconfirmed.some((entry)=>!$4607a4f054ecad4b$export$6e1942fa8b890756(entry.step))) {
            onNotShown?.('rebasedConcurrentEdit', agentType);
            return [];
        }
    }
    try {
        // Map an inserted range in doc_{i+1} forward through the remaining steps to final-doc coords.
        // (A later step's own inserted content starts at its `from`; only subsequent steps shift it.)
        const mapToFinalDoc = (pos, stepIndex, bias)=>{
            let p = pos;
            for(let j = stepIndex + 1; j < steps.length; j++)p = steps[j].getMap().map(p, bias);
            return p;
        };
        const infos = [];
        json.forEach((rawStep, index)=>{
            if (typeof rawStep?.agentType !== 'string') return;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const pmStep = steps[index];
            if (typeof pmStep?.getMap !== 'function') return;
            // Mark-only steps have an empty StepMap, so the getMap().forEach below never fires for them.
            // Derive their range from step.from/.to instead so formatting-only agent edits still shimmer.
            const markRange = $4607a4f054ecad4b$export$c78340582aaebc79(steps[index]);
            if (markRange) {
                const beforeDocForMark = tr.docs[index] ?? tr.before;
                const from = mapToFinalDoc(markRange.from, index, -1);
                const to = mapToFinalDoc(markRange.to, index, 1);
                if (to > from) try {
                    const before = beforeDocForMark.slice(markRange.from, markRange.to);
                    const after = tr.doc.slice(from, to);
                    if (!(0, $lVJ72.slicesEqualIgnoringLocalId)(before, after)) infos.push({
                        from: from,
                        to: to
                    });
                } catch (error) {
                    // Degrade gracefully (no shimmer for this step) but track the error so a silent
                    // fall-through does not hide a systemic slicing problem.
                    (0, $jv11C.logException)(error, {
                        location: 'editor-plugin-collab-edit/agent-shimmer-ranges/markStepSlice'
                    });
                }
                return;
            }
            // The doc this step was applied to (its `old` coords resolve here). `tr.docs[index]` is the
            // document state before step `index`; fall back to the batch's before-doc for the first step.
            const beforeDoc = tr.docs[index] ?? tr.before;
            pmStep.getMap().forEach((oldStart, oldEnd, newStart, newEnd)=>{
                if (newEnd <= newStart) return; // pure deletion / attribute-only — no new content to highlight
                const from = mapToFinalDoc(newStart, index, -1);
                const to = mapToFinalDoc(newEnd, index, 1);
                // Skip phantom same-size re-writes (e.g. a `localId`/breakout re-stamp on an untouched
                // panel): their StepMap reports new content but nothing visibly changed. Drop only when
                // before/after are equal ignoring `localId` and layout marks, so real same-size edits
                // still shimmer. Mirrors the Review-moment segment producer's guard.
                if (oldEnd - oldStart === newEnd - newStart) try {
                    const before = beforeDoc.slice(oldStart, oldEnd);
                    const after = tr.doc.slice(from, to);
                    if ((0, $lVJ72.slicesEqualIgnoringLocalId)(before, after)) return;
                } catch  {
                // Comparison unsafe: keep the range; whole-block expansion still renders it.
                }
                infos.push({
                    from: from,
                    to: to
                });
            });
        });
        if (!infos.length) {
            onNotShown?.('nothingToShow', agentType);
            return [];
        }
        // Group the changed ranges by the TOP-LEVEL block they landed in, then highlight each touched
        // block IN FULL. NCS emits a single agent edit as many small replace fragments and often keeps a
        // common prefix/suffix untouched, so the changed sub-ranges cover only part of a block (e.g. half
        // a rewritten heading). Expanding to the whole block's content makes the entire heading/paragraph
        // shimmer as one unit rather than leaving the unchanged half undecorated. Directly-adjacent
        // touched blocks (index n and n+1) merge into one group so a multi-block rewrite reveals together;
        // a genuinely untouched block in between (index gap > 1) splits the run, so far-apart edits stay
        // independent.
        const sorted = [
            ...infos
        ].sort((a, b)=>a.from - b.from || a.to - b.to);
        const groups = [];
        sorted.forEach((info)=>{
            const block = $4607a4f054ecad4b$var$topLevelBlockIndexAt(tr.doc, info.from);
            const current = groups[groups.length - 1];
            if (current && block <= current.maxBlock + 1) {
                current.to = Math.max(current.to, info.to);
                current.maxBlock = Math.max(current.maxBlock, block);
            } else groups.push({
                from: info.from,
                to: info.to,
                maxBlock: block
            });
        });
        return groups.map((group)=>({
                shimmerId: `agent-shimmer-${$4607a4f054ecad4b$var$agentShimmerIdCounter++}`,
                from: $4607a4f054ecad4b$var$topLevelBlockContentStart(tr.doc, group.from),
                to: $4607a4f054ecad4b$var$topLevelBlockContentEnd(tr.doc, group.to),
                telepointerLabel: telepointerLabel,
                phase: initialPhase,
                highlightDurationMs: highlightDurationMs
            }));
    } catch (err) {
        // Never let shimmer range derivation throw into the shared remote-step handler; degrade to no
        // shimmer.
        onNotShown?.('captureThrew', agentType, err);
        return [];
    }
};
const $4607a4f054ecad4b$export$f64f53873128087b = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
json, steps, tr, view, shimmerDurationMs, highlightDurationMs, telepointerEnabled, onNotShown)=>{
    if (!(0, $ieeJu.expValEquals)('platform_editor_agent_be_streaming', 'isEnabled', true)) return [];
    return $4607a4f054ecad4b$var$deriveAgentShimmerRanges(json, steps, tr, view, shimmerDurationMs, highlightDurationMs, telepointerEnabled, onNotShown);
};
const $4607a4f054ecad4b$export$e3e1a593a0c5d01c = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
json, steps, tr, view, onNotShown)=>{
    // Reuse legacy range derivation with skeleton and telepointer output disabled. A non-zero
    // highlight duration keeps capture enabled; the returned legacy phase and duration are discarded.
    return $4607a4f054ecad4b$var$deriveAgentShimmerRanges(json, steps, tr, view, 0, 1, false, onNotShown).map(({ from: from, to: to })=>({
            from: from,
            to: to
        }));
};


const $512a8a2a05552848$export$7c03da4a40433b = 'platform_editor_backend_review_moment_agent_types';
// [CCI-17994] Post Stream Review ("Review moment") recording for BE streaming.
//
// Sibling to `getAgentShimmerRanges`, but for a different consumer: the shimmer
// only needs the NEW extent of added content, whereas the Review moment needs, per
// contiguous change, BOTH the pre-edit slice (for undo) and the new slice (for
// redo), and must keep deletions. The output is a neutral
// `AgentRemoteEditReviewData`; `editor-plugin-ai` turns each segment into a coarse
// `aiContentPositions` entry and reuses the entire FE Review moment pipeline.
//
// That pipeline requires every coarse entry to be a CLOSED, whole-node slice
// occupying exactly `[startPos, endPos]`. If a slice is left OPEN (a partial node,
// e.g. "…\nD") it drops the node wrapper on reconstruction — losing content on undo
// (data-loss bug) and bleeding highlights into neighbouring nodes. So we expand
// every change to whole-node outer boundaries and only emit self-consistent
// entries (see the group loop below).
const $512a8a2a05552848$var$clampToDoc = (doc, pos)=>Math.min(Math.max(pos, 1), doc.content.size);
const $512a8a2a05552848$var$topLevelBlockIndexAt = (doc, pos)=>doc.resolve($512a8a2a05552848$var$clampToDoc(doc, pos)).index(0);
// Outer boundaries (before/after tokens) of the top-level node containing `pos`.
// Slicing between these includes each node's own wrapper tokens, so the slice is
// CLOSED (`openStart === openEnd === 0`) and preserves node type on reconstruction
// (a `heading` stays a heading). `depth === 0` means `pos` sits between top-level
// nodes, so it is already a node boundary.
// Whether `pos` sits INSIDE a top-level node (depth > 0) vs exactly on a node
// boundary (depth 0). Unlike `clampToDoc`, this clamps to `[0, size]` (allowing 0)
// so the doc-start boundary is correctly reported as a boundary, not forced into
// the first node. Used to tell a structural add/remove (zero-width span at a node
// boundary) from a text-only insert/delete inside a surviving node.
const $512a8a2a05552848$var$isInsideNode = (doc, pos)=>doc.resolve(Math.min(Math.max(pos, 0), doc.content.size)).depth > 0;
const $512a8a2a05552848$var$topLevelNodeStart = (doc, pos)=>{
    const $pos = doc.resolve($512a8a2a05552848$var$clampToDoc(doc, pos));
    return $pos.depth === 0 ? $pos.pos : $pos.before(1);
};
const $512a8a2a05552848$var$topLevelNodeEnd = (doc, pos)=>{
    const $pos = doc.resolve($512a8a2a05552848$var$clampToDoc(doc, pos));
    return $pos.depth === 0 ? $pos.pos : $pos.after(1);
};
// Map a position in doc_{i+1} forward through the remaining steps to final-doc
// coords. Mirrors the shimmer's `mapToFinalDoc` — a later step's own inserted
// content starts at its `from`; only subsequent steps shift it.
const $512a8a2a05552848$var$mapToFinalDoc = (steps, pos, stepIndex, bias)=>{
    let p = pos;
    for(let j = stepIndex + 1; j < steps.length; j++)p = steps[j].getMap().map(p, bias);
    return p;
};
// Map a step's `old` coord (valid in doc_i, this step's input) back to pre-batch
// (`tr.before`) coords by inverting the PRECEDING steps' maps in reverse. Needed to
// recover a deletion's original span: its new extent is zero-width, so it cannot be
// found by inverse-mapping the collapsed new point.
const $512a8a2a05552848$var$mapToBeforeDoc = (steps, pos, stepIndex, bias)=>{
    let p = pos;
    for(let j = stepIndex - 1; j >= 0; j--)p = steps[j].getMap().invert().map(p, bias);
    return p;
};
const $512a8a2a05552848$export$72163675ef60f4e3 = (// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
json, steps, tr, view)=>{
    const agentEditRequester = (0, $f6a9255fd4845490$export$2f1374fb6d9abffc)(json, view);
    if (!agentEditRequester) return null;
    const { actorUserId: actorUserId, agentId: agentId, agentType: agentType, isLocalUserRequester: isLocalUserRequester } = agentEditRequester;
    // Only record Review Moment for agentTypes allowlisted in Statsig. Default `[]` fails
    // closed until the config is populated (CCI-18607).
    const allowedAgentTypes = (0, $cha5E.expVal)($512a8a2a05552848$export$7c03da4a40433b, 'value', []);
    if (!allowedAgentTypes.includes(agentType)) return null;
    // Hybrid end-of-edit seam: if the BE/NCS flags a batch as the terminal one, carry
    // it so the AI plugin can open review immediately instead of waiting for the
    // debounce. Additive marker; absent for streaming (non-final) batches.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const complete = json.some((step)=>step?.agentEditComplete === true);
    // Same rebase guard as the shimmer: index-based range math is only valid if any
    // rebased-over local steps shifted no positions. Degrade to no recording otherwise.
    if (Number(tr.getMeta('rebased')) > 0) {
        const unconfirmed = (0, $7TcbF.getCollabState)(view.state)?.unconfirmed ?? [];
        if (unconfirmed.some((entry)=>!(0, $4607a4f054ecad4b$export$6e1942fa8b890756)(entry.step))) return null;
    }
    try {
        // Each agent step's changed extent in FINAL-doc coords, taken from its StepMap
        // (the canonical, step-type-agnostic source). Unlike the shimmer we KEEP
        // zero-width new extents — a pure deletion has `newEnd === newStart` but is a
        // reviewable `remove`.
        const ranges = [];
        json.forEach((rawStep, index)=>{
            if (typeof rawStep?.agentType !== 'string') return;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const pmStep = steps[index];
            if (typeof pmStep?.getMap !== 'function') return;
            // Mark-only steps have an empty StepMap, so the getMap().forEach below never fires for them.
            // Derive their range from step.from/.to so a formatting-only agent edit still becomes a segment.
            const markRange = (0, $4607a4f054ecad4b$export$c78340582aaebc79)(steps[index]);
            if (markRange) {
                const mappedFrom = $512a8a2a05552848$var$mapToFinalDoc(steps, markRange.from, index, -1);
                const mappedTo = $512a8a2a05552848$var$mapToFinalDoc(steps, markRange.to, index, 1);
                const mappedOrigFrom = $512a8a2a05552848$var$mapToBeforeDoc(steps, markRange.from, index, -1);
                const mappedOrigTo = $512a8a2a05552848$var$mapToBeforeDoc(steps, markRange.to, index, 1);
                if (mappedTo > mappedFrom) try {
                    const before = tr.before.slice(mappedOrigFrom, mappedOrigTo);
                    const after = tr.doc.slice(mappedFrom, mappedTo);
                    if (!before.content.eq(after.content)) ranges.push({
                        from: mappedFrom,
                        to: mappedTo,
                        origFrom: mappedOrigFrom,
                        origTo: mappedOrigTo
                    });
                } catch (error) {
                    // Degrade gracefully (skip this step's range) but track the error so a silent
                    // fall-through does not hide a systemic slicing problem.
                    (0, $jv11C.logException)(error, {
                        location: 'editor-plugin-collab-edit/agent-review-segments/markStepSlice'
                    });
                }
                return;
            }
            pmStep.getMap().forEach((oldStart, oldEnd, newStart, newEnd)=>{
                const mappedFrom = $512a8a2a05552848$var$mapToFinalDoc(steps, newStart, index, -1);
                const mappedTo = $512a8a2a05552848$var$mapToFinalDoc(steps, newEnd, index, 1);
                // The same change in pre-batch coords, so a deletion (zero-width new
                // extent) still carries its original span.
                const mappedOrigFrom = $512a8a2a05552848$var$mapToBeforeDoc(steps, oldStart, index, -1);
                const mappedOrigTo = $512a8a2a05552848$var$mapToBeforeDoc(steps, oldEnd, index, 1);
                // Skip position-neutral phantom touches: the collab apply stamps same-size
                // re-writes on unrelated nodes (e.g. `localId` on panels). Drop them only
                // when byte-identical, so a real same-size replacement is preserved.
                if (oldEnd - oldStart === newEnd - newStart) try {
                    const before = tr.before.slice(oldStart, oldEnd);
                    const after = tr.doc.slice(mappedFrom, mappedTo);
                    if (before.content.eq(after.content)) return;
                } catch  {
                // Comparison unsafe: keep the range; whole-block expansion + the
                // later identical-content skip still guard against phantoms.
                }
                ranges.push({
                    from: mappedFrom,
                    to: mappedTo,
                    origFrom: mappedOrigFrom,
                    origTo: mappedOrigTo
                });
            });
        });
        if (!ranges.length) return null;
        // Coalesce fragments in the same/adjacent top-level block into one region (a
        // single agent edit arrives as many small replace fragments); an untouched block
        // between them splits the run so far-apart edits stay separate. Each region
        // becomes one coarse segment; the AI plugin refines it further.
        const sorted = [
            ...ranges
        ].sort((a, b)=>a.from - b.from || a.to - b.to);
        const groups = [];
        sorted.forEach((range)=>{
            const block = $512a8a2a05552848$var$topLevelBlockIndexAt(tr.doc, range.from);
            const current = groups[groups.length - 1];
            // Coalesce changes in the same or directly-adjacent top-level block (index n /
            // n+1) into one region, exactly like the shimmer — a single agent edit arrives
            // as many small fragments. A genuinely untouched block in between (index gap
            // > 1) splits the run, keeping far-apart edits separate. The original span is
            // unioned in parallel so a deletion's removed content is preserved.
            if (current && block <= current.maxBlock + 1) {
                current.to = Math.max(current.to, range.to);
                current.maxBlock = Math.max(current.maxBlock, block);
                current.origFrom = Math.min(current.origFrom, range.origFrom);
                current.origTo = Math.max(current.origTo, range.origTo);
            } else groups.push({
                from: range.from,
                to: range.to,
                maxBlock: block,
                origFrom: range.origFrom,
                origTo: range.origTo
            });
        });
        const segments = [];
        groups.forEach((group)=>{
            try {
                // Expand the NEW extent to whole-node outer boundaries → a CLOSED slice.
                // A zero-width new extent at a top-level node boundary is a structural
                // deletion: leave it empty (do NOT whole-node expand, or it would grab the
                // unchanged neighbour node that now sits at that point and be discarded as an
                // identical phantom). A zero-width new extent INSIDE a node is a text-only
                // deletion from a surviving node, so expand to the whole node (an `update`).
                const newIsStructuralRemove = group.from === group.to && !$512a8a2a05552848$var$isInsideNode(tr.doc, group.from);
                const newFrom = $512a8a2a05552848$var$topLevelNodeStart(tr.doc, Math.min(group.from, group.to));
                const newTo = newIsStructuralRemove ? newFrom : $512a8a2a05552848$var$topLevelNodeEnd(tr.doc, Math.max(group.from, group.to));
                const newSlice = tr.doc.slice(newFrom, newTo);
                // Build the ORIGINAL slice from the carried pre-batch span, expanded to whole
                // nodes → a CLOSED slice. Using the carried `origFrom/origTo` (from the
                // StepMap `old` coords) rather than inverse-mapping the new bounds is what
                // lets a deletion recover its removed content.
                //
                // A zero-width original span is only a true structural ADD when it sits at a
                // top-level node boundary (inserting a whole new node). A zero-width span
                // INSIDE a node is a text insertion into that node, so expand to the whole
                // node (an `update`) — matching how an in-place edit reviews.
                const origIsStructuralAdd = group.origFrom === group.origTo && !$512a8a2a05552848$var$isInsideNode(tr.before, group.origFrom);
                const origFrom = $512a8a2a05552848$var$topLevelNodeStart(tr.before, Math.min(group.origFrom, group.origTo));
                const origTo = origIsStructuralAdd ? origFrom : $512a8a2a05552848$var$topLevelNodeEnd(tr.before, Math.max(group.origFrom, group.origTo));
                const originalSlice = tr.before.slice(origFrom, origTo);
                const originalEmpty = originalSlice.content.size === 0;
                const newEmpty = newSlice.content.size === 0;
                // A truly empty-to-empty region is not a change — skip it.
                if (originalEmpty && newEmpty) return;
                // Skip phantom artifacts: a same-size StepMap "touch" at an unrelated node
                // (e.g. a `localId` stamp on a panel during collab apply) expands to a
                // segment whose original and new content are identical — not a real change.
                // Layout-only marks (`breakout`) and `localId`s are ignored so a
                // breakout-width-only change is not recorded as a coarse segment: the FE
                // Review filter drops it anyway, so recording it here would anchor the modal
                // to a node with no visible diff.
                if ((0, $lVJ72.slicesEqualIgnoringLocalId)(originalSlice, newSlice)) return;
                const kind = originalEmpty ? 'add' : newEmpty ? 'remove' : 'update';
                segments.push({
                    startPos: newFrom,
                    endPos: newTo,
                    originalSlice: originalSlice,
                    newSlice: newSlice,
                    kind: kind
                });
            } catch  {
            // One bad group must not drop the others.
            }
        });
        if (!segments.length) return null;
        return {
            actorUserId: actorUserId,
            agentId: agentId,
            agentType: agentType,
            complete: complete,
            isLocalUserRequester: isLocalUserRequester,
            segments: segments
        };
    } catch  {
        // Never throw into the shared remote-step handler; degrade to no recording.
        return null;
    }
};



var $8nvEM = parcelRequire("8nvEM");

const $2ae884f8c9798406$export$aa0937b45953b3db = 3000;
const $2ae884f8c9798406$export$f8af4b416532a528 = 2000;
const $2ae884f8c9798406$export$63ca995375149bdc = 'collab-agent-shimmer';
const $2ae884f8c9798406$export$222eb4184643a9 = 'collab-agent-edit-highlight';
const $2ae884f8c9798406$export$6c825ce2d4ad5f26 = 'ai-in-editor-telepointer';
const $2ae884f8c9798406$export$1aa6da0fcc4baa6e = 'ai-in-editor-telepointer-label';
const $2ae884f8c9798406$export$e48683d1c200d637 = 'addAgentShimmer'; // register the shimmer decorations
const $2ae884f8c9798406$export$736faf53f1a48861 = 'highlightAgentShimmer'; // skeleton → purple highlight phase
const $2ae884f8c9798406$export$4cd536a39e6c2c4f = 'removeAgentShimmer'; // remove them once the shimmer ends
// Rovo AI in-editor telepointer/cursor shown at the end of an agent-authored range (same DOM/style
// pattern as editor-plugin-ai's in-editor direct-streaming telepointer).
const $2ae884f8c9798406$var$createRovoAgentTelepointer = (label)=>{
    const element = document.createElement('span');
    element.setAttribute('data-testid', 'ai-in-editor-telepointer-widget');
    element.className = $2ae884f8c9798406$export$6c825ce2d4ad5f26;
    const labelElement = document.createElement('span');
    labelElement.setAttribute('data-testid', 'ai-in-editor-telepointer-widget-label');
    labelElement.className = $2ae884f8c9798406$export$1aa6da0fcc4baa6e;
    labelElement.append(label);
    element.appendChild(labelElement);
    return element;
};
const $2ae884f8c9798406$export$caaa5661d99996f1 = (current, tr, added, removedShimmerId, highlightShimmerId)=>{
    let next = current;
    let changed = false;
    // Ranges added in THIS transaction are already in post-change coords, so map the pre-existing
    // ones BEFORE replacing with any new batch.
    if (tr.docChanged && next.length) {
        next = next.map((shimmer)=>({
                ...shimmer,
                from: tr.mapping.map(shimmer.from, -1),
                to: tr.mapping.map(shimmer.to, 1)
            }));
        changed = true;
    }
    if (added?.length) {
        next = added.map((shimmer)=>({
                ...shimmer
            }));
        changed = true;
    }
    // Transition a shimmer from the skeleton phase to the purple highlight phase (skeleton timer fired).
    // Guard on an actual match so a timer firing after the shimmer was already removed (superseded by a
    // new batch, or cleared) doesn't rebuild the array and trigger a pointless decoration rebuild.
    if (highlightShimmerId && next.some((shimmer)=>shimmer.shimmerId === highlightShimmerId)) {
        next = next.map((shimmer)=>shimmer.shimmerId === highlightShimmerId ? {
                ...shimmer,
                phase: 'highlight'
            } : shimmer);
        changed = true;
    }
    if (removedShimmerId) {
        next = next.filter((shimmer)=>shimmer.shimmerId !== removedShimmerId);
        changed = true;
    }
    return {
        changed: changed,
        next: next
    };
};
const $2ae884f8c9798406$export$6039627ad3fe2215 = (tr, shimmers, getValidPos, onError)=>{
    const decorations = [];
    shimmers.forEach(({ shimmerId: shimmerId, from: from, to: to, telepointerLabel: telepointerLabel, phase: phase, highlightDurationMs: highlightDurationMs })=>{
        try {
            // `getValidPos` already clamps to the last valid position, so only the lower bound needs
            // guarding here (a raw `from < 1` would throw in `doc.resolve`).
            const validFrom = getValidPos(tr, Math.max(from, 1));
            const validTo = getValidPos(tr, to);
            if (validTo <= validFrom) return;
            // Inline decoration over the whole range: the grey skeleton loader, or (once revealed) the
            // purple "just edited" highlight. The highlight eases in and out over its lifetime via a CSS
            // animation whose duration is set inline so it matches the removal timer.
            const isHighlight = phase === 'highlight';
            const inlineAttrs = {
                class: isHighlight ? $2ae884f8c9798406$export$222eb4184643a9 : $2ae884f8c9798406$export$63ca995375149bdc
            };
            if (isHighlight && highlightDurationMs > 0) inlineAttrs.style = `animation-duration: ${highlightDurationMs}ms`;
            decorations.push((0, $8nvEM.Decoration).inline(validFrom, validTo, inlineAttrs, {
                isAgentShimmer: true,
                shimmerId: shimmerId
            }));
            // Rovo AI telepointer/cursor (labelled with the agent's type) at the end of the range, shown
            // through BOTH the skeleton and purple-highlight phases so the agent's cursor stays put until
            // the edit is fully revealed.
            if (telepointerLabel) decorations.push((0, $8nvEM.Decoration).widget(validTo, $2ae884f8c9798406$var$createRovoAgentTelepointer(telepointerLabel), {
                isAgentShimmer: true,
                shimmerId: shimmerId,
                class: $2ae884f8c9798406$export$6c825ce2d4ad5f26,
                key: `agent-telepointer-${shimmerId}`,
                side: 1
            }));
        } catch (err) {
            // One bad range must not kill the others.
            onError(err);
        }
    });
    return decorations;
};








var $hdvEd = parcelRequire("hdvEd");


var $1A89X = parcelRequire("1A89X");





var $jbOus = parcelRequire("jbOus");


var $5Qi6J = parcelRequire("5Qi6J");


var $fngNp = parcelRequire("fngNp");











var $6e6qw = parcelRequire("6e6qw");


var $aPdNQ = parcelRequire("aPdNQ");

function $310f7ef6cdc3c4ee$export$e0776a297562f4e0(oldFragment, newFragment) {
    // Fast path: referentially identical — nothing to do
    if (oldFragment === newFragment) return oldFragment;
    // Fast path: structurally equal — reuse old fragment entirely.
    // This covers the common SSR case where collab init sends the same doc.
    if (oldFragment.eq(newFragment)) return oldFragment;
    // Walk children position-by-position and preserve what we can
    const oldCount = oldFragment.childCount;
    const newCount = newFragment.childCount;
    let changed = false;
    const children = [];
    for(let i = 0; i < newCount; i++){
        const newChild = newFragment.child(i);
        if (i < oldCount) {
            const oldChild = oldFragment.child(i);
            if (oldChild === newChild) // Already referentially identical
            children.push(newChild);
            else if (oldChild.eq(newChild)) // Structurally equal — reuse old reference (THE KEY OPERATION)
            children.push(oldChild);
            else if (oldChild.type === newChild.type && oldChild.sameMarkup(newChild) && oldChild.content.childCount > 0 && newChild.content.childCount > 0) {
                // Same type and markup but different content — recurse into children
                const preservedContent = $310f7ef6cdc3c4ee$export$e0776a297562f4e0(oldChild.content, newChild.content);
                if (preservedContent === oldChild.content) // All content was preserved — reuse old node entirely
                children.push(oldChild);
                else {
                    // Partially changed — create node with preserved content
                    children.push(oldChild.copy(preservedContent));
                    changed = true;
                }
            } else {
                // Completely different node — use new
                children.push(newChild);
                changed = true;
            }
        } else {
            // New child beyond old count — use as-is (insertion)
            children.push(newChild);
            changed = true;
        }
    }
    // If nothing changed and counts match, return old fragment directly
    // (avoids creating a new Fragment object)
    if (!changed && oldCount === newCount) return oldFragment;
    return (0, $aPdNQ.Fragment).from(children);
}


const $c09ce8c88f088fff$export$cc7116c03c331d66 = (id, decorations)=>decorations.find().reduce(// `pointer` is absent on non-telepointer decorations (e.g. the agent-shimmer
    // sweep decorations), so guard against it to avoid crashing this shared helper.
    (arr, deco)=>deco.spec.pointer?.presenceId === id ? arr.concat(deco) : arr, []);
function $c09ce8c88f088fff$var$style(options) {
    const color = options && options.color || "var(--ds-border, #0B120E24)";
    const borderWidth = "var(--ds-border-width-focused, 2px)";
    return `border-right: ${borderWidth} solid ${color}; margin-right: calc(-1 * ${borderWidth}); z-index: 1`;
}
function $c09ce8c88f088fff$export$90c6ee000c44ff4a(str) {
    const participantColor = (0, $6e6qw.getParticipantColor)(str);
    return {
        index: participantColor.index,
        backgroundColor: participantColor.color.backgroundColor,
        textColor: participantColor.color.textColor
    };
}
const $c09ce8c88f088fff$export$8f868fb36fe42fe8 = (from, to, sessionId, isSelection, initial, presenceId, fullName, isNudged)=>{
    const decorations = [];
    const avatarColor = $c09ce8c88f088fff$export$90c6ee000c44ff4a(presenceId);
    const color = avatarColor.index.toString();
    if (isSelection) {
        const className = `telepointer color-${color} telepointer-selection`;
        decorations.push((0, $8nvEM.Decoration).inline(from, to, {
            class: className
        }, {
            pointer: {
                sessionId: sessionId,
                presenceId: presenceId
            }
        }));
    }
    const spaceJoinerBefore = document.createElement('span');
    spaceJoinerBefore.textContent = (0, $fngNp.ZERO_WIDTH_JOINER);
    const spaceJoinerAfter = document.createElement('span');
    spaceJoinerAfter.textContent = (0, $fngNp.ZERO_WIDTH_JOINER);
    const cursor = document.createElement('span');
    cursor.textContent = (0, $fngNp.ZERO_WIDTH_JOINER);
    cursor.className = `telepointer color-${color} telepointer-selection-badge`;
    cursor.style.cssText = `${$c09ce8c88f088fff$var$style({
        color: avatarColor.backgroundColor
    })};`;
    cursor.setAttribute('aria-label', `${fullName} cursor position`);
    cursor.setAttribute('role', 'button');
    cursor.setAttribute((0, $jbOus.TELEPOINTER_DATA_SESSION_ID_ATTR), sessionId);
    // If there is an ongoing expand animation, we'll keep the telepointer expanded
    // until the keyframe animation is complete. Please note that this will restart the anim timer
    // from 0 everytime it's re-added.
    if (isNudged) cursor.classList.add((0, $jbOus.TELEPOINTER_PULSE_DURING_TR_CLASS));
    const fullNameEl = document.createElement('span');
    fullNameEl.textContent = fullName;
    fullNameEl.className = 'telepointer-fullname';
    fullNameEl.style.backgroundColor = avatarColor.backgroundColor;
    fullNameEl.style.color = avatarColor.textColor;
    fullNameEl.setAttribute('aria-hidden', 'true');
    cursor.appendChild(fullNameEl);
    const initialEl = document.createElement('span');
    initialEl.textContent = initial;
    initialEl.className = 'telepointer-initial';
    initialEl.style.backgroundColor = avatarColor.backgroundColor;
    initialEl.style.color = avatarColor.textColor;
    initialEl.setAttribute('aria-hidden', 'true');
    cursor.appendChild(initialEl);
    return decorations.concat((0, $8nvEM.Decoration).widget(to, spaceJoinerAfter, {
        pointer: {
            sessionId: sessionId,
            presenceId: presenceId
        },
        key: `telepointer-${sessionId}-zero`
    })).concat((0, $8nvEM.Decoration).widget(to, cursor, {
        pointer: {
            sessionId: sessionId,
            presenceId: presenceId
        },
        key: `telepointer-${sessionId}`
    })).concat((0, $8nvEM.Decoration).widget(to, spaceJoinerBefore, {
        pointer: {
            sessionId: sessionId,
            presenceId: presenceId
        },
        key: `telepointer-${sessionId}-zero`
    }));
};
const $c09ce8c88f088fff$export$fe10d6bdd551e45e = (doc, state, version, options, reserveCursor, editorAnalyticsAPI)=>{
    const { schema: schema, tr: tr } = state;
    const parsedDoc = (0, $5Qi6J.processRawValueWithoutValidation)(schema, doc, editorAnalyticsAPI?.fireAnalyticsEvent);
    const hasContent = !!parsedDoc?.childCount;
    const content = parsedDoc?.content;
    if (hasContent && content) {
        const preservedContent = (0, $310f7ef6cdc3c4ee$export$e0776a297562f4e0)(state.doc.content, content);
        // If the entire content is identical, skip the replaceWith entirely
        // and just update collab metadata. This avoids triggering a full
        // document reconciliation for no-op replacements.
        if (preservedContent === state.doc.content) {
            tr.setMeta('addToHistory', false);
            if (version !== undefined && options && options.useNativePlugin) {
                const collabState = {
                    version: version,
                    unconfirmed: []
                };
                tr.setMeta('collab$', collabState);
            }
            return tr;
        }
        // Use the preserved fragment (reuses old node references for unchanged nodes)
        // rather than the raw parsed content, so ProseMirror's view reconciliation
        // can fast-match unchanged subtrees via referential identity (===).
        tr.setMeta('addToHistory', false);
        tr.replaceWith(0, state.doc.nodeSize - 2, preservedContent);
        const selection = state.selection;
        if (reserveCursor) {
            if (selection.to < tr.doc.content.size - 2) {
                const $from = tr.doc.resolve(selection.from);
                const $to = tr.doc.resolve(selection.to);
                const newselection = new (0, $kCECX.TextSelection)($from, $to);
                tr.setSelection(newselection);
            }
        } else tr.setSelection((0, $kCECX.Selection).atStart(tr.doc));
        tr.setMeta('replaceDocument', true);
        if (version !== undefined && options && options.useNativePlugin) {
            const collabState = {
                version: version,
                unconfirmed: []
            };
            tr.setMeta('collab$', collabState);
        }
    } else if (hasContent) {
        tr.setMeta('addToHistory', false);
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        tr.replaceWith(0, state.doc.nodeSize - 2, content);
        const selection = state.selection;
        if (reserveCursor) // If the cursor is still in the range of the new document,
        // keep where it was.
        {
            if (selection.to < tr.doc.content.size - 2) {
                const $from = tr.doc.resolve(selection.from);
                const $to = tr.doc.resolve(selection.to);
                const newselection = new (0, $kCECX.TextSelection)($from, $to);
                tr.setSelection(newselection);
            }
        } else tr.setSelection((0, $kCECX.Selection).atStart(tr.doc));
        tr.setMeta('replaceDocument', true);
        if (options && options.useNativePlugin) {
            const collabState = {
                version: version,
                unconfirmed: []
            };
            tr.setMeta('collab$', collabState);
        }
    }
    return tr;
};
const $c09ce8c88f088fff$export$82e6f13680c85057 = (editorView, participants, sessionId, index, editorAnalyticsAPI)=>{
    const selectedUser = participants[index];
    if (selectedUser && selectedUser.cursorPos !== undefined && selectedUser.sessionId !== sessionId) {
        const { state: state } = editorView;
        const tr = state.tr;
        const analyticsPayload = {
            action: (0, $krYZG.ACTION).MATCHED,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).SELECTION,
            eventType: (0, $krYZG.EVENT_TYPE).TRACK
        };
        tr.setSelection((0, $kCECX.Selection).near(tr.doc.resolve(selectedUser.cursorPos)));
        editorAnalyticsAPI?.attachAnalyticsEvent(analyticsPayload)(tr);
        tr.scrollIntoView();
        editorView.dispatch(tr);
        if (!editorView.hasFocus()) editorView.focus();
    }
};
const $c09ce8c88f088fff$export$4d66b240d6166074 = (sessionId, decorationSet)=>{
    let scrollPosition;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    decorationSet.find().forEach((deco)=>{
        if (deco.type.spec.pointer.sessionId === sessionId) scrollPosition = deco.from;
    });
    return scrollPosition;
};
const $c09ce8c88f088fff$export$94600c572c12bcd6 = (step)=>step instanceof (0, $eOaGc.ReplaceStep);
const $c09ce8c88f088fff$export$b8c92cc7dad49da = (transaction, metaTag)=>{
    const hasMetaTag = Boolean(transaction.getMeta(metaTag));
    if (hasMetaTag) return true;
    const appendedTransaction = transaction.getMeta('appendedTransaction');
    if (appendedTransaction instanceof (0, $kCECX.Transaction)) return $c09ce8c88f088fff$export$b8c92cc7dad49da(appendedTransaction, metaTag);
    return false;
};
/**
 * This list contains step attributes that do not result from a user action.
 * All steps that contain ONLY the blocked attribute are considered automated steps
 * and should not be recognised as organic change.
 *
 * `attr_colwidth` is an exception to above explanation. Resizing the column
 * currently creates too many steps and is therefore also on this list.
 *
 * Steps analycs dashboard: https://atlassian-discover.cloud.databricks.com/dashboardsv3/01ef4d3c8aa916c8b0cb5332a9f37caf/published?o=4482001201517624
 */ const $c09ce8c88f088fff$var$blockedAttrsList = [
    '__contextId',
    'localId',
    '__autoSize',
    'attr_colwidth',
    'originalHeight',
    'originalWidth'
];
const $c09ce8c88f088fff$export$227edb0398ff0ff6 = (tr)=>{
    // If document has not been marked as `docChanged` by PM, skip the rest of the logic
    if (!tr.docChanged) return false;
    return tr.steps.some((step)=>{
        // If a step is an instance of AnalyticsStep, it is not considered organic
        if (step instanceof (0, $l5rX3.AnalyticsStep)) return false;
        // editor-plugin-local-id uses AttrStep to set the localId attribute
        if (step instanceof (0, $eOaGc.AttrStep) && step.attr === 'localId') return false;
        // editor-plugin-local-id uses BatchAttrStep to set the localId attribute
        if (step instanceof (0, $hdvEd.BatchAttrsStep)) {
            const allAttributes = step.data.map((data)=>Object.keys(data.attrs)).flat();
            return allAttributes.some((attr)=>!$c09ce8c88f088fff$var$blockedAttrsList.includes(attr)) && !tr.doc.eq(tr.before);
        }
        // If a step is not an instance of SetAttrsStep, it is considered organic
        if (!(step instanceof (0, $1A89X.SetAttrsStep))) return true;
        const allAttributes = Object.keys(step.attrs);
        // If a step is an instance of SetAttrsStep, it checks if the attributes in the step
        // are not in the `blockedAttributes`. If one of the attributes not on the list, it considers the change
        // organic but only if the entire document is not equal to the previous state.
        return allAttributes.some((attr)=>!$c09ce8c88f088fff$var$blockedAttrsList.includes(attr)) && !tr.doc.eq(tr.before);
    });
};
const $c09ce8c88f088fff$export$6a7a563833bcd8 = (sessionId, nudgeAnimations)=>{
    const nudgeAnimStartTime = nudgeAnimations.get(sessionId);
    let hasExistingNudge = false;
    if (nudgeAnimStartTime) {
        const timeElapsed = Date.now() - nudgeAnimStartTime;
        hasExistingNudge = timeElapsed < (0, $jbOus.TELEPOINTER_PULSE_DURING_TR_DURATION_MS);
    }
    return hasExistingNudge;
};


const $666505553c33095c$export$d970973925859b8e = ()=>{
    Object.entries($aOSDg).forEach(()=>{});
    Object.entries($aqgkf).forEach(()=>{});
};
const $666505553c33095c$export$a04a448cc866246 = (initData, view, options, editorAnalyticsApi)=>{
    const { doc: doc, json: json, version: version, reserveCursor: reserveCursor } = initData;
    if (doc) {
        const { state: state } = view;
        const tr = (0, $c09ce8c88f088fff$export$fe10d6bdd551e45e)(doc, state, version, options, reserveCursor, editorAnalyticsApi);
        tr.setMeta('isRemote', true);
        view.dispatch(tr);
    } else if (json) $666505553c33095c$export$ff4f2767b9e99aa9(json, view, undefined, options, editorAnalyticsApi);
};
const $666505553c33095c$export$cf9a0dcadb173615 = (connectionData, view)=>{
    const { state: { tr: tr } } = view;
    view.dispatch(tr.setMeta('sessionId', connectionData));
};
const $666505553c33095c$export$f9db5387b510d6c = (presenceData, view)=>{
    const { state: { tr: tr } } = view;
    view.dispatch(tr.setMeta('presence', presenceData));
};
const $666505553c33095c$export$c6643a6a2625d22c = (remoteData, view, options, editorAnalyticsApi)=>{
    const { json: json, userIds: userIds = [] } = remoteData;
    if (json) $666505553c33095c$export$ff4f2767b9e99aa9(json, view, userIds, options, editorAnalyticsApi);
};
const $666505553c33095c$export$ff4f2767b9e99aa9 = (// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
json, view, userIds, options, editorAnalyticsApi)=>{
    if (!json || !json.length) return;
    const { state: state, state: { schema: schema } } = view;
    const steps = json.map((step)=>(0, $5aU9U.Step).fromJSON(schema, step));
    let tr;
    if (options && options.useNativePlugin && userIds) tr = (0, $7TcbF.receiveTransaction)(state, steps, userIds, {
        mapSelectionBackward: true
    });
    else {
        tr = state.tr;
        steps.forEach((step)=>tr.step(step));
    }
    if (tr) {
        const agentEditRequester = (0, $iDrrr.fg)('platform_editor_agent_be_review_undo') ? (0, $f6a9255fd4845490$export$2f1374fb6d9abffc)(json, view) : null;
        const shouldRecordAgentEditInHistory = agentEditRequester?.isLocalUserRequester === true;
        tr.setMeta('addToHistory', shouldRecordAgentEditInHistory);
        tr.setMeta('isRemote', true);
        // Agent edit shimmer: mark the ranges agent steps just wrote so the plugin reveals them with the
        // skeleton loader, then (optionally) a purple "just edited" highlight. Gated as a whole so no
        // experiment reads run off-experiment; off-path leaves `agentShimmers` empty and everything below
        // is a no-op.
        let shimmerDurationMs = 0;
        let highlightDurationMs = 0;
        let agentShimmers = [];
        let visualJson = json;
        let visualSteps = steps;
        if (options?.useNativePlugin && userIds && (0, $4o0zT.isExperimentEnabled)('platform_editor_agent_be_streaming')) {
            // Read the client ID before applying the acknowledgement, while the local steps
            // are still unconfirmed. receiveTransaction removes this same local prefix.
            // Exclude it from visuals too: the originating FE stream already owns its UI.
            const localClientId = (0, $7TcbF.sendableSteps)(state)?.clientID;
            let acknowledgedSteps = 0;
            if (localClientId != null) while(userIds[acknowledgedSteps] != null && String(userIds[acknowledgedSteps]) === String(localClientId))acknowledgedSteps++;
            // Slice both visual inputs so remote steps stay aligned with tr.docs. The
            // full batch still participates in collaboration, presence and attribution.
            visualJson = json.slice(acknowledgedSteps);
            visualSteps = steps.slice(acknowledgedSteps);
        }
        const isUnifiedPostApplyChromeEnabled = (0, $4o0zT.isExperimentEnabled)('platform_editor_ai_unified_post_apply_chrome');
        if (isUnifiedPostApplyChromeEnabled && (0, $4o0zT.isExperimentEnabled)('platform_editor_agent_be_streaming')) {
            const ranges = (0, $4607a4f054ecad4b$export$e3e1a593a0c5d01c)(visualJson, visualSteps, tr, view, (reason, agentType, error)=>editorAnalyticsApi?.attachAnalyticsEvent((0, $7cf676f4d1e8bc54$export$6f3f7a1f93aa6704)(reason, agentType, error))(tr));
            const requester = (0, $f6a9255fd4845490$export$2f1374fb6d9abffc)(visualJson, view);
            if (ranges.length && requester) {
                // Collab supplies a machine agent type, not a display name; preserve the legacy
                // uppercase telepointer label.
                const telepointerLabel = requester.agentType.trim().toUpperCase();
                tr.setMeta((0, $1UwGp.AGENT_EDIT_CHROME_DATA), {
                    ...(0, $1UwGp.getAgentEditChromeDynamicConfig)(),
                    ...telepointerLabel ? {
                        telepointerLabel: telepointerLabel
                    } : {},
                    ranges: ranges
                });
            }
        }
        if (!isUnifiedPostApplyChromeEnabled && (0, $ieeJu.expValEquals)('platform_editor_agent_be_streaming', 'isEnabled', true)) {
            // The skeleton and purple-highlight phases toggle independently. `shimmerDurationMs` is the
            // skeleton lifetime; `0` skips the skeleton (an edit can still get the purple highlight).
            shimmerDurationMs = (0, $cha5E.expVal)('platform_editor_agent_be_streaming', 'shimmerDurationMs', (0, $2ae884f8c9798406$export$aa0937b45953b3db));
            // `highlightDurationMs` is the purple "just edited" highlight lifetime; `0` skips the highlight
            // (the skeleton still shows). `0` on both shows nothing.
            highlightDurationMs = (0, $cha5E.expVal)('platform_editor_agent_be_streaming', 'highlightDurationMs', (0, $2ae884f8c9798406$export$f8af4b416532a528));
            // Telepointer shown by default; `telepointerDisabled` hides it (inverted because `expVal`
            // only permits `false` as a boolean default).
            const telepointerEnabled = !(0, $cha5E.expVal)('platform_editor_agent_be_streaming', 'telepointerDisabled', false);
            agentShimmers = (0, $4607a4f054ecad4b$export$f64f53873128087b)(visualJson, visualSteps, tr, view, shimmerDurationMs, highlightDurationMs, telepointerEnabled, // An agent edit that applied without the shimmer fires the operational event on the same
            // transaction, so success stays event-free and only degrades are reported.
            (reason, agentType, error)=>editorAnalyticsApi?.attachAnalyticsEvent((0, $7cf676f4d1e8bc54$export$6f3f7a1f93aa6704)(reason, agentType, error))(tr));
            if (agentShimmers.length) tr.setMeta((0, $2ae884f8c9798406$export$e48683d1c200d637), agentShimmers);
        }
        // Record the agent's edit (original + new slice per change) onto this
        // transaction; `editor-plugin-ai` consumes the meta to open the BE Review moment.
        // Gated by the `isBackendReviewMomentEnabled` param on
        // `platform_editor_ai_new_aifc_editor_experience` (mirrors `isFrontendReviewMomentEnabled`).
        // `getAgentEditSegments` self-gates (returns null for non-agent edits, never throws),
        // so this is a no-op for ordinary collaborator edits.
        if ((0, $ieeJu.expValEquals)('platform_editor_ai_new_aifc_editor_experience', 'isBackendReviewMomentEnabled', true)) {
            const reviewData = (0, $512a8a2a05552848$export$72163675ef60f4e3)(json, steps, tr, view);
            if (reviewData) tr.setMeta((0, $jdUP6.AGENT_REMOTE_EDIT_REVIEW_DATA), reviewData);
        }
        /*
		 * Persist marks across transactions. Fixes an issue where
		 * marks are lost if remote transactions are dispatched
		 * between a user creating the mark and typing.
		 */ if (state.tr.storedMarks) tr.setStoredMarks(state.tr.storedMarks);
        view.dispatch(tr);
        // Schedule each shimmer's phase changes. `dispatchMeta` is guarded so a timer firing after
        // teardown is a harmless no-op. Only reached when the gated block above produced ranges, so this
        // whole path is off-experiment-safe.
        if (agentShimmers.length) {
            let tornDownReported = false;
            const dispatchMeta = (metaKey, value)=>{
                try {
                    view.dispatch(view.state.tr.setMeta(metaKey, value));
                } catch  {
                    // View torn down before the timer fired — nothing to clean up. Report once (not once
                    // per shimmer) so we can see how often shimmers are interrupted by teardown.
                    if (!tornDownReported) {
                        tornDownReported = true;
                        editorAnalyticsApi?.fireAnalyticsEvent((0, $7cf676f4d1e8bc54$export$6f3f7a1f93aa6704)('tornDownMidAnimation'));
                    }
                }
            };
            agentShimmers.forEach(({ shimmerId: shimmerId })=>{
                if (shimmerDurationMs > 0) // Skeleton first. When it clears, show the purple highlight (if enabled) then remove;
                // otherwise remove straight away.
                setTimeout(()=>{
                    if (highlightDurationMs > 0) {
                        dispatchMeta((0, $2ae884f8c9798406$export$736faf53f1a48861), shimmerId);
                        setTimeout(()=>{
                            dispatchMeta((0, $2ae884f8c9798406$export$4cd536a39e6c2c4f), shimmerId);
                        }, highlightDurationMs);
                    } else dispatchMeta((0, $2ae884f8c9798406$export$4cd536a39e6c2c4f), shimmerId);
                }, shimmerDurationMs);
                else // Skeleton disabled: the range already starts in the highlight phase, so just time its
                // removal. (Reached only when `highlightDurationMs > 0`, else no ranges were produced.)
                setTimeout(()=>{
                    dispatchMeta((0, $2ae884f8c9798406$export$4cd536a39e6c2c4f), shimmerId);
                }, highlightDurationMs);
            });
        }
    }
};
const $666505553c33095c$export$abfa80d838a68fd6 = (telepointerData, view)=>{
    const { state: { tr: tr } } = view;
    view.dispatch(tr.setMeta('telepointer', telepointerData));
};
function $666505553c33095c$var$isAllSelection(selection) {
    return selection instanceof (0, $kCECX.AllSelection);
}
function $666505553c33095c$var$isNodeSelection(selection) {
    return selection instanceof (0, $kCECX.NodeSelection);
}
const $666505553c33095c$export$b95b91cb8577b1db = (selection)=>{
    /**
	 * <kbd>CMD + A</kbd> triggers a AllSelection
	 * <kbd>escape</kbd> triggers a NodeSelection
	 */ return {
        type: 'textSelection',
        anchor: selection.anchor,
        head: $666505553c33095c$var$isAllSelection(selection) || $666505553c33095c$var$isNodeSelection(selection) ? selection.head - 1 : selection.head
    };
};



const $a38ec21fd2b3cec9$export$8e0e7ffc78696d30 = ({ originalTransaction: originalTransaction, transactions: transactions, oldEditorState: oldEditorState, newEditorState: newEditorState, useNativePlugin: useNativePlugin, viewMode: viewMode, hideTelecursorOnLoad: hideTelecursorOnLoad })=>(provider)=>{
        const docChangedTransaction = transactions.find((tr)=>tr.docChanged);
        const currentPluginState = (0, $2955bb74975a5428$export$18d4026d1ea86bb1).getState(newEditorState);
        const trNoAnalytics = oldEditorState.tr;
        docChangedTransaction?.steps.forEach((step)=>{
            if (!(step instanceof (0, $l5rX3.AnalyticsStep))) trNoAnalytics.step(step);
        });
        if (!currentPluginState?.isReady) return;
        const shouldSendStepForSynchronyCollabProvider = !originalTransaction.getMeta('isRemote') && // TODO: ED-8995 - We need to do this check to reduce the number of race conditions when working with tables.
        // This metadata is coming from the scaleTable command in table-resizing plugin
        !originalTransaction.getMeta('scaleTable') && trNoAnalytics.docChanged;
        if (useNativePlugin || shouldSendStepForSynchronyCollabProvider) provider.send(trNoAnalytics, oldEditorState, newEditorState);
        const prevPluginState = (0, $2955bb74975a5428$export$18d4026d1ea86bb1).getState(oldEditorState);
        const { activeParticipants: prevActiveParticipants } = prevPluginState || {};
        const { activeParticipants: activeParticipants, sessionId: sessionId } = currentPluginState;
        const selectionChanged = !oldEditorState.selection.eq(newEditorState.selection);
        const participantsChanged = prevActiveParticipants && !prevActiveParticipants.eq(activeParticipants);
        if (!sessionId || viewMode !== 'edit') return;
        // uiEvent is standard metdata (docs: https://prosemirror.net/docs/ref/#state.Transaction)
        const isPaste = docChangedTransaction?.getMeta('uiEvent') === 'paste';
        // If this metadata is truthy then it means a selection bookmark might be declared as the meta value OR the transaction
        // doesn't want the tr.selection to be sent to remote users at all.
        const remoteSelectionBookmark = originalTransaction.getMeta('useSelectionBookmarkForRemote');
        if (!!remoteSelectionBookmark) {
            if (remoteSelectionBookmark !== true && 'resolve' in remoteSelectionBookmark) {
                const selection = remoteSelectionBookmark.resolve(newEditorState.doc);
                const message = {
                    type: 'telepointer',
                    selection: (0, $666505553c33095c$export$b95b91cb8577b1db)(selection),
                    sessionId: sessionId
                };
                provider.sendMessage(message);
            }
        } else if (// Broadcast the position if the selection has changed, and the doc hasn't changed (it is mapped
        // by the receiver).
        // If we're pasting content though make an exception (as doc has changed)
        // as on a ranged selection it results in not clearing the ranged selection after the paste
        selectionChanged && (!docChangedTransaction || isPaste) || participantsChanged && !hideTelecursorOnLoad) {
            const selection = (0, $666505553c33095c$export$b95b91cb8577b1db)(newEditorState.selection);
            const message = {
                type: 'telepointer',
                selection: selection,
                sessionId: sessionId
            };
            provider.sendMessage(message);
        }
    };








function $293a9c6514990e26$export$75962d04b28eb982(steps) {
    const filteredSteps = steps.reduce((acc, rebaseable)=>{
        if (!(rebaseable.step instanceof (0, $l5rX3.AnalyticsStep))) acc.push(new (0, $7TcbF.Rebaseable)(rebaseable.step, rebaseable.inverted, rebaseable.origin));
        return acc;
    }, []);
    return filteredSteps;
}


// It is important to get all steps in that package
// Ignored via go/ees005
// eslint-disable-next-line import/no-namespace









var $fdQKX = parcelRequire("fdQKX");


var $kpCD8 = parcelRequire("kpCD8");






var $dOBRD = parcelRequire("dOBRD");





















const $7482f28e0a2bd480$export$a79cdfb4b852386b = new (0, $kCECX.PluginKey)('collabTrackNCSInitializationPlugin');
const $7482f28e0a2bd480$export$ae829ec7b2625219 = ()=>{
    return new (0, $kpCD8.SafePlugin)({
        key: $7482f28e0a2bd480$export$a79cdfb4b852386b,
        state: {
            init () {
                return {
                    collabInitialisedAt: null,
                    firstChangeAfterInitAt: null,
                    firstContentBodyChangeAfterInitAt: null
                };
            },
            apply (transaction, prevPluginState, oldState) {
                if (Boolean(transaction.getMeta('collabInitialised'))) return {
                    collabInitialisedAt: Date.now(),
                    firstChangeAfterInitAt: null,
                    firstContentBodyChangeAfterInitAt: null
                };
                const shouldCheckDocument = prevPluginState.collabInitialisedAt && !prevPluginState.firstContentBodyChangeAfterInitAt;
                if (!shouldCheckDocument) return prevPluginState;
                const isRemote = (0, $c09ce8c88f088fff$export$b8c92cc7dad49da)(transaction, 'isRemote');
                const isDocumentReplaceFromRemote = isRemote && (0, $c09ce8c88f088fff$export$b8c92cc7dad49da)(transaction, 'replaceDocument');
                if (isDocumentReplaceFromRemote) return prevPluginState;
                if ((0, $jbOus.isDirtyTransaction)(transaction)) return prevPluginState;
                if (transaction.docChanged && !transaction.doc.eq(oldState.doc)) {
                    // For analytics purposes, inline comment annotations are not considered as edits to the document body
                    // Transaction may contain other steps, but we know that they won't be user-generated (non synthetic) steps
                    // Additionally, for analytics purposes we do not want to trigger on other participants' changes (i.e. remote changes)
                    const isAnnotationStep = !!transaction.steps.find((step)=>step instanceof (0, $eOaGc.AddMarkStep) && step.mark?.type?.name === 'annotation');
                    return {
                        collabInitialisedAt: prevPluginState.collabInitialisedAt,
                        firstChangeAfterInitAt: Date.now(),
                        firstContentBodyChangeAfterInitAt: isAnnotationStep || isRemote ? prevPluginState.firstContentBodyChangeAfterInitAt : Date.now()
                    };
                }
                return prevPluginState;
            }
        },
        props: {
            attributes (editorState) {
                const trackPluginState = $7482f28e0a2bd480$export$a79cdfb4b852386b.getState(editorState);
                return {
                    ['data-has-collab-initialised']: `${Boolean(trackPluginState?.collabInitialisedAt)}`
                };
            }
        }
    });
};










const $9f98dc1e1d0f84b5$export$1fa2affd5117a057 = new (0, $kCECX.PluginKey)('trackLastRemoteConflict');
const $9f98dc1e1d0f84b5$export$ae829ec7b2625219 = ()=>{
    return new (0, $kpCD8.SafePlugin)({
        key: $9f98dc1e1d0f84b5$export$1fa2affd5117a057,
        state: {
            init () {
                return undefined;
            },
            apply (transaction, prevPluginState) {
                const metadata = transaction.getMeta($9f98dc1e1d0f84b5$export$1fa2affd5117a057);
                if (metadata) return metadata;
                return prevPluginState;
            }
        }
    });
};


// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $98128c88e4bb0942$var$effect = (fn, eq)=>{
    let previousDeps;
    let cleanup;
    return (...currentDeps)=>{
        if (cleanup && eq(previousDeps, currentDeps)) return cleanup;
        cleanup = fn(...currentDeps);
        previousDeps = currentDeps;
        return cleanup;
    };
};
const $98128c88e4bb0942$export$ec068583843480e7 = $98128c88e4bb0942$var$effect((view, provider, options, featureFlags, _providerFactory, editorAnalyticsApi)=>{
    let entityRef;
    const entityHandlers = {
        disconnectedHandler: ()=>{
            (0, $7cf676f4d1e8bc54$export$31cf0e3f119813a1)(view.state, view.state.tr)('disconnected', editorAnalyticsApi);
        },
        errorHandler: ()=>{
            (0, $7cf676f4d1e8bc54$export$31cf0e3f119813a1)(view.state, view.state.tr)('error', editorAnalyticsApi);
        }
    };
    const unsubscribeSynchronyEntity = ()=>{
        if (entityRef) {
            entityRef.off('disconnected', entityHandlers.disconnectedHandler);
            entityRef.off('error', entityHandlers.errorHandler);
        }
    };
    const handlers = {
        initHandler: (data)=>{
            view.dispatch(view.state.tr.setMeta('collabInitialised', true));
            (0, $666505553c33095c$export$a04a448cc866246)(data, view, options, editorAnalyticsApi);
        },
        connectedHandler: (data)=>(0, $666505553c33095c$export$cf9a0dcadb173615)(data, view),
        dataHandler: (data)=>(0, $666505553c33095c$export$c6643a6a2625d22c)(data, view, options, editorAnalyticsApi),
        presenceHandler: (data)=>(0, $666505553c33095c$export$f9db5387b510d6c)(data, view),
        telepointerHandler: (data)=>(0, $666505553c33095c$export$abfa80d838a68fd6)(data, view),
        localStepsHandler: (data)=>{
            const { steps: steps } = data;
            const { state: state } = view;
            const { tr: tr } = state;
            steps.forEach((step)=>tr.step(step));
            view.dispatch(tr);
        },
        errorHandler: (error)=>{
            (0, $7cf676f4d1e8bc54$export$8c408a1f4e12c948)(view.state, view.state.tr, featureFlags, editorAnalyticsApi)(error);
        },
        entityHandler: ({ entity: entity })=>{
            unsubscribeSynchronyEntity();
            if (options.EXPERIMENTAL_allowInternalErrorAnalytics) {
                entity.on('disconnected', entityHandlers.disconnectedHandler);
                entity.on('error', entityHandlers.errorHandler);
                entityRef = entity;
            }
        },
        dataConflictHandler: (data)=>{
            view.dispatch(view.state.tr.setMeta((0, $9f98dc1e1d0f84b5$export$1fa2affd5117a057), data));
        }
    };
    provider.on('init', handlers.initHandler).on('connected', handlers.connectedHandler).on('data', handlers.dataHandler).on('presence', handlers.presenceHandler).on('telepointer', handlers.telepointerHandler).on('local-steps', handlers.localStepsHandler).on('error', handlers.errorHandler).on('entity', handlers.entityHandler).on('data:conflict', handlers.dataConflictHandler);
    return ()=>{
        unsubscribeSynchronyEntity();
        provider.off('init', handlers.initHandler).off('connected', handlers.connectedHandler).off('data', handlers.dataHandler).off('presence', handlers.presenceHandler).off('telepointer', handlers.telepointerHandler).off('local-steps', handlers.localStepsHandler).off('error', handlers.errorHandler).off('entity', handlers.entityHandler).off('data:conflict', handlers.dataConflictHandler);
    };
}, (previousDeps, currentDeps)=>currentDeps && currentDeps.every((dep, i)=>dep === previousDeps[i]));


const $f68e6042357b791f$var$initCollab = (collabEditProvider, view)=>{
    if (collabEditProvider.initialize) collabEditProvider.initialize(()=>view.state, (json)=>(0, $5aU9U.Step).fromJSON(view.state.schema, json));
};
const $f68e6042357b791f$var$initNewCollab = (collabEditProvider, view, editorApi, onSyncUpError)=>{
    collabEditProvider.setup({
        getState: ()=>view.state,
        editorApi: editorApi,
        onSyncUpError: onSyncUpError
    });
};
const $f68e6042357b791f$var$initCollabMemo = (0, $dOBRD.default)($f68e6042357b791f$var$initCollab);
const $f68e6042357b791f$export$2a47f398eeff8b01 = ({ options: options, providerFactory: providerFactory, view: view, featureFlags: featureFlags, editorAnalyticsApi: editorAnalyticsApi, pluginInjectionApi: pluginInjectionApi })=>(provider)=>{
        // eslint-disable-next-line prefer-const
        let cleanup;
        const pluginState = (0, $2955bb74975a5428$export$18d4026d1ea86bb1).getState(view.state);
        if (pluginState?.isReady && cleanup) cleanup();
        cleanup = (0, $98128c88e4bb0942$export$ec068583843480e7)(view, provider, options, featureFlags, providerFactory, editorAnalyticsApi);
        // Initialize provider
        if (options.useNativePlugin) // ED-13912 For NCS we don't want to use memoizeOne because it causes
        // infinite text while changing page-width
        $f68e6042357b791f$var$initNewCollab(provider, view, pluginInjectionApi, options.onSyncUpError);
        else /**
			 * We only want to initialise once, if we reload/reconfigure this plugin
			 * We dont want to re-init collab, it would break existing sessions
			 */ $f68e6042357b791f$var$initCollabMemo(provider, view);
        // Rebind path: if the provider has already initialised (i.e. this view()
        // is running because the editor preset was reconfigured or the EditorView
        // was recreated mid-session, e.g. on a rich-text → markdown-mode flip),
        // the provider's `init` event has already fired and won't fire again.
        // Without intervention the freshly-attached collab plugin view never sees
        // `collabInitialised`, so `filterTransaction` silently drops every
        // doc-changing transaction and the editor appears read-only.
        //
        // PM `state.reconfigure` preserves plugin state by key, so in many cases
        // the plugin state survives and no action is needed; we only seed when
        // state was actually lost (e.g. EditorView recreated from scratch).
        //
        // Gated behind `cc-markdown-mode` (the same experiment that drives the
        // preset rebuild on convert); when off, behaviour is unchanged. Uses
        // `expValEquals` (not `*NoExposure`) so the editor's statsig client
        // enrols the user — otherwise an early rebind can race the FE-side
        // exposure and read the default (false), defeating the gate. The
        // experiment check is last so legacy providers (no `getInitPayload`)
        // short-circuit and don't fire an exposure.
        if (provider.getInitPayload && (0, $ieeJu.expValEquals)('cc-markdown-mode', 'isEnabled', true)) {
            const cachedInit = provider.getInitPayload();
            if (cachedInit) // Defer one microtask so the new pluginView is fully registered
            // before we dispatch (mirrors the timing of a real `init` event).
            Promise.resolve().then(()=>{
                if (view.isDestroyed) return;
                const currentCollabState = (0, $2955bb74975a5428$export$18d4026d1ea86bb1).getState(view.state);
                const currentTrackState = (0, $7482f28e0a2bd480$export$a79cdfb4b852386b).getState(view.state);
                // State was preserved across reconfigure → nothing to do.
                if (currentCollabState?.isReady && currentTrackState?.collabInitialisedAt) return;
                // Seed the freshly-attached pluginView so `isReady` flips to true,
                // `data-has-collab-initialised` becomes "true", and downstream
                // listeners (analytics, sweet-state, track-ncs) re-receive init.
                // Note: we intentionally do NOT replay `handleInit` (which would
                // call `replaceDocument`) — the document is already in the editor
                // and replacing it would clobber any in-flight local steps.
                view.dispatch(view.state.tr.setMeta('collabInitialised', true));
            });
        }
        return cleanup;
    };




var $8dxef = parcelRequire("8dxef");










class $af6e3560ecdbcf4a$export$3ebbcd8e174d58e4 {
    add(data) {
        const newSet = new Map(this.participants);
        data.forEach((participant)=>{
            newSet.set(participant.sessionId, participant);
        });
        return new $af6e3560ecdbcf4a$export$3ebbcd8e174d58e4(newSet);
    }
    remove(sessionIds) {
        const newSet = new Map(this.participants);
        sessionIds.forEach((sessionId)=>{
            newSet.delete(sessionId);
        });
        return new $af6e3560ecdbcf4a$export$3ebbcd8e174d58e4(newSet);
    }
    update(sessionId, lastActive) {
        const newSet = new Map(this.participants);
        const data = newSet.get(sessionId);
        if (!data) return this;
        newSet.set(sessionId, {
            ...data,
            lastActive: lastActive
        });
        return new $af6e3560ecdbcf4a$export$3ebbcd8e174d58e4(newSet);
    }
    updateCursorPos(sessionId, cursorPos) {
        const newSet = new Map(this.participants);
        const data = newSet.get(sessionId);
        if (!data) return this;
        newSet.set(sessionId, {
            ...data,
            cursorPos: cursorPos
        });
        return new $af6e3560ecdbcf4a$export$3ebbcd8e174d58e4(newSet);
    }
    toArray() {
        return Array.from(this.participants.values());
    }
    get(sessionId) {
        return this.participants.get(sessionId);
    }
    size() {
        return this.participants.size;
    }
    eq(other) {
        const left = this.toArray().map((p)=>p.sessionId).sort((a, b)=>a > b ? -1 : 1).join('');
        const right = other.toArray().map((p)=>p.sessionId).sort((a, b)=>a > b ? -1 : 1).join('');
        return left === right;
    }
    constructor(participants = new Map()){
        this.participants = void 0;
        this.participants = participants;
    }
}




const $fe2c13f286900d8a$export$1e860daa85a829a5 = (tr, pos)=>{
    const endOfDocPos = tr.doc.nodeSize - 2;
    if (pos <= endOfDocPos) {
        const resolvedPos = tr.doc.resolve(pos);
        const backwardSelection = (0, $kCECX.Selection).findFrom(resolvedPos, -1, true);
        // if there's no correct cursor position before the `pos`, we try to find it after the `pos`
        const forwardSelection = (0, $kCECX.Selection).findFrom(resolvedPos, 1, true);
        return backwardSelection ? backwardSelection.from : forwardSelection ? forwardSelection.from : pos;
    }
    return endOfDocPos;
};
class $fe2c13f286900d8a$export$d8e4bc17e84598c5 {
    get decorations() {
        return this.decorationSet;
    }
    get activeParticipants() {
        return this.participants;
    }
    get sessionId() {
        return this.sid;
    }
    getFullName(sessionId) {
        const participant = this.participants.get(sessionId);
        return participant ? participant.name : 'X';
    }
    getInitial(sessionId) {
        return this.getFullName(sessionId).substring(0, 1).toUpperCase();
    }
    getPresenceId(sessionId) {
        const participant = this.participants.get(sessionId);
        return participant?.presenceId ?? sessionId;
    }
    apply(tr) {
        // Ignored via go/ees005
        // eslint-disable-next-line prefer-const
        let { participants: participants, sid: sid, isReady: isReady } = this;
        const presenceData = tr.getMeta('presence');
        const telepointerData = tr.getMeta('telepointer');
        const nudgeTelepointerData = tr.getMeta('nudgeTelepointer');
        const agentShimmerData = tr.getMeta((0, $2ae884f8c9798406$export$e48683d1c200d637));
        const removeAgentShimmerId = tr.getMeta((0, $2ae884f8c9798406$export$4cd536a39e6c2c4f));
        const highlightAgentShimmerId = tr.getMeta((0, $2ae884f8c9798406$export$736faf53f1a48861));
        const sessionIdData = tr.getMeta('sessionId');
        let collabInitialised = tr.getMeta('collabInitialised');
        if (typeof collabInitialised !== 'boolean') collabInitialised = isReady;
        if (sessionIdData) sid = sessionIdData.sid;
        let add = [];
        let remove = [];
        if (presenceData) {
            const { joined: joined = [], left: left = [] } = presenceData;
            participants = participants.remove(left.map((i)=>i.sessionId));
            participants = participants.add(joined);
            // Remove telepointers for users that left
            left.forEach((i)=>{
                const pointers = (0, $c09ce8c88f088fff$export$cc7116c03c331d66)(this.getPresenceId(i.sessionId), this.decorationSet);
                if (pointers) remove = remove.concat(pointers);
            });
        }
        if (telepointerData) {
            const { sessionId: sessionId } = telepointerData;
            if (participants.get(sessionId) && sessionId !== sid) {
                const oldPointers = (0, $c09ce8c88f088fff$export$cc7116c03c331d66)(this.getPresenceId(sessionId), this.decorationSet);
                if (oldPointers) remove = remove.concat(oldPointers);
                const endOfDocPos = tr.doc.nodeSize - 2;
                const anchor = telepointerData.selection.anchor;
                const head = telepointerData.selection.head;
                let rawFrom = anchor < head ? anchor : head;
                let rawTo = anchor >= head ? anchor : head;
                if (rawFrom > endOfDocPos) rawFrom = endOfDocPos;
                if (rawTo > endOfDocPos) rawTo = endOfDocPos;
                const isSelection = rawTo - rawFrom > 0;
                let from = 1;
                let to = 1;
                try {
                    from = $fe2c13f286900d8a$export$1e860daa85a829a5(tr, isSelection ? Math.max(rawFrom, 0) : rawFrom);
                    to = isSelection ? $fe2c13f286900d8a$export$1e860daa85a829a5(tr, rawTo) : from;
                } catch (err) {
                    this.onError(err);
                }
                add = add.concat((0, $c09ce8c88f088fff$export$8f868fb36fe42fe8)(from, to, sessionId, isSelection, this.getInitial(sessionId), this.getPresenceId(sessionId), this.getFullName(sessionId), (0, $c09ce8c88f088fff$export$6a7a563833bcd8)(sessionId, this.nudgeAnimations)));
            }
        }
        if (tr.docChanged) // Adjust decoration positions to changes made by the transaction
        try {
            this.decorationSet = this.decorationSet.map(tr.mapping, tr.doc, {
                // Reapplies decorators those got removed by the state change
                onRemove: (spec)=>{
                    if (spec.pointer && spec.pointer.sessionId && spec.key === `telepointer-${spec.pointer.sessionId}`) {
                        const step = tr.steps.filter((0, $c09ce8c88f088fff$export$94600c572c12bcd6))[0];
                        if (step) {
                            const { sessionId: sessionId, presenceId: presenceId } = spec.pointer;
                            const { slice: { content: { size: size } }, from: from } = step;
                            const pos = $fe2c13f286900d8a$export$1e860daa85a829a5(tr, size ? Math.min(from + size, tr.doc.nodeSize - 3) : Math.max(from, 1));
                            add = add.concat((0, $c09ce8c88f088fff$export$8f868fb36fe42fe8)(pos, pos, sessionId, false, this.getInitial(sessionId), presenceId, this.getFullName(sessionId), (0, $c09ce8c88f088fff$export$6a7a563833bcd8)(sessionId, this.nudgeAnimations)));
                        }
                    }
                }
            });
        } catch (err) {
            this.onError(err);
        }
        const { selection: selection } = tr;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.decorationSet.find().forEach((deco)=>{
            // Never let telepointer dim/side logic touch agent-shimmer decorations.
            if (deco.spec?.isAgentShimmer) return;
            if (deco.type.toDOM) {
                const hasTelepointerDimClass = deco.type.toDOM.classList.contains((0, $jbOus.TELEPOINTER_DIM_CLASS));
                const browser = (0, $8dxef.getBrowserInfo)();
                if (deco.from === selection.from && deco.to === selection.to) {
                    if (!hasTelepointerDimClass) deco.type.toDOM.classList.add((0, $jbOus.TELEPOINTER_DIM_CLASS));
                    // Browser condition here to fix ED-14722 where telepointer
                    // decorations with side -1 in Firefox causes backspace issues.
                    // This is likely caused by contenteditable quirks in Firefox
                    if (!browser.gecko) deco.type.side = -1;
                } else {
                    if (hasTelepointerDimClass) deco.type.toDOM.classList.remove((0, $jbOus.TELEPOINTER_DIM_CLASS));
                    deco.type.side = 0;
                }
            }
        });
        if (nudgeTelepointerData) {
            const nudgeSessionId = nudgeTelepointerData?.sessionId;
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            this.decorationSet.find().forEach((deco)=>{
                // Never let telepointer nudge logic touch agent-shimmer decorations.
                if (deco.spec?.isAgentShimmer) return;
                if (deco.type.toDOM && participants.get(nudgeSessionId) && deco.spec?.pointer?.sessionId === nudgeSessionId && deco.spec?.key === `telepointer-${nudgeSessionId}`) {
                    // Restart animation by removing and re-adding the class
                    deco.type.toDOM.classList.remove((0, $jbOus.TELEPOINTER_PULSE_DURING_TR_CLASS));
                    deco.type.toDOM.classList.remove((0, $jbOus.TELEPOINTER_PULSE_CLASS));
                    deco.type.toDOM.offsetWidth; // Force reflow
                    deco.type.toDOM.classList.add((0, $jbOus.TELEPOINTER_PULSE_CLASS));
                    this.nudgeAnimations.set(nudgeSessionId, Date.now());
                }
            });
        }
        // Register / keep-aligned / remove the agent-edit purple highlight
        // decorations. Fully fault-isolated — it works on local copies and only merges into the shared
        // `add`/`remove` (and commits `this.agentShimmers`) after the whole block succeeds, so a fault
        // here can never corrupt telepointer decorations or the shared decoration set. Never mutates
        // shimmer entries in place: each change produces a fresh array of fresh objects.
        try {
            const { changed: changed, next: next } = (0, $2ae884f8c9798406$export$caaa5661d99996f1)(this.agentShimmers, tr, agentShimmerData, removeAgentShimmerId, highlightAgentShimmerId);
            if (changed) {
                // Build into local arrays; only merge into the shared add/remove once the block succeeds.
                const agentRemove = this.decorationSet.find(undefined, undefined, (spec)=>spec.isAgentShimmer);
                const agentAdd = (0, $2ae884f8c9798406$export$6039627ad3fe2215)(tr, next, $fe2c13f286900d8a$export$1e860daa85a829a5, this.onError);
                // Commit only after the whole block succeeded.
                remove = remove.concat(agentRemove);
                add = add.concat(agentAdd);
                this.agentShimmers = next;
            }
        } catch (err) {
            this.onError(err);
            // Degrade to no shimmer without corrupting telepointer decorations: drop all agent
            // decorations and clear agent state, leaving the telepointer `add`/`remove` untouched.
            this.agentShimmers = [];
            try {
                remove = remove.concat(this.decorationSet.find(undefined, undefined, (spec)=>spec.isAgentShimmer));
            } catch  {
            // Teardown must not re-throw.
            }
        }
        if (remove.length) this.decorationSet = this.decorationSet.remove(remove);
        if (add.length) this.decorationSet = this.decorationSet.add(tr.doc, add);
        // This piece needs to be after the decorationSet adjustments,
        // otherwise it's always one step behind where the cursor is
        if (telepointerData) {
            const { sessionId: sessionId } = telepointerData;
            if (participants.get(sessionId)) {
                const positionForScroll = (0, $c09ce8c88f088fff$export$4d66b240d6166074)(sessionId, this.decorationSet);
                if (positionForScroll) participants = participants.updateCursorPos(sessionId, positionForScroll);
            }
        }
        const nextState = new $fe2c13f286900d8a$export$d8e4bc17e84598c5(this.decorationSet, participants, sid, collabInitialised, this.onError, this.nudgeAnimations, this.agentShimmers);
        return $fe2c13f286900d8a$export$d8e4bc17e84598c5.eq(nextState, this) ? this : nextState;
    }
    static eq(a, b) {
        return a.participants === b.participants && a.sessionId === b.sessionId && a.isReady === b.isReady;
    }
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    static init(config) {
        const { doc: doc, onError: onError } = config;
        return new $fe2c13f286900d8a$export$d8e4bc17e84598c5((0, $8nvEM.DecorationSet).create(doc, []), new (0, $af6e3560ecdbcf4a$export$3ebbcd8e174d58e4)(), undefined, undefined, onError);
    }
    constructor(decorations, participants, sessionId, collabInitalised = false, onError, nudgeAnimations = new Map(), agentShimmers = []){
        this.decorationSet = void 0;
        this.participants = void 0;
        this.nudgeAnimations = void 0;
        // Active agent-edit shimmer ranges (pure data). Replaced with a fresh array of fresh
        // objects whenever it changes — never mutated in place.
        this.agentShimmers = void 0;
        // eslint-disable-next-line no-console
        this.onError = (error)=>console.error(error);
        this.sid = void 0;
        this.isReady = void 0;
        this.decorationSet = decorations;
        this.participants = participants;
        this.sid = sessionId;
        this.isReady = collabInitalised;
        this.onError = onError || this.onError;
        this.nudgeAnimations = nudgeAnimations;
        this.agentShimmers = agentShimmers;
    }
}


const $4e5bb196f2fe3a0b$var$enforceCustomStepRegisters = ()=>{
    const tryToRegisterStep = (obj)=>{
        for (const customStep of Object.values(obj)){
            // I know this seems awful
            // But unfortunate ProseMirror does not expose the jsonID property p
            // @ts-expect-error
            const id = customStep?.prototype?.jsonID;
            if (typeof id === 'string') try {
                // We are trying to re-register the steps here
                // in the normal flow, those custom step should be already registred
                // So, it should throw an expeception
                // @ts-expect-error
                (0, $5aU9U.Step).jsonID(id, customStep);
            } catch (e) {
            // This mean the step was already registred.
            // It is ok to ignore this exception.
            }
        }
    };
    // @ts-expect-error
    tryToRegisterStep($aOSDg);
    // @ts-expect-error
    tryToRegisterStep($aqgkf);
};
const $4e5bb196f2fe3a0b$export$ae829ec7b2625219 = (dispatch, providerFactory, providerResolver, collabProviderCallback, options, featureFlags, pluginInjectionApi)=>{
    $4e5bb196f2fe3a0b$var$enforceCustomStepRegisters();
    return new (0, $kpCD8.SafePlugin)({
        key: (0, $2955bb74975a5428$export$18d4026d1ea86bb1),
        state: {
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            init (config) {
                return (0, $fe2c13f286900d8a$export$d8e4bc17e84598c5).init(config);
            },
            apply (transaction, prevPluginState, _oldEditorState, _newEditorState) {
                const pluginState = prevPluginState.apply(transaction);
                dispatch((0, $2955bb74975a5428$export$18d4026d1ea86bb1), pluginState);
                return pluginState;
            }
        },
        props: {
            decorations (state) {
                return (0, $2955bb74975a5428$export$18d4026d1ea86bb1).getState(state)?.decorations;
            },
            handleDOMEvents: {
                click (view, event) {
                    if (!(event.target instanceof HTMLElement)) return false;
                    if (!view.state.selection.empty) return false;
                    const { pos: pos } = view.state.tr.selection.$from;
                    if (!pos) return false;
                    // check if the pos is the same pos as a telepointer decoration
                    const decorations = (0, $2955bb74975a5428$export$18d4026d1ea86bb1).getState(view.state)?.decorations?.find(pos, pos);
                    if (!decorations?.length) return false;
                    // analytics to track telepointer clicks as they sometimes cause broken selections
                    const fireAnalyticsCallback = (0, $fdQKX.fireAnalyticsEvent)(pluginInjectionApi?.analytics?.sharedState.currentState()?.createAnalyticsEvent ?? undefined);
                    fireAnalyticsCallback({
                        payload: {
                            action: (0, $krYZG.ACTION).CLICKED,
                            actionSubject: (0, $krYZG.ACTION_SUBJECT).TELEPOINTER,
                            actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).TELEPOINTER,
                            eventType: (0, $krYZG.EVENT_TYPE).TRACK
                        }
                    });
                }
            }
        },
        filterTransaction (tr, state) {
            const pluginState = (0, $2955bb74975a5428$export$18d4026d1ea86bb1).getState(state);
            const collabInitialiseTr = tr.getMeta('collabInitialised');
            // Don't allow transactions that modifies the document before
            // collab-plugin is ready.
            if (collabInitialiseTr) return true;
            if (!pluginState?.isReady && tr.docChanged) return false;
            return true;
        },
        view (view) {
            const addErrorAnalytics = (0, $7cf676f4d1e8bc54$export$8c408a1f4e12c948)(view.state, view.state.tr, featureFlags, pluginInjectionApi?.analytics?.actions);
            const onSyncUpError = (attributes)=>{
                const fireAnalyticsCallback = (0, $fdQKX.fireAnalyticsEvent)(pluginInjectionApi?.analytics?.sharedState.currentState()?.createAnalyticsEvent ?? undefined);
                fireAnalyticsCallback({
                    payload: {
                        action: (0, $krYZG.ACTION).NEW_COLLAB_SYNC_UP_ERROR_NO_STEPS,
                        actionSubject: (0, $krYZG.ACTION_SUBJECT).EDITOR,
                        eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
                        attributes: attributes
                    }
                });
            };
            options.onSyncUpError = onSyncUpError;
            const cleanup = collabProviderCallback((0, $f68e6042357b791f$export$2a47f398eeff8b01)({
                view: view,
                options: options,
                providerFactory: providerFactory,
                featureFlags: featureFlags,
                pluginInjectionApi: pluginInjectionApi,
                editorAnalyticsApi: pluginInjectionApi?.analytics?.actions
            }), addErrorAnalytics);
            providerFactory && providerFactory.subscribe('collabEditProvider', (_name, providerPromise)=>{
                if (providerPromise) providerPromise.then((provider)=>providerResolver(provider));
            });
            return {
                destroy () {
                    providerFactory.unsubscribeAll('collabEditProvider');
                    if (cleanup) cleanup.then((unsubscribe)=>{
                        if (unsubscribe) unsubscribe();
                    });
                }
            };
        }
    });
};




var $jaFVy = parcelRequire("jaFVy");










const $3f4c2e14e00f350f$var$isLocked = (step)=>{
    if (step.origin instanceof (0, $kCECX.Transaction)) return step.origin.getMeta('mergeIsLocked');
    return false;
};
function $3f4c2e14e00f350f$export$8e3092acded15d5d(steps, api) {
    const mergedSteps = steps.reduce((acc, rebaseable)=>{
        const lastStep = acc[acc.length - 1];
        const isOffline = (0, $jaFVy.isOfflineMode)(api?.connectivity?.sharedState.currentState()?.mode);
        const isOnlineMergeEnabled = (0, $ieeJu.expValEquals)('platform_editor_enable_single_player_step_merging', 'isEnabled', true);
        const isMergingEnabled = isOffline || isOnlineMergeEnabled;
        if (isMergingEnabled && lastStep && !$3f4c2e14e00f350f$var$isLocked(lastStep) && !$3f4c2e14e00f350f$var$isLocked(rebaseable)) {
            const mergedStep = lastStep.step.merge(rebaseable.step);
            const inverted = rebaseable.inverted.merge(lastStep.inverted);
            // Always take the origin of the new step.
            // We use this in packages/editor/collab-provider/src/document/document-service.ts:commitUnconfirmedSteps
            // to confirm that the last transaction has been sent. Since we're taking the latest this still works as expected
            // As we want to wait until all the transactions have been pushed through
            const origin = lastStep.origin;
            if (mergedStep && inverted) {
                acc[acc.length - 1] = new (0, $7TcbF.Rebaseable)(mergedStep, inverted, origin instanceof (0, $kCECX.Transaction) ? origin.setMeta('isOffline', origin.getMeta('isOffline') === true || isOffline) : origin);
                return acc;
            }
        }
        acc.push(new (0, $7TcbF.Rebaseable)(rebaseable.step, rebaseable.inverted, rebaseable.origin instanceof (0, $kCECX.Transaction) ? rebaseable.origin.setMeta('isOffline', rebaseable.origin.getMeta('isOffline') === true || isOffline) : rebaseable.origin));
        return acc;
    }, []);
    return mergedSteps;
}


















const $ce42e57f255e75ac$export$e968e014d3efd8b6 = new (0, $kCECX.PluginKey)('collabTrackLastOrganicChangePlugin');
const $ce42e57f255e75ac$export$ae829ec7b2625219 = ()=>{
    return new (0, $kpCD8.SafePlugin)({
        key: $ce42e57f255e75ac$export$e968e014d3efd8b6,
        state: {
            init () {
                return {
                    lastLocalOrganicChangeAt: null,
                    lastRemoteOrganicChangeAt: null,
                    lastLocalOrganicBodyChangeAt: null,
                    lastRemoteOrganicBodyChangeAt: null
                };
            },
            apply (transaction, prevPluginState) {
                if (Boolean(transaction.getMeta('appendedTransaction'))) return prevPluginState;
                const isRemote = Boolean(transaction.getMeta('isRemote'));
                const isDocumentReplaceFromRemote = isRemote && Boolean(transaction.getMeta('replaceDocument'));
                // Inline comment annotations are not considered as edits to the document body
                const isAnnotationStep = !!transaction.steps.find((step)=>(step instanceof (0, $eOaGc.AddMarkStep) || step instanceof (0, $eOaGc.RemoveMarkStep)) && step.mark?.type?.name === 'annotation');
                if (isDocumentReplaceFromRemote) return prevPluginState;
                if ((0, $jbOus.isDirtyTransaction)(transaction)) return prevPluginState;
                if ((0, $c09ce8c88f088fff$export$227edb0398ff0ff6)(transaction)) {
                    if (isRemote) return {
                        lastLocalOrganicChangeAt: prevPluginState.lastLocalOrganicChangeAt,
                        lastRemoteOrganicChangeAt: Date.now(),
                        lastLocalOrganicBodyChangeAt: prevPluginState.lastLocalOrganicBodyChangeAt,
                        lastRemoteOrganicBodyChangeAt: isAnnotationStep ? prevPluginState.lastRemoteOrganicBodyChangeAt : Date.now()
                    };
                    return {
                        lastLocalOrganicChangeAt: Date.now(),
                        lastRemoteOrganicChangeAt: prevPluginState.lastRemoteOrganicChangeAt,
                        lastLocalOrganicBodyChangeAt: isAnnotationStep ? prevPluginState.lastLocalOrganicBodyChangeAt : Date.now(),
                        lastRemoteOrganicBodyChangeAt: prevPluginState.lastRemoteOrganicBodyChangeAt
                    };
                }
                return prevPluginState;
            }
        }
    });
};


// delete this file when cleaning up platform_editor_remove_collab_step_metrics















// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ var $a362193e7f71cc60$export$d173f08296df529 = /*#__PURE__*/ function(NCS_STORAGE) {
    // remove step metrics keys when cleaning up platform_editor_remove_collab_step_metrics
    NCS_STORAGE["NCS_STORAGE_CLIENT_KEY"] = "ncs-session-step-metrics-storage";
    NCS_STORAGE["NCS_SESSION_STEP_METRICS"] = "ncsSessionStepMetrics";
    NCS_STORAGE["NCS_ACTIVE_SESSIONS"] = "ncsActiveSessions";
    return NCS_STORAGE;
}({});



var $6YrB3 = parcelRequire("6YrB3");

const $289cf17f76da8b8b$var$storageClient = new (0, $6YrB3.StorageClient)((0, $a362193e7f71cc60$export$d173f08296df529).NCS_STORAGE_CLIENT_KEY);
const $289cf17f76da8b8b$export$4fe9abcf7996805c = (metrics, sessionId, steps)=>{
    const current = metrics[sessionId] ?? {
        ncsSessionId: sessionId,
        totalStepSize: 0,
        numberOfSteps: 0,
        maxStepSize: 0,
        stepSizeSumForP90: []
    };
    steps.forEach((step)=>{
        const stepSize = JSON.stringify(step).length;
        current.totalStepSize += stepSize;
        current.numberOfSteps += 1;
        current.maxStepSize = Math.max(current.maxStepSize, stepSize || 0);
        current.stepSizeSumForP90.push(stepSize || 0);
    });
    return current;
};
const $289cf17f76da8b8b$export$bc7fe0d8ce4c3c0a = (sessionId)=>{
    const currentActiveSessions = JSON.parse($289cf17f76da8b8b$var$storageClient.getItem((0, $a362193e7f71cc60$export$d173f08296df529).NCS_ACTIVE_SESSIONS) || '{}');
    if (!currentActiveSessions[sessionId]) $289cf17f76da8b8b$var$storageClient.setItemWithExpiry((0, $a362193e7f71cc60$export$d173f08296df529).NCS_ACTIVE_SESSIONS, JSON.stringify({
        ...currentActiveSessions,
        [sessionId]: true
    }));
};
const $289cf17f76da8b8b$export$defdcaf9cc1c87fe = ({ api: api, steps: steps })=>{
    const sessionId = api?.collabEdit?.sharedState.currentState()?.sessionId;
    if (!sessionId) return;
    const existingMetrics = JSON.parse($289cf17f76da8b8b$var$storageClient.getItem((0, $a362193e7f71cc60$export$d173f08296df529).NCS_SESSION_STEP_METRICS) || '{}');
    const ncsSessionStepMetrics = $289cf17f76da8b8b$export$4fe9abcf7996805c(existingMetrics, sessionId, steps);
    $289cf17f76da8b8b$var$storageClient.setItemWithExpiry((0, $a362193e7f71cc60$export$d173f08296df529).NCS_SESSION_STEP_METRICS, JSON.stringify({
        ...existingMetrics,
        [sessionId]: ncsSessionStepMetrics
    }));
    $289cf17f76da8b8b$export$bc7fe0d8ce4c3c0a(sessionId);
};


function $ea00a46645b09ae6$var$groupBy(array, keyGetter) {
    // Check group by exists, and that it's a function. If so, use the native browser code
    if ('groupBy' in Object && typeof Object.groupBy === 'function') return Object.groupBy(array, keyGetter);
    // Fallback to custom implementation
    const map = {};
    array.forEach((item)=>{
        const key = keyGetter(item);
        if (!map[key]) map[key] = [];
        map[key].push(item);
    });
    return map;
}
const $ea00a46645b09ae6$export$685b976035d234a6 = (step)=>{
    const serializedStep = step.toJSON();
    const sanitizedStep = {
        stepType: serializedStep.stepType
    };
    if (step instanceof (0, $eOaGc.AttrStep) || step instanceof (0, $eOaGc.DocAttrStep)) sanitizedStep.attr = step.attr;
    else if (step instanceof (0, $1A89X.SetAttrsStep)) // Combines all attrs keys separated by _ to one single string
    sanitizedStep.attr = Object.keys(step.attrs).sort().join('_');
    else if (step instanceof (0, $eOaGc.AddMarkStep) || step instanceof (0, $eOaGc.RemoveMarkStep) || step instanceof (0, $eOaGc.RemoveNodeMarkStep) || step instanceof (0, $eOaGc.AddNodeMarkStep)) sanitizedStep.markType = step.mark.type.name;
    else if (step instanceof (0, $hdvEd.BatchAttrsStep)) {
        const batched = step.data.map(({ nodeType: nodeType, attrs: attrs })=>`${nodeType}_${Object.keys(attrs).sort().join('_')}`);
        sanitizedStep.attr = batched.sort().join('_');
    }
    return sanitizedStep;
};
const $ea00a46645b09ae6$export$cb21deee7d469afa = (sanitizedSteps)=>{
    const grouped = $ea00a46645b09ae6$var$groupBy(sanitizedSteps, (e)=>Object.values(e).join('_'));
    return Object.entries(grouped).reduce((acc, [key, value])=>{
        acc[key] = Array.isArray(value) ? value.length : 0;
        return acc;
    }, {});
};
const $ea00a46645b09ae6$export$94e939b87ca64fb4 = (cache, onTrackDataProcessed)=>{
    const stepsMetadata = [];
    for (const entry of cache.values()){
        const { startedAt: startedAt, endedAt: endedAt, steps: steps } = entry;
        const stepTypesAmount = $ea00a46645b09ae6$export$cb21deee7d469afa(steps.map($ea00a46645b09ae6$export$685b976035d234a6));
        stepsMetadata.push({
            startedAt: startedAt,
            endedAt: endedAt,
            stepTypesAmount: stepTypesAmount
        });
    }
    cache.clear();
    if (stepsMetadata.length > 0) onTrackDataProcessed(stepsMetadata);
};
const $ea00a46645b09ae6$var$stepsSentCache = new Map();
// Every ten seconds we will try to process the step data.
const $ea00a46645b09ae6$var$LOW_PRIORITY_DELAY = 10000;
const $ea00a46645b09ae6$var$getScheduler = (// Our TypeScript configuration isn't ready for the Scheduler API https://developer.mozilla.org/en-US/docs/Web/API/Scheduler/ (yet)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
obj)=>{
    if (!obj) return null;
    if ('scheduler' in obj) return obj.scheduler;
    return null;
};
const $ea00a46645b09ae6$export$6b2a7d5132615086 = ({ api: api, newEditorState: newEditorState, transactions: transactions, onTrackDataProcessed: onTrackDataProcessed })=>{
    const newSteps = transactions.flatMap((t)=>t.steps);
    const collabState = (0, $7TcbF.sendableSteps)(newEditorState);
    const scheduler = $ea00a46645b09ae6$var$getScheduler(window);
    if (!newSteps.length || !scheduler || !collabState) return;
    const { version: version } = collabState;
    const buffer = $ea00a46645b09ae6$var$stepsSentCache.get(version);
    const startedAt = buffer?.startedAt || Date.now();
    const endedAt = Date.now();
    const steps = (buffer?.steps || []).concat(newSteps);
    $ea00a46645b09ae6$var$stepsSentCache.set(version, {
        startedAt: startedAt,
        endedAt: endedAt,
        steps: steps
    });
    (0, $289cf17f76da8b8b$export$defdcaf9cc1c87fe)({
        api: api,
        steps: newSteps.filter((step)=>!(step instanceof (0, $l5rX3.AnalyticsStep)))
    });
    scheduler.postTask(()=>{
        $ea00a46645b09ae6$export$94e939b87ca64fb4($ea00a46645b09ae6$var$stepsSentCache, onTrackDataProcessed);
    }, {
        priority: 'background',
        delay: $ea00a46645b09ae6$var$LOW_PRIORITY_DELAY
    });
};


// This is essentially a queue of cached events. When the background task runs to send these items then this queue is flushed.
const $258b55880d613071$var$organicReportingCache = [];
// Every ten seconds we will try to process the step data.
const $258b55880d613071$var$LOW_PRIORITY_DELAY = 10000;
const $258b55880d613071$export$5cff7ac265db316a = (// Our TypeScript configuration isn't ready for the Scheduler API https://developer.mozilla.org/en-US/docs/Web/API/Scheduler/ (yet)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
obj)=>{
    if (!obj) return null;
    if ('scheduler' in obj) return obj.scheduler;
    return null;
};
/**
 * Processes the steps metadata from the cache and calls the callback function with the processed data.
 *
 * @param {OrganicCacheType} cache - A cache containing steps metadata.
 * @param {(data: OrganicMetadataAnalytics[]) => void} onDataProcessed - Callback function to be called with the processed data.
 */ const $258b55880d613071$var$task = (cache, onDataProcessed)=>{
    const data = [];
    for (const item of cache){
        const { steps: steps, ...rest } = item;
        // We'll use the same grouping and sanitize logic from the track-steps util
        const stepTypesAmount = (0, $ea00a46645b09ae6$export$cb21deee7d469afa)(steps.map((0, $ea00a46645b09ae6$export$685b976035d234a6)));
        data.push({
            ...rest,
            stepTypesAmount: stepTypesAmount
        });
    }
    // clear the cache.
    cache.length = 0;
    if (data.length > 0) onDataProcessed(data);
};
const $258b55880d613071$export$41ae48ec4a268424 = ({ newEditorState: newEditorState, oldEditorState: oldEditorState, transactions: transactions, onDataProcessed: onDataProcessed })=>{
    // We can exclude analytic steps since they should never trigger an organic change.
    const newSteps = transactions.flatMap((t)=>t.steps).filter((step)=>!(step instanceof (0, $l5rX3.AnalyticsStep)));
    const scheduler = $258b55880d613071$export$5cff7ac265db316a(window);
    if (!newSteps.length || !scheduler) return;
    // We know that an organic change during startup will trigger a draft sync which will;
    // fire editor edited event ->  confluence/next/packages/editor-features/src/hooks/useDraftSync/useDraftSync.tsx
    // and call triggerUpdate() notifying the BE that user edited the page -> confluence/next/packages/editor-features/src/hooks/useDraftSync/useEditorDraftSyncAction.tsx
    // This can cause a problem with statsig metrics if organic changes are being incorrectly reported, ie an automated change
    // occurs which contributes the user towards editing a page when in fact they didn't edit the page.
    //
    const oldPluginState = (0, $ce42e57f255e75ac$export$e968e014d3efd8b6).getState(oldEditorState);
    const newPluginState = (0, $ce42e57f255e75ac$export$e968e014d3efd8b6).getState(newEditorState);
    if (newSteps.length && oldPluginState?.lastLocalOrganicBodyChangeAt !== newPluginState?.lastLocalOrganicBodyChangeAt) {
        const now = Date.now();
        const isFirstChange = !oldPluginState?.lastLocalOrganicBodyChangeAt;
        // Check if we should compact with the previous entry (within 2 seconds) this means with a possible 10sec delay
        // due to the postTask we could have a potential 5 grouped organic changes listed.
        const shouldCompact = $258b55880d613071$var$organicReportingCache.length > 0 && now - $258b55880d613071$var$organicReportingCache[$258b55880d613071$var$organicReportingCache.length - 1].startedAt < 2000;
        if (shouldCompact) {
            // Compact with previous entry
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            const prev = $258b55880d613071$var$organicReportingCache.pop(); // We know it exists due to shouldCompact check
            // tr.docChanged
            $258b55880d613071$var$organicReportingCache.push({
                transactions: prev.transactions + 1,
                startedAt: prev.startedAt,
                endedAt: now,
                isFirstChange: prev.isFirstChange || isFirstChange,
                steps: prev.steps.concat(newSteps)
            });
        } else // Add new entry
        $258b55880d613071$var$organicReportingCache.push({
            transactions: 1,
            startedAt: now,
            endedAt: now,
            isFirstChange: isFirstChange,
            steps: newSteps
        });
        if ($258b55880d613071$var$organicReportingCache.length === 1) scheduler.postTask(()=>{
            $258b55880d613071$var$task($258b55880d613071$var$organicReportingCache, onDataProcessed);
        }, {
            priority: 'background',
            delay: $258b55880d613071$var$LOW_PRIORITY_DELAY
        });
    }
};








const $847ae5ee06d6088f$var$nativeCollabProviderPluginKey = new (0, $kCECX.PluginKey)('nativeCollabProviderPlugin');
const $847ae5ee06d6088f$export$ad653665b59b3ffd = ({ providerPromise: providerPromise })=>{
    return new (0, $kpCD8.SafePlugin)({
        key: $847ae5ee06d6088f$var$nativeCollabProviderPluginKey,
        state: {
            init: ()=>null,
            apply: (tr, currentPluginState)=>{
                const provider = tr.getMeta($847ae5ee06d6088f$var$nativeCollabProviderPluginKey);
                return provider ? provider : currentPluginState;
            }
        },
        view: (editorView)=>{
            providerPromise.then((provider)=>{
                const { dispatch: dispatch, state: state } = editorView;
                const tr = state.tr;
                tr.setMeta($847ae5ee06d6088f$var$nativeCollabProviderPluginKey, provider);
                dispatch(tr);
            });
            return {};
        }
    });
};
const $847ae5ee06d6088f$export$82feb779db31f396 = (editorState)=>{
    return $847ae5ee06d6088f$var$nativeCollabProviderPluginKey.getState(editorState);
};






var $gT4iv = parcelRequire("gT4iv");


var $73Kv0 = parcelRequire("73Kv0");













const $30d605db108db527$var$THRESHOLD = 50; // 50 milliseconds
const $30d605db108db527$export$2d791416d1075a3b = (step)=>{
    const serializedStep = step.toJSON();
    const sanitizedStep = {
        stepType: serializedStep.stepType,
        stepInstance: 'unknown'
    };
    if (step instanceof (0, $eOaGc.AttrStep)) {
        sanitizedStep.attr = step.attr;
        sanitizedStep.stepInstance = 'AttrStep';
    } else if (step instanceof (0, $eOaGc.DocAttrStep)) {
        sanitizedStep.attr = step.attr;
        sanitizedStep.stepInstance = 'DocAttrStep';
    } else if (step instanceof (0, $1A89X.SetAttrsStep)) {
        // Combines all attrs keys separated by _ to one single string
        sanitizedStep.attr = Object.keys(step.attrs).sort().join('_');
        sanitizedStep.stepInstance = 'SetAttrsStep';
    } else if (step instanceof (0, $eOaGc.AddMarkStep)) {
        sanitizedStep.markType = step.mark.type.name;
        sanitizedStep.stepInstance = 'AddMarkStep';
    } else if (step instanceof (0, $eOaGc.RemoveMarkStep)) {
        sanitizedStep.markType = step.mark.type.name;
        sanitizedStep.stepInstance = 'RemoveMarkStep';
    } else if (step instanceof (0, $eOaGc.RemoveNodeMarkStep)) {
        sanitizedStep.markType = step.mark.type.name;
        sanitizedStep.stepInstance = 'RemoveNodeMarkStep';
    } else if (step instanceof (0, $eOaGc.AddNodeMarkStep)) {
        sanitizedStep.markType = step.mark.type.name;
        sanitizedStep.stepInstance = 'AddNodeMarkStep';
    } else if (step instanceof (0, $eOaGc.ReplaceStep)) sanitizedStep.stepInstance = 'ReplaceStep';
    else if (step instanceof (0, $eOaGc.ReplaceAroundStep)) sanitizedStep.stepInstance = 'ReplaceAroundStep';
    else if (step instanceof (0, $l5rX3.AnalyticsStep)) sanitizedStep.stepInstance = 'AnalyticsStep';
    else if (step instanceof (0, $gT4iv.InsertTypeAheadStep)) sanitizedStep.stepInstance = 'InsertTypeAheadStep';
    else if (step instanceof (0, $73Kv0.LinkMetaStep)) sanitizedStep.stepInstance = 'LinkMetaStep';
    return sanitizedStep;
};
const $30d605db108db527$export$4bff6ad17bbfeba7 = (recentTransactionsTimestamps, trackFilteredTransaction)=>{
    return (tr)=>{
        if (Boolean(tr.getMeta('appendTransaction'))) return true;
        const isRemote = Boolean(tr.getMeta('isRemote'));
        if (isRemote) return true;
        const containsExcludedSteps = tr.steps.some((step)=>{
            return step instanceof (0, $l5rX3.AnalyticsStep) || step instanceof (0, $eOaGc.ReplaceStep) || step instanceof (0, $eOaGc.ReplaceAroundStep) || step instanceof (0, $73Kv0.LinkMetaStep);
        });
        if (containsExcludedSteps) return true;
        if (tr.docChanged && tr.doc.eq(tr.before)) {
            const transactionKey = $30d605db108db527$export$16b712be60324104(tr);
            if (!transactionKey) return true;
            //Clean up tracked transactions when time over threshold
            recentTransactionsTimestamps.forEach((value, key)=>{
                if (tr.time - value.timestamp > $30d605db108db527$var$THRESHOLD) // Delete tracked transaction when over threshold
                recentTransactionsTimestamps.delete(key);
            });
            const lastTransactionEntry = recentTransactionsTimestamps.get(transactionKey);
            if (!lastTransactionEntry) {
                // If no timestamp exists for the given transaction, allow transaction and add an entry
                recentTransactionsTimestamps.set(transactionKey, {
                    timestamp: tr.time,
                    steps: tr.steps
                });
                return true;
            }
            // Track analytics for the filtered transaction
            trackFilteredTransaction(tr);
            // Filter transaction
            return false;
        }
        return true; // Allow the transaction
    };
};
function $30d605db108db527$export$16b712be60324104(tr) {
    const stepPositions = tr.steps.map((step)=>{
        if (step instanceof (0, $eOaGc.RemoveNodeMarkStep) || step instanceof (0, $eOaGc.AddNodeMarkStep) || step instanceof (0, $1A89X.SetAttrsStep) || step instanceof (0, $eOaGc.AttrStep)) {
            if (step.pos !== undefined) return `${step.pos}`;
        } else if (step instanceof (0, $eOaGc.AddMarkStep) || step instanceof (0, $eOaGc.RemoveMarkStep)) return `from_${step.from}_to_${step.to}`;
        else if (step instanceof (0, $gT4iv.InsertTypeAheadStep)) return `insertTypeAheadStep`;
        return '';
    });
    if (stepPositions.some((step)=>Boolean(step))) return stepPositions.join('_');
    return '';
}
const $30d605db108db527$export$ea2d2436326e1247 = new (0, $kCECX.PluginKey)('trackAndFilterSpammingStepsPluginKey');
const $30d605db108db527$export$ae829ec7b2625219 = (trackFilteredTransaction)=>{
    const recentTransactionsTimestamps = new Map();
    return new (0, $kpCD8.SafePlugin)({
        key: $30d605db108db527$export$ea2d2436326e1247,
        filterTransaction: $30d605db108db527$export$4bff6ad17bbfeba7(recentTransactionsTimestamps, trackFilteredTransaction)
    });
};







const $337191a1934f18d7$var$providerBuilder = (collabEditProviderPromise)=>async (codeToExecute, onError)=>{
        try {
            const provider = await collabEditProviderPromise;
            if (provider) return codeToExecute(provider);
        } catch (err) {
            if (onError) onError(err);
            else // eslint-disable-next-line no-console
            console.error(err);
        }
    };
const $337191a1934f18d7$var$createAddInlineCommentMark = (providerPromise)=>({ from: from, to: to, mark: mark })=>{
        providerPromise.then((provider)=>{
            const commentMark = new (0, $eOaGc.AddMarkStep)(Math.min(from, to), Math.max(from, to), mark);
            // @ts-expect-error 2339: Property 'api' does not exist on type 'CollabEditProvider<CollabEvents>'.
            provider.api?.addComment([
                commentMark
            ]);
        });
        return false;
    };
const $337191a1934f18d7$var$createAddInlineCommentNodeMark = (providerPromise)=>({ pos: pos, mark: mark })=>{
        providerPromise.then((provider)=>{
            const commentMark = new (0, $eOaGc.AddNodeMarkStep)(pos, mark);
            // @ts-expect-error 2339: Property 'api' does not exist on type 'CollabEditProvider<CollabEvents>'.
            provider.api?.addComment([
                commentMark
            ]);
        });
        return false;
    };
const $337191a1934f18d7$export$7b59344e4e475116 = ({ config: options, api: api })=>{
    const featureFlags = api?.featureFlags?.sharedState.currentState() || {};
    let providerResolver = ()=>{};
    const editorViewRef = {
        current: null
    };
    const collabEditProviderPromise = new Promise((_providerResolver)=>{
        providerResolver = _providerResolver;
    });
    const executeProviderCode = $337191a1934f18d7$var$providerBuilder(collabEditProviderPromise);
    return {
        name: 'collabEdit',
        getSharedState (state) {
            if (!state) return {
                initialised: {
                    collabInitialisedAt: null,
                    firstChangeAfterInitAt: null,
                    firstContentBodyChangeAfterInitAt: null,
                    lastLocalOrganicChangeAt: null,
                    lastRemoteOrganicChangeAt: null,
                    lastLocalOrganicBodyChangeAt: null,
                    lastRemoteOrganicBodyChangeAt: null
                },
                activeParticipants: undefined,
                sessionId: undefined,
                lastReconnectionConflictMetadata: undefined
            };
            const collabPluginState = (0, $2955bb74975a5428$export$18d4026d1ea86bb1).getState(state);
            const metadata = (0, $7482f28e0a2bd480$export$a79cdfb4b852386b).getState(state);
            const lastOrganicChangeState = (0, $ce42e57f255e75ac$export$e968e014d3efd8b6).getState(state);
            const lastRemoteConflict = (0, $9f98dc1e1d0f84b5$export$1fa2affd5117a057).getState(state);
            return {
                activeParticipants: collabPluginState?.activeParticipants,
                sessionId: collabPluginState?.sessionId,
                initialised: {
                    collabInitialisedAt: metadata?.collabInitialisedAt || null,
                    firstChangeAfterInitAt: metadata?.firstChangeAfterInitAt || null,
                    firstContentBodyChangeAfterInitAt: metadata?.firstContentBodyChangeAfterInitAt || null,
                    lastLocalOrganicChangeAt: lastOrganicChangeState?.lastLocalOrganicChangeAt || null,
                    lastRemoteOrganicChangeAt: lastOrganicChangeState?.lastRemoteOrganicChangeAt || null,
                    lastLocalOrganicBodyChangeAt: lastOrganicChangeState?.lastLocalOrganicBodyChangeAt || null,
                    lastRemoteOrganicBodyChangeAt: lastOrganicChangeState?.lastRemoteOrganicBodyChangeAt || null
                },
                lastReconnectionConflictMetadata: lastRemoteConflict
            };
        },
        actions: {
            getAvatarColor: $c09ce8c88f088fff$export$90c6ee000c44ff4a,
            addInlineCommentMark: $337191a1934f18d7$var$createAddInlineCommentMark(collabEditProviderPromise),
            addInlineCommentNodeMark: $337191a1934f18d7$var$createAddInlineCommentNodeMark(collabEditProviderPromise),
            isRemoteReplaceDocumentTransaction: (tr)=>tr.getMeta('isRemote') && tr.getMeta('replaceDocument'),
            getCurrentCollabState: ()=>{
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                const adfDocument = new (0, $2lPWP.JSONTransformer)().encode(editorViewRef.current.state.doc);
                return {
                    content: adfDocument,
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    version: (0, $7TcbF.getCollabState)(editorViewRef.current.state)?.version || 0,
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    sendableSteps: (0, $7TcbF.sendableSteps)(editorViewRef.current.state)
                };
            },
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            validatePMJSONDocument: (doc)=>{
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                const content = (doc.content || []).map((child)=>// Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    editorViewRef.current.state.schema.nodeFromJSON(child));
                return content.every((node)=>{
                    try {
                        node.check(); // this will throw an error if the node is invalid
                    } catch  {
                        return false;
                    }
                    return true;
                });
            }
        },
        pmPlugins () {
            const { useNativePlugin: useNativePlugin = false, userId: userId = null } = options || {};
            const transformUnconfirmed = (steps)=>{
                const transformed = (0, $293a9c6514990e26$export$75962d04b28eb982)(steps);
                if ((0, $jkcNT.editorExperiment)('platform_editor_offline_editing_web', true) || (0, $ieeJu.expValEquals)('platform_editor_enable_single_player_step_merging', 'isEnabled', true)) return (0, $3f4c2e14e00f350f$export$8e3092acded15d5d)(transformed, api);
                return transformed;
            };
            const plugins = [
                ...useNativePlugin ? [
                    {
                        name: 'pmCollab',
                        plugin: ()=>(0, $7TcbF.collab)({
                                clientID: userId,
                                transformUnconfirmed: transformUnconfirmed
                            })
                    },
                    {
                        name: 'nativeCollabProviderPlugin',
                        plugin: ()=>(0, $847ae5ee06d6088f$export$ad653665b59b3ffd)({
                                providerPromise: collabEditProviderPromise
                            })
                    }
                ] : [],
                {
                    name: 'collab',
                    plugin: ({ dispatch: dispatch, providerFactory: providerFactory })=>{
                        return (0, $4e5bb196f2fe3a0b$export$ae829ec7b2625219)(dispatch, providerFactory, providerResolver, executeProviderCode, options, featureFlags, api);
                    }
                },
                {
                    name: 'collabTrackNCSInitializationPlugin',
                    plugin: (0, $7482f28e0a2bd480$export$ae829ec7b2625219)
                }
            ];
            plugins.push({
                name: 'trackAndFilterSpammingSteps',
                plugin: ()=>(0, $30d605db108db527$export$ae829ec7b2625219)((tr)=>{
                        const sanitizedSteps = tr.steps.map((step)=>(0, $30d605db108db527$export$2d791416d1075a3b)(step));
                        api?.analytics?.actions?.fireAnalyticsEvent({
                            action: (0, $krYZG.ACTION).STEPS_FILTERED,
                            actionSubject: (0, $krYZG.ACTION_SUBJECT).COLLAB,
                            attributes: {
                                steps: sanitizedSteps
                            },
                            eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL
                        });
                    })
            });
            plugins.push({
                name: 'collabTrackLastOrganicChangePlugin',
                plugin: (0, $ce42e57f255e75ac$export$ae829ec7b2625219)
            });
            if ((0, $jkcNT.editorExperiment)('platform_editor_offline_editing_web', true)) plugins.push({
                name: 'trackLastRemoteConflictPlugin',
                plugin: (0, $9f98dc1e1d0f84b5$export$ae829ec7b2625219)
            });
            return plugins;
        },
        onEditorViewStateUpdated (props) {
            const addErrorAnalytics = (0, $7cf676f4d1e8bc54$export$8c408a1f4e12c948)(props.newEditorState, props.newEditorState.tr, featureFlags, api?.analytics?.actions);
            const isEmptyDoc = (0, $iLrhi.isEmptyDocument)(props.newEditorState.doc);
            const viewMode = api?.editorViewMode?.sharedState.currentState()?.mode;
            executeProviderCode((0, $a38ec21fd2b3cec9$export$8e0e7ffc78696d30)({
                originalTransaction: props.originalTransaction,
                transactions: props.transactions,
                oldEditorState: props.oldEditorState,
                newEditorState: props.newEditorState,
                useNativePlugin: options.useNativePlugin ?? false,
                hideTelecursorOnLoad: !isEmptyDoc && (options.hideTelecursorOnLoad ?? false),
                viewMode: viewMode
            }), addErrorAnalytics);
            if (!(0, $ieeJu.expValEquals)('platform_editor_remove_collab_step_metrics', 'isEnabled', true)) (0, $ea00a46645b09ae6$export$6b2a7d5132615086)({
                api: api,
                ...props,
                onTrackDataProcessed: (steps)=>{
                    api?.analytics?.actions?.fireAnalyticsEvent({
                        action: (0, $krYZG.ACTION).STEPS_TRACKED,
                        actionSubject: (0, $krYZG.ACTION_SUBJECT).COLLAB,
                        attributes: {
                            steps: steps
                        },
                        eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL
                    });
                }
            });
            if ((0, $iDrrr.fg)('platform_editor_collab_organic_change_reporting')) (0, $258b55880d613071$export$41ae48ec4a268424)({
                api: api,
                ...props,
                onDataProcessed: (data)=>{
                    api?.analytics?.actions?.fireAnalyticsEvent({
                        action: (0, $krYZG.ACTION).ORGANIC_CHANGES_TRACKED,
                        actionSubject: (0, $krYZG.ACTION_SUBJECT).COLLAB,
                        attributes: {
                            organicChanges: data
                        },
                        eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL
                    });
                }
            });
        },
        commands: {
            nudgeTelepointer: (sessionId)=>({ tr: tr })=>{
                    tr.setMeta('nudgeTelepointer', {
                        sessionId: sessionId
                    });
                    return tr;
                }
        }
    };
};
module.exports["collabEditPlugin"] = $337191a1934f18d7$export$7b59344e4e475116;

});

parcelRegister("fxjEF", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");

parcelRequire("cozmU");


var $5Z7gB = parcelRequire("5Z7gB");


var $c0Rae = parcelRequire("c0Rae");


var $3k5Tv = parcelRequire("3k5Tv");


var $5I78X = parcelRequire("5I78X");


var $4o0zT = parcelRequire("4o0zT");


var $ieeJu = parcelRequire("ieeJu");

const $38d1d0a193cd4295$export$809659ed37baae65 = (syncBlockStore)=>{
    return syncBlockStore.sourceManager.flush();
};
const $38d1d0a193cd4295$export$42389f194734952a = (syncBlockStore)=>{
    return syncBlockStore.referenceManager.flush();
};
const $38d1d0a193cd4295$export$e79742b5511b2d66 = (syncBlockStore)=>{
    return syncBlockStore.sourceManager.discardUnpublishedBlocks();
};



var $4XbfY = parcelRequire("4XbfY");


var $krYZG = parcelRequire("krYZG");


var $1TzXg = parcelRequire("1TzXg");


var $aPdNQ = parcelRequire("aPdNQ");


var $kCECX = parcelRequire("kCECX");


var $bjg0G = parcelRequire("bjg0G");


var $d04Ge = parcelRequire("d04Ge");


var $iDrrr = parcelRequire("iDrrr");


var $anBbz = parcelRequire("anBbz");





var $jbOus = parcelRequire("jbOus");


var $kpCD8 = parcelRequire("kpCD8");


var $lp7sw = parcelRequire("lp7sw");


var $95bQO = parcelRequire("95bQO");


var $fud2r = parcelRequire("fud2r");

var $2w79Z = parcelRequire("2w79Z");


var $jaFVy = parcelRequire("jaFVy");





var $eOaGc = parcelRequire("eOaGc");


var $8nvEM = parcelRequire("8nvEM");














var $cozmU = parcelRequire("cozmU");





var $h75sz = parcelRequire("h75sz");













const $65eb1a6a9f5a9fc0$export$214d9e923056baaa = ({ sourceAri: sourceAri, sourceProduct: sourceProduct })=>{
    if (sourceProduct === 'jira-work-item' || sourceAri?.startsWith('ari:cloud:jira:')) return 'jiraWorkItem';
    if (sourceAri?.includes(':blogpost/')) return 'blog';
    return 'page';
};


/* SyncBlockLabel.tsx generated by @compiled/babel-plugin v3.0.1 */ 






var $kSwu1 = parcelRequire("kSwu1");


var $aI2Eh = parcelRequire("aI2Eh");





var $3rarE = parcelRequire("3rarE");


var $iMnC5 = parcelRequire("iMnC5");

var $4aRua = parcelRequire("4aRua");





var $lpNn5 = parcelRequire("lpNn5");


var $9GVkD = parcelRequire("9GVkD");


var $15IyG = parcelRequire("15IyG");

const $034823299c32b512$var$SECONDS_IN_MINUTE = 60;
const $034823299c32b512$var$SECONDS_IN_HOUR = $034823299c32b512$var$SECONDS_IN_MINUTE * 60;
const $034823299c32b512$var$SECONDS_IN_DAY = $034823299c32b512$var$SECONDS_IN_HOUR * 24;
const $034823299c32b512$var$SECONDS_IN_WEEK = $034823299c32b512$var$SECONDS_IN_DAY * 7;
const $034823299c32b512$var$SECONDS_IN_MONTH = $034823299c32b512$var$SECONDS_IN_DAY * 30;
const $034823299c32b512$var$SECONDS_IN_YEAR = $034823299c32b512$var$SECONDS_IN_DAY * 365;
const $034823299c32b512$export$49475f5c6fb1131c = (isoDate, intl)=>{
    const now = Date.now();
    const date = new Date(isoDate).getTime();
    const diffInSeconds = Math.floor((now - date) / 1000);
    const dateObj = new Date(isoDate);
    // Show "yesterday" when timestamp is from the previous calendar day
    if ((0, $15IyG.default)(dateObj) && diffInSeconds >= $034823299c32b512$var$SECONDS_IN_DAY) return intl.formatRelativeTime(-1, 'day', {
        numeric: 'auto',
        style: 'long'
    });
    if (diffInSeconds < $034823299c32b512$var$SECONDS_IN_MINUTE) return intl.formatRelativeTime(-Math.max(diffInSeconds, 1), 'second', {
        style: 'long'
    });
    else if (diffInSeconds < $034823299c32b512$var$SECONDS_IN_HOUR) {
        const minutes = Math.floor(diffInSeconds / $034823299c32b512$var$SECONDS_IN_MINUTE);
        return intl.formatRelativeTime(-minutes, 'minute', {
            style: 'long'
        });
    } else if (diffInSeconds < $034823299c32b512$var$SECONDS_IN_DAY) {
        const hours = Math.floor(diffInSeconds / $034823299c32b512$var$SECONDS_IN_HOUR);
        return intl.formatRelativeTime(-hours, 'hour', {
            style: 'long'
        });
    } else if (diffInSeconds < $034823299c32b512$var$SECONDS_IN_WEEK) {
        const days = Math.floor(diffInSeconds / $034823299c32b512$var$SECONDS_IN_DAY);
        return intl.formatRelativeTime(-days, 'day', {
            style: 'long'
        });
    } else if (diffInSeconds < $034823299c32b512$var$SECONDS_IN_MONTH) {
        const weeks = Math.floor(diffInSeconds / $034823299c32b512$var$SECONDS_IN_WEEK);
        return intl.formatRelativeTime(-weeks, 'week', {
            style: 'long'
        });
    } else if (diffInSeconds < $034823299c32b512$var$SECONDS_IN_YEAR) {
        const months = Math.floor(diffInSeconds / $034823299c32b512$var$SECONDS_IN_MONTH);
        return intl.formatRelativeTime(-months, 'month', {
            style: 'long'
        });
    } else {
        const years = Math.floor(diffInSeconds / $034823299c32b512$var$SECONDS_IN_YEAR);
        return intl.formatRelativeTime(-years, 'year', {
            style: 'long'
        });
    }
};


const $74d9a790701b865f$var$SyncBlockLabelDataId = 'sync-block-label';
const $74d9a790701b865f$var$styles = {
    truncatedLabelText: "_2sNsIg7NXe _4bt5LAnQyn _2WAcuGnQyn _1UtDYzZpcK _4ouGXIdnbC _39HuIbz8Lp _1ANEUSLRg7",
    unpublishedSuffix: "_2sNsIg7NXe _1UtDYzZpcK _3YEZNOdnbC _1ANEUSLRg7"
};
const $74d9a790701b865f$var$SyncBlockLabelComponent = ({ contentUpdatedAt: contentUpdatedAt, isSource: isSource, localId: localId, title: title, isUnsyncedBlock: isUnsyncedBlock, unpublishedInfo: unpublishedInfo })=>{
    const intl = (0, $kSwu1.useIntl)();
    const { formatMessage: formatMessage } = intl;
    const [tooltipContent, setTooltipContent] = (0, $cozmU.useState)(formatMessage((0, $aI2Eh.syncBlockMessages).defaultSyncBlockTooltip));
    let tooltipMessage = formatMessage((0, $aI2Eh.syncBlockMessages).defaultSyncBlockTooltip);
    if (title) tooltipMessage = formatMessage((0, $aI2Eh.syncBlockMessages).referenceSyncBlockTooltip, {
        title: title
    });
    const updateTooltipContent = (0, $cozmU.useCallback)(()=>{
        let tooltipContent = tooltipMessage;
        if (contentUpdatedAt) {
            const elapsedTime = (0, $034823299c32b512$export$49475f5c6fb1131c)(contentUpdatedAt, intl);
            tooltipContent = /*#__PURE__*/ (0, $8aG6j.jsxs)("div", {
                children: [
                    title ? /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $8aG6j.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                                size: "small",
                                color: "color.text.inverse",
                                weight: "bold",
                                children: formatMessage((0, $aI2Eh.syncBlockMessages).referenceSyncBlockSyncedFrom)
                            }),
                            /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $4aRua.Text), {
                                size: "small",
                                color: "color.text.inverse",
                                children: [
                                    ' ',
                                    title
                                ]
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                        size: "small",
                        color: "color.text.inverse",
                        children: tooltipMessage
                    }),
                    /*#__PURE__*/ (0, $8aG6j.jsx)("br", {}),
                    /*#__PURE__*/ (0, $8aG6j.jsx)("br", {}),
                    /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                        size: "small",
                        color: "color.text.inverse",
                        weight: "bold",
                        children: formatMessage((0, $aI2Eh.syncBlockMessages).referenceSyncBlockLastEdited)
                    }),
                    /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $4aRua.Text), {
                        size: "small",
                        color: "color.text.inverse",
                        children: [
                            ' ',
                            elapsedTime
                        ]
                    })
                ]
            });
        }
        setTooltipContent(tooltipContent);
    }, [
        contentUpdatedAt,
        formatMessage,
        intl,
        title,
        tooltipMessage
    ]);
    const ariaDescribedById = `sync-block-label-description-${localId}`;
    const unpublishedParenthetical = unpublishedInfo ? formatMessage((0, $aI2Eh.syncBlockMessages).unpublishedInParentheses) : undefined;
    const getLabelContent = (0, $cozmU.useMemo)(()=>{
        // The parenthetical carries a leading space so the accessible name and copied text read as
        // "… (unpublished)". Flex trims it visually, and the label's own gap provides the spacing.
        const renderUnpublishedLabel = (label)=>/*#__PURE__*/ (0, $8aG6j.jsxs)((0, $8aG6j.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                        as: "span",
                        xcss: $74d9a790701b865f$var$styles.truncatedLabelText,
                        children: label
                    }),
                    /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                        as: "span",
                        xcss: $74d9a790701b865f$var$styles.unpublishedSuffix,
                        children: ` ${unpublishedParenthetical}`
                    })
                ]
            });
        const renderPlainLabel = (label)=>unpublishedParenthetical ? renderUnpublishedLabel(label) : /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                size: "small",
                color: "color.text.subtle",
                children: label
            });
        const renderTruncatingTitle = (label)=>unpublishedParenthetical ? renderUnpublishedLabel(label) : /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                maxLines: 1,
                size: "small",
                color: "color.text.subtle",
                children: label
            });
        if (isUnsyncedBlock) return renderPlainLabel(formatMessage((0, $aI2Eh.syncBlockMessages).unsyncedBlockLabel));
        if (isSource) return renderPlainLabel(formatMessage((0, $ieeJu.expValEquals)('platform_editor_sync_block_activation', 'isEnabled', true) ? (0, $aI2Eh.syncBlockMessages).sourceSyncedBlockLabel : (0, $aI2Eh.syncBlockMessages).syncedBlockLabel));
        if (!title) return renderPlainLabel(formatMessage((0, $aI2Eh.syncBlockMessages).syncedBlockLabel));
        return renderTruncatingTitle(title);
    }, [
        formatMessage,
        isSource,
        isUnsyncedBlock,
        title,
        unpublishedParenthetical
    ]);
    const unpublishedTooltipLabel = unpublishedInfo ? formatMessage(unpublishedInfo.variant === 'source' ? (0, $aI2Eh.syncBlockMessages).unpublishedSourceAvailabilityTooltip : (0, $aI2Eh.syncBlockMessages).unpublishedLocalReferenceAvailabilityTooltip, {
        sourceType: unpublishedInfo.sourceType
    }) : undefined;
    const primaryLabel = /*#__PURE__*/ (0, $8aG6j.jsxs)("div", {
        "data-testid": $74d9a790701b865f$var$SyncBlockLabelDataId,
        className: (0, $95bQO.SyncBlockLabelSharedCssClassName).labelClassName,
        "aria-describedby": isSource || isUnsyncedBlock ? undefined : ariaDescribedById,
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3rarE))), {
                color: "var(--ds-icon-subtle, #505258)",
                size: "small",
                label: ""
            }),
            getLabelContent
        ]
    });
    const referenceDescription = !isSource && !isUnsyncedBlock && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9GVkD.default), {
        id: ariaDescribedById,
        children: (0, $ieeJu.expValEquals)('platform_editor_sync_block_activation', 'isEnabled', true) ? tooltipMessage : tooltipContent
    });
    if (unpublishedTooltipLabel) return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $lpNn5.default), {
        position: "top",
        content: unpublishedTooltipLabel,
        children: [
            primaryLabel,
            referenceDescription
        ]
    });
    if (isSource || isUnsyncedBlock) return primaryLabel;
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $lpNn5.default), {
        position: "top",
        content: tooltipContent,
        // this causes an infinite rerender loop because of the forwardRef from the node view we are inside in bodiedSyncBlock
        // tooltip content is available for screen readers in visually hidden content after the label
        isScreenReaderAnnouncementDisabled: true,
        onShow: updateTooltipContent,
        children: [
            primaryLabel,
            referenceDescription
        ]
    });
};
const $74d9a790701b865f$export$af6d83e4f9d69ba5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).memo($74d9a790701b865f$var$SyncBlockLabelComponent);


const $88b0b05de75c97b3$export$9eec9bbd6569d309 = (node)=>{
    if (node.childCount !== 1) return false;
    const firstChild = node.firstChild;
    return firstChild?.type.name === 'paragraph' && firstChild.content.size === 0;
};


const $d6e50e685ac89fcf$var$toDOM = (node)=>[
        'div',
        {
            class: `${(0, $95bQO.BodiedSyncBlockSharedCssClassName).prefix} bodiedSyncBlockView-content-wrap`,
            localid: node.attrs.localId,
            resourceid: node.attrs.resourceId
        },
        [
            'div',
            {
                class: (0, $95bQO.BodiedSyncBlockSharedCssClassName).content,
                contenteditable: 'true'
            },
            0
        ]
    ];
const $d6e50e685ac89fcf$export$520fa575be2f7d06 = ({ localId: localId, resourceId: resourceId, sourceManager: sourceManager })=>{
    const isSamePageSyncEnabled = (0, $4o0zT.isExperimentEnabled)('editor-synced-block-same-page-sync');
    const [isUnpublished, setIsUnpublished] = (0, $cozmU.useState)(()=>isSamePageSyncEnabled && sourceManager?.getLocalSourceSnapshot(resourceId)?.status === 'unpublished');
    const [sourceInfo, setSourceInfo] = (0, $cozmU.useState)();
    (0, $cozmU.useEffect)(()=>{
        if (!isSamePageSyncEnabled) return;
        let isMounted = true;
        sourceManager?.getSyncBlockSourceInfo(localId).then((nextSourceInfo)=>{
            if (isMounted) setSourceInfo(nextSourceInfo);
        });
        const unsubscribe = sourceManager?.subscribeToLocalSource(resourceId, (snapshot)=>setIsUnpublished(snapshot?.status === 'unpublished'));
        return ()=>{
            isMounted = false;
            unsubscribe?.();
        };
    }, [
        isSamePageSyncEnabled,
        localId,
        resourceId,
        sourceManager
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $74d9a790701b865f$export$af6d83e4f9d69ba5), {
        isSource: true,
        localId: localId,
        unpublishedInfo: isSamePageSyncEnabled && isUnpublished ? {
            sourceType: (0, $65eb1a6a9f5a9fc0$export$214d9e923056baaa)({
                sourceAri: sourceInfo?.sourceAri,
                sourceProduct: sourceInfo?.productType
            }),
            variant: 'source'
        } : undefined
    });
};
class $d6e50e685ac89fcf$export$e287a7d211075664 {
    updateContentEditable({ nextConnectivityMode: nextConnectivityMode, nextViewMode: nextViewMode }) {
        const connectivityMode = nextConnectivityMode ?? this.api?.connectivity?.sharedState?.currentState()?.mode;
        const viewMode = nextViewMode ?? this.api?.editorViewMode?.sharedState?.currentState()?.mode;
        const isOnline = !(0, $jaFVy.isOfflineMode)(connectivityMode);
        const isEditMode = viewMode !== 'view';
        const shouldBeEditable = isOnline && isEditMode;
        this.contentDOM.setAttribute('contenteditable', shouldBeEditable ? 'true' : 'false');
    }
    handleConnectivityModeChange() {
        if (this.api?.connectivity) this.cleanupConnectivityModeListener = this.api.connectivity.sharedState.onChange(({ nextSharedState: nextSharedState })=>{
            this.updateContentEditable({
                nextConnectivityMode: nextSharedState.mode
            });
        });
    }
    handleViewModeChange() {
        if (this.api?.editorViewMode) this.cleanupViewModeListener = this.api.editorViewMode.sharedState.onChange(({ nextSharedState: nextSharedState })=>{
            this.updateContentEditable({
                nextViewMode: nextSharedState?.mode
            });
        });
    }
    /**
   * Marks the block as empty so the source placeholder can be shown purely from document state.
   * See `isEmptySourceSyncBlock` for why the DOM is not used to decide this.
   */ updateEmptyClass() {
        this.dom.classList.toggle((0, $95bQO.BodiedSyncBlockSharedCssClassName).empty, (0, $88b0b05de75c97b3$export$9eec9bbd6569d309)(this.node));
    }
    update(node) {
        if (this.node.type !== node.type) return false;
        // Cache updates are handled in appendTransaction where we can
        // filter out non-user changes (remote collab, table auto-scale, etc.)
        this.node = node;
        this.updateEmptyClass();
        return true;
    }
    ignoreMutation(mutation) {
        if (mutation.type === 'selection') return false;
        return true;
    }
    destroy() {
        this.cleanupConnectivityModeListener?.();
        this.cleanupViewModeListener?.();
        this.nodeViewPortalProviderAPI.remove(this.labelKey);
    }
    constructor(node, view, getPos, api, nodeViewPortalProviderAPI, sourceManager){
        this.dom = void 0;
        this.contentDOM = void 0;
        this.node = void 0;
        this.view = void 0;
        this.getPos = void 0;
        this.nodeViewPortalProviderAPI = void 0;
        this.api = void 0;
        this.cleanupConnectivityModeListener = void 0;
        this.cleanupViewModeListener = void 0;
        this.labelKey = void 0;
        this.node = node;
        this.view = view;
        this.getPos = getPos;
        this.api = api;
        this.nodeViewPortalProviderAPI = nodeViewPortalProviderAPI;
        // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage -- NodeView serialization must target active runtime document
        const { dom: dom, contentDOM: contentDOM } = (0, $aPdNQ.DOMSerializer).renderSpec(document, $d6e50e685ac89fcf$var$toDOM(this.node));
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        this.dom = dom;
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        this.contentDOM = contentDOM;
        // Render the label into a separate container so portal implementations that
        // write directly into the target do not clobber contentDOM. This also covers
        // SSR, where the portal's renderToStaticMarkup + innerHTML would clobber it.
        // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage -- NodeView DOM must be created against active runtime document
        const labelContainer = document.createElement('div');
        this.dom.appendChild(labelContainer);
        this.labelKey = crypto.randomUUID();
        this.nodeViewPortalProviderAPI.render(()=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $h75sz.ErrorBoundary), {
                component: (0, $krYZG.ACTION_SUBJECT).SYNCED_BLOCK,
                componentId: (0, $krYZG.ACTION_SUBJECT_ID).SYNCED_BLOCK_LABEL,
                dispatchAnalyticsEvent: this.api?.analytics?.actions.fireAnalyticsEvent,
                fallbackComponent: null,
                children: /*#__PURE__*/ (0, $8aG6j.jsx)($d6e50e685ac89fcf$export$520fa575be2f7d06, {
                    localId: node.attrs.localId,
                    resourceId: node.attrs.resourceId,
                    sourceManager: sourceManager
                })
            }), labelContainer, this.labelKey);
        this.updateContentEditable({});
        this.updateEmptyClass();
        this.handleConnectivityModeChange();
        this.handleViewModeChange();
    // Cache is populated in state.init() and updated in appendTransaction,
    // so no additional updateSyncBlockData call is needed here.
    }
}
const $d6e50e685ac89fcf$export$89bdce39123f4223 = (props)=>{
    const { api: api, pmPluginFactoryParams: { nodeViewPortalProviderAPI: nodeViewPortalProviderAPI }, syncBlockStore: syncBlockStore } = props;
    return (node, view, getPos)=>{
        return new $d6e50e685ac89fcf$export$e287a7d211075664(node, view, getPos, api, nodeViewPortalProviderAPI, syncBlockStore?.sourceManager);
    };
};





parcelRequire("cozmU");








var $Igylv = parcelRequire("Igylv");


var $i2lVL = parcelRequire("i2lVL");














var $cbY7C = parcelRequire("cbY7C");








var $79ir6 = parcelRequire("79ir6");

var $4cJIQ = parcelRequire("4cJIQ");



const $eba34f15ca47930e$export$b5dcfcd5b90b41cc = (manager, syncBlockNode)=>{
    const nodeRef = (0, $cozmU.useRef)(syncBlockNode);
    nodeRef.current = syncBlockNode;
    const nodeTypeName = syncBlockNode.type.name;
    const resourceId = syncBlockNode.attrs?.resourceId;
    const localId = syncBlockNode.attrs?.localId;
    // Initialize state from cache to prevent flickering during re-renders
    const [sourceTitle, setSourceTitle] = (0, $cozmU.useState)(()=>{
        if (nodeTypeName !== 'syncBlock') return undefined;
        if (!resourceId) return undefined;
        const cachedData = manager.referenceManager.getFromCache(resourceId);
        return cachedData?.data?.sourceTitle;
    });
    (0, $cozmU.useEffect)(()=>{
        const unsubscribe = manager.referenceManager.subscribeToSourceTitle(nodeRef.current, (title)=>{
            setSourceTitle(title);
        });
        return ()=>{
            unsubscribe();
        };
    }, [
        manager,
        nodeTypeName,
        resourceId,
        localId
    ]);
    return sourceTitle;
};







const $76e39394309af1c6$var$SyncBlockRendererWrapperDataId = 'sync-block-plugin-renderer-wrapper';
const $76e39394309af1c6$var$SyncBlockRendererWrapperComponent = ({ syncedBlockRenderer: syncedBlockRenderer, syncBlockStore: syncBlockStore, node: node, resourceId: resourceId, localId: localId, api: api })=>{
    const isSamePageSyncEnabled = (0, $4o0zT.isExperimentEnabled)('editor-synced-block-same-page-sync');
    const syncBlockFetchResult = (0, $4cJIQ.useFetchSyncBlockData)(syncBlockStore, resourceId, localId, api?.analytics?.actions?.fireAnalyticsEvent);
    const title = (0, $eba34f15ca47930e$export$b5dcfcd5b90b41cc)(syncBlockStore, node);
    const contentUpdatedAt = syncBlockFetchResult?.syncBlockInstance?.data?.contentUpdatedAt;
    const isUnpublishedBlock = syncBlockFetchResult.syncBlockInstance?.data?.status === 'unpublished';
    const localSameDocumentSource = isSamePageSyncEnabled ? syncBlockFetchResult.syncBlockInstance?.localSameDocumentSource : undefined;
    const localSourceBlockInstanceId = localSameDocumentSource?.sourceBlockInstanceId;
    const [localSourceInfo, setLocalSourceInfo] = (0, $cozmU.useState)();
    (0, $cozmU.useEffect)(()=>{
        let isMounted = true;
        if (!localSourceBlockInstanceId) {
            setLocalSourceInfo(undefined);
            return;
        }
        syncBlockStore.sourceManager?.getSyncBlockSourceInfo(localSourceBlockInstanceId).then((sourceInfo)=>{
            if (isMounted) setLocalSourceInfo(sourceInfo);
        });
        return ()=>{
            isMounted = false;
        };
    }, [
        localSourceBlockInstanceId,
        syncBlockStore.sourceManager
    ]);
    const isUnsyncedBlock = isUnpublishedBlock && !localSameDocumentSource || syncBlockFetchResult?.syncBlockInstance?.error?.type === (0, $79ir6.SyncBlockError).NotFound;
    // Evaluated unconditionally so the experiment exposure is tracked correctly
    // (recorded on every render, not lazily on first click).
    const isSyncBlockActivationEnabled = (0, $ieeJu.expValEquals)('platform_editor_sync_block_activation', 'isEnabled', true);
    // Prevent editing in the contentEditable renderer wrapper. We set
    // contentEditable="true" to enable text selection (creating an editable
    // island inside ProseMirror's contentEditable="false" nodeview wrapper),
    // but users must not be able to type into or modify the renderer content.
    const preventInput = (0, $cozmU.useCallback)((e)=>{
        e.preventDefault();
    }, []);
    // Browsers suppress link navigation on a plain click inside a
    // contentEditable region (they place the caret instead), which breaks links
    // rendered in the content — e.g. the "when the page is published" link in
    // the unpublished error card. Re-trigger navigation for _blank anchors
    // ourselves. A native listener (rather than an onClick on the div) is used
    // so we delegate link clicks without making the container itself interactive.
    const rendererRef = (0, $cozmU.useRef)(null);
    (0, $cozmU.useEffect)(()=>{
        const containerEl = rendererRef.current;
        if (!containerEl || !isSyncBlockActivationEnabled) return;
        const unbind = (0, $cbY7C.bind)(containerEl, {
            type: 'click',
            listener: (e)=>{
                // Let the browser handle modified/non-primary clicks (open-in-new-tab,
                // etc.) natively so we don't open a second tab on top of it.
                if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
                const target = e.target instanceof Element ? e.target : null;
                const anchor = target?.closest('a[href]');
                if (!(anchor instanceof HTMLAnchorElement) || e.defaultPrevented || anchor.target !== '_blank') return;
                window.open(anchor.href, '_blank', 'noopener,noreferrer');
            }
        });
        return unbind;
    }, [
        isSyncBlockActivationEnabled
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
                ref: rendererRef,
                "data-testid": $76e39394309af1c6$var$SyncBlockRendererWrapperDataId,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
                className: (0, $95bQO.SyncBlockSharedCssClassName).renderer,
                contentEditable: true,
                suppressContentEditableWarning: true,
                // Prevent the contentEditable div from being keyboard-focusable.
                // It is only used to enable text selection, not as an input target.
                // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
                tabIndex: -1,
                onBeforeInput: preventInput,
                onPaste: preventInput,
                // eslint-disable-next-line @atlaskit/design-system/no-direct-use-of-web-platform-drag-and-drop
                onDrop: preventInput,
                children: syncedBlockRenderer({
                    syncBlockFetchResult: syncBlockFetchResult,
                    api: api,
                    localId: localId
                })
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $74d9a790701b865f$export$af6d83e4f9d69ba5), {
                isSource: false,
                title: title,
                contentUpdatedAt: contentUpdatedAt,
                localId: localId,
                isUnsyncedBlock: isUnsyncedBlock,
                unpublishedInfo: localSameDocumentSource && isUnpublishedBlock ? {
                    sourceType: (0, $65eb1a6a9f5a9fc0$export$214d9e923056baaa)({
                        sourceAri: localSourceInfo?.sourceAri ?? syncBlockFetchResult.syncBlockInstance?.data?.sourceAri,
                        sourceProduct: localSourceInfo?.productType ?? localSameDocumentSource.sourceProduct
                    }),
                    variant: 'local-reference'
                } : undefined
            })
        ]
    });
};
const $76e39394309af1c6$export$295fdde04ad91bbd = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).memo($76e39394309af1c6$var$SyncBlockRendererWrapperComponent);





parcelRequire("cozmU");





var $4iudd = parcelRequire("4iudd");

function $0fe46b9dabba4423$export$491fe064d74662f9({ children: children, intl: intl }) {
    if (!(0, $4iudd.isSSR)()) return children;
    if (!intl) return children;
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.RawIntlProvider), {
        value: intl,
        children: children
    });
}


// Event types that should be intercepted (returned as handled) when they
// originate inside the sync block content area, so ProseMirror does not
// convert them into node-level selections or drag operations and the browser
// can perform native text selection/cut instead.
const $64e6e0cab8437f11$var$STOPPED_EVENT_TYPES = [
    'mousedown',
    'mousemove',
    'mouseup',
    'click',
    'dblclick',
    'selectstart'
];
class $64e6e0cab8437f11$export$5dd7fae087dd8061 extends (0, $Igylv.default) {
    createDomRef() {
        // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage -- NodeView DOM must be created against active runtime document
        const domRef = document.createElement('div');
        domRef.classList.add((0, $95bQO.SyncBlockSharedCssClassName).prefix);
        // Prevent native browser drag on the contentEditable="false" wrapper.
        // Without this, clicking in empty space (outside the contentEditable
        // renderer but inside the domRef) initiates a native element drag.
        domRef.draggable = false;
        this.dragStartHandler = (e)=>{
            e.preventDefault();
        };
        // eslint-disable-next-line @atlaskit/design-system/no-direct-use-of-web-platform-drag-and-drop, @repo/internal/dom-events/no-unsafe-event-listeners
        domRef.addEventListener('dragstart', this.dragStartHandler);
        return domRef;
    }
    /**
   * Allow mouse and selection events inside the renderer content to pass
   * through to the browser so that users can select and copy text within a
   * reference sync block.
   *
   * Events that originate inside the sync block content area (but not the label)
   * are stopped so ProseMirror does not intercept them for node-level selection.
   * This includes the full click-drag cycle (mousedown, mousemove, mouseup),
   * click, dblclick, selectstart and cut. The `cut` event is stopped because
   * mousedown explicitly sets a NodeSelection on the sync block — without
   * stopping `cut`, a subsequent Ctrl+X would cause ProseMirror to delete the
   * entire sync block node instead of cutting the user's text selection.
   *
   * Copy events are conditionally stopped: when the user has an active native
   * text selection inside the renderer, `copy` is stopped so the browser handles
   * it natively (copying the selected text). When there is no text selection
   * (just a PM NodeSelection), `copy` is NOT stopped so ProseMirror's copy
   * handler runs and sets the "sync-block-copied" flag for the reference paste flow.
   *
   * Events on the SyncBlockLabel are left for ProseMirror to handle, preserving
   * label click interactions and the floating toolbar.
   *
   * The renderer wrapper sets contentEditable="true" to create a re-editable
   * island inside ProseMirror's contentEditable="false" nodeview, enabling
   * native text selection and preventing browser drag behaviour.
   */ stopEvent(event) {
        const target = event.target;
        if (!(target instanceof Element)) return false;
        // Stop events inside the sync block content area, but not on the
        // SyncBlockLabel (to preserve label click interactions).
        if (target.closest(`.${(0, $95bQO.SyncBlockSharedCssClassName).prefix}`) && !target.closest(`.${(0, $95bQO.SyncBlockLabelSharedCssClassName).labelClassName}`)) {
            const eventType = event.type;
            // Stop `copy` only when there is an active native text selection
            // inside the renderer. This lets the browser handle text copy
            // natively. When there is no text selection (just a PM
            // NodeSelection), we let PM handle the copy event so the
            // "sync-block-copied" flag is set for the reference paste flow.
            if (eventType === 'copy') {
                const selection = window.getSelection();
                return !!(selection && selection.toString().length > 0);
            }
            // For `cut`: when text is selected inside the renderer, stop the
            // event and prevent default to avoid the browser removing text from
            // the read-only content. When no text is selected (NodeSelection),
            // let PM handle it so cut deletes the sync block as expected.
            if (eventType === 'cut') {
                const selection = window.getSelection();
                if (selection && selection.toString().length > 0) {
                    event.preventDefault();
                    return true;
                }
                return false;
            }
            // Stop keyboard events that would cause PM to replace the
            // NodeSelection with typed text (deleting the sync block).
            // Allow modifier-key combos (Cmd+C, Cmd+A, etc.) through.
            // Allow Delete/Backspace through so PM's delete handler can
            // process them (e.g. show offline error flag).
            if ((eventType === 'keydown' || eventType === 'keypress') && event instanceof KeyboardEvent && !event.metaKey && !event.ctrlKey && event.key !== 'Delete' && event.key !== 'Backspace') return true;
            if ($64e6e0cab8437f11$var$STOPPED_EVENT_TYPES.includes(eventType)) {
                // Ensure the syncBlock has a NodeSelection so the floating
                // toolbar is visible while the user interacts with the renderer.
                // stopEvent prevents PM from processing the mousedown, so we
                // need to explicitly set the selection ourselves.
                if (eventType === 'mousedown' && !(this.view.state.selection instanceof (0, $kCECX.NodeSelection) && this.view.state.selection.node === this.node)) {
                    if (typeof this.getPos === 'function') {
                        const pos = this.getPos();
                        if (typeof pos === 'number') try {
                            const { tr: tr } = this.view.state;
                            this.view.dispatch(tr.setSelection((0, $kCECX.NodeSelection).create(tr.doc, pos)));
                        } catch  {
                        // pos no longer valid — leave selection unchanged
                        }
                    }
                }
                return true;
            }
        }
        return false;
    }
    validUpdate(currentNode, newNode) {
        // Only consider as the valid update if the localId and resourceId are the same
        // This prevents PM reusing the same node view for different sync block node in live page transition
        return currentNode.attrs.localId === newNode.attrs.localId && currentNode.attrs.resourceId === newNode.attrs.resourceId;
    }
    update(node, decorations, innerDecorations) {
        return super.update(node, decorations, innerDecorations, this.validUpdate);
    }
    render({ getPos: getPos }) {
        if (!this.options?.syncedBlockRenderer) return null;
        const { resourceId: resourceId, localId: localId } = this.node.attrs;
        if (!resourceId || !localId) return null;
        const syncBlockStore = this.api?.syncedBlock?.sharedState.currentState()?.syncBlockStore ?? this.syncBlockStore;
        if (!syncBlockStore) return null;
        // get document node from data provider
        return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $0fe46b9dabba4423$export$491fe064d74662f9), {
            intl: this.intl,
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $h75sz.ErrorBoundary), {
                component: (0, $krYZG.ACTION_SUBJECT).SYNCED_BLOCK,
                dispatchAnalyticsEvent: this.api?.analytics?.actions.fireAnalyticsEvent,
                fallbackComponent: null,
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $i2lVL.SyncBlockActionsProvider), {
                    removeSyncBlock: this.removeSyncBlockStable,
                    fetchSyncBlockSourceInfo: this.fetchSyncBlockSourceInfoStable,
                    children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $76e39394309af1c6$export$295fdde04ad91bbd), {
                        localId: localId,
                        resourceId: resourceId,
                        node: this.node,
                        syncBlockStore: syncBlockStore,
                        syncedBlockRenderer: this.options?.syncedBlockRenderer,
                        api: this.api
                    })
                })
            })
        });
    }
    destroy() {
        this.unsubscribe?.();
        if (this.dragStartHandler) {
            // eslint-disable-next-line @atlaskit/design-system/no-direct-use-of-web-platform-drag-and-drop, @repo/internal/dom-events/no-unsafe-event-listeners
            this.dom?.removeEventListener('dragstart', this.dragStartHandler);
            this.dragStartHandler = undefined;
        }
        super.destroy();
    }
    constructor(props){
        super(props.node, props.view, props.getPos, props.portalProviderAPI, props.eventDispatcher, props);
        this.options = void 0;
        this.api = void 0;
        this.syncBlockStore = void 0;
        this.intl = void 0;
        // Stable callback references — defined as arrow properties so they keep a
        // fixed identity across render() calls, avoiding defeats of React.memo.
        // The experiment gate lives in render(); these are always available.
        this.removeSyncBlockStable = ()=>{
            const pos = this.getPos();
            if (pos !== undefined) (0, $4d68281089368b28$export$8d571a58cfd57507)(this.api, pos);
        };
        this.fetchSyncBlockSourceInfoStable = (sourceAri)=>{
            // store is guaranteed non-null: render() guards on syncBlockStore
            // before these callbacks can be invoked.
            const store = this.api?.syncedBlock?.sharedState.currentState()?.syncBlockStore ?? this.syncBlockStore;
            return store ? store.referenceManager.fetchSyncBlockSourceInfoBySourceAri(sourceAri) : Promise.resolve(undefined);
        };
        this.unsubscribe = void 0;
        // Stored reference so the listener can be removed in destroy() to
        // avoid a memory leak on every nodeview destruction.
        this.dragStartHandler = void 0;
        this.options = props.options;
        this.api = props.api;
        this.syncBlockStore = props.syncBlockStore;
        this.intl = props.intl;
    }
}
const $64e6e0cab8437f11$export$72faffc4c399ec30 = ({ options: options, pmPluginFactoryParams: pmPluginFactoryParams, api: api })=>(node, view, getPos)=>{
        const { portalProviderAPI: portalProviderAPI, eventDispatcher: eventDispatcher } = pmPluginFactoryParams;
        return new $64e6e0cab8437f11$export$5dd7fae087dd8061({
            api: api,
            options: options,
            node: node,
            view: view,
            getPos: getPos,
            portalProviderAPI: portalProviderAPI,
            eventDispatcher: eventDispatcher
        }).init();
    };


var $ec0a253b1ada3f34$export$5881677fb314e6d9 = /*#__PURE__*/ function(FLAG_ID) {
    FLAG_ID["CANNOT_DELETE_WHEN_OFFLINE"] = "cannot-delete-when-offline";
    FLAG_ID["CANNOT_EDIT_WHEN_OFFLINE"] = "cannot-edit-when-offline";
    FLAG_ID["CANNOT_CREATE_WHEN_OFFLINE"] = "cannot-create-when-offline";
    FLAG_ID["FAIL_TO_DELETE"] = "fail-to-delete";
    FLAG_ID["SYNC_BLOCK_COPIED"] = "sync-block-copied";
    FLAG_ID["UNPUBLISHED_SYNC_BLOCK_PASTED"] = "unpublished-sync-block-pasted";
    FLAG_ID["CANNOT_CREATE_SYNC_BLOCK"] = "cannot-create-sync-block";
    FLAG_ID["INLINE_EXTENSION_IN_SYNC_BLOCK"] = "inline-extension-in-sync-block";
    FLAG_ID["EXTENSION_IN_SYNC_BLOCK"] = "extension-in-sync-block";
    FLAG_ID["DUPLICATE_SOURCE_SYNC_BLOCK"] = "duplicate-source-sync-block";
    FLAG_ID["SYNC_BLOCK_FEEDBACK_PROMPT"] = "synced-block-feedback-prompt";
    return FLAG_ID;
}({});
const $ec0a253b1ada3f34$export$ce5236bf4eef2662 = {
    primaryToolbarCreate: 'create-synced-block-toolbar-btn',
    blockMenuCreate: 'create-synced-block-block-menu-btn',
    quickInsertCreate: 'create-synced-block-quick-insert-btn',
    syncedBlockToolbarCopy: 'synced-block-copy-btn',
    syncedBlockToolbarReferenceDelete: 'reference-synced-block-delete-btn',
    syncedBlockToolbarSourceDelete: 'source-synced-block-delete-btn',
    syncedBlockToolbarReferenceUnsync: 'reference-synced-block-unsync-btn',
    syncedBlockToolbarSourceUnsync: 'source-synced-block-unsync-btn',
    syncedBlockToolbarSyncedLocationsTrigger: 'synced-block-synced-locations-dropdown--trigger',
    syncedBlockToolbarReferenceOverflowTrigger: 'reference-synced-block-overflow-dropdown--trigger',
    syncedBlockToolbarSourceOverflowTrigger: 'source-synced-block-overflow-dropdown--trigger'
};








var $dOBRD = parcelRequire("dOBRD");


var $lVAkE = parcelRequire("lVAkE");













const $04e29bf458c24792$export$fb2d0f31ec71c7e9 = (fn)=>{
    queueMicrotask(fn);
};
const $04e29bf458c24792$export$8e2da6078c69a0c6 = (schema, selection)=>{
    const { syncBlock: syncBlock } = schema.nodes;
    return (0, $bjg0G.findSelectedNodeOfType)(syncBlock)(selection);
};
const $04e29bf458c24792$export$342c143cb64448d1 = (schema, selection)=>{
    return (0, $bjg0G.findSelectedNodeOfType)(schema.nodes.bodiedSyncBlock)(selection) || (0, $bjg0G.findParentNodeOfType)(schema.nodes.bodiedSyncBlock)(selection);
};
const $04e29bf458c24792$export$72f89723ce6d6fa3 = (schema, selection)=>{
    return $04e29bf458c24792$export$8e2da6078c69a0c6(schema, selection) || $04e29bf458c24792$export$342c143cb64448d1(schema, selection);
};
const $04e29bf458c24792$export$5f971aa95a01794c = (node, bodiedSyncBlock)=>node.type === bodiedSyncBlock;
const $04e29bf458c24792$export$77fbebd359a90e90 = (0, $dOBRD.default)(()=>new Set([
        'inlineExtension',
        'extension',
        'bodiedExtension',
        'syncBlock',
        'bodiedSyncBlock',
        ...(0, $ieeJu.expValEquals)('confluence_native_tabs_experiment', 'isEnabled', true) ? [
            'multiBodiedExtension'
        ] : []
    ]));
const $04e29bf458c24792$export$a912fa82dfd54783 = (selection)=>{
    const { $from: $from, range: range } = (0, $lVAkE.expandSelectionToBlockRange)(selection);
    if (!range) return false;
    const from = range.start;
    const to = range.end;
    const unsupportedNodeTypes = $04e29bf458c24792$export$77fbebd359a90e90();
    let canBeConverted = true;
    $from.doc.nodesBetween(from, to, (node)=>{
        if (unsupportedNodeTypes.has(node.type.name)) {
            canBeConverted = false;
            return false;
        }
    });
    if (!canBeConverted) return false;
    const selectedContent = $from.doc.slice(from, to).content;
    // A single wrapper cannot preserve independent breakout widths for a multi-node selection.
    const breakoutMark = selectedContent.childCount === 1 ? selectedContent.firstChild?.marks.find((mark)=>mark.type.name === 'breakout') : undefined;
    const contentToInclude = $04e29bf458c24792$var$removeBreakoutMarks(selectedContent);
    return {
        breakoutMark: breakoutMark,
        contentToInclude: contentToInclude,
        from: from,
        to: to
    };
};
const $04e29bf458c24792$var$removeBreakoutMarks = (content)=>{
    const nodes = [];
    // we only need to recurse at the top level, because breakout has to be on a top level
    content.forEach((node)=>{
        const filteredMarks = node.marks.filter((mark)=>mark.type.name !== 'breakout');
        if (node.isText) nodes.push(node);
        else {
            const newNode = node.type.create(node.attrs, node.content, filteredMarks);
            nodes.push(newNode);
        }
    });
    return (0, $aPdNQ.Fragment).from(nodes);
};
const $04e29bf458c24792$export$384f6683328fd2fe = (slice, node)=>{
    const isFirstChild = slice.content.firstChild?.type === node.type && slice.content.firstChild?.attrs.resourceId === node.attrs.resourceId;
    const isLastChild = slice.content.lastChild?.type === node.type && slice.content.lastChild?.attrs.resourceId === node.attrs.resourceId;
    const isOpenAtStart = isFirstChild && slice.openStart > 0;
    const isOpenAtEnd = isLastChild && slice.openEnd > 0;
    if (isOpenAtStart || isOpenAtEnd) return false;
    return true;
};
// even though extension and bodiedExtension are explicitly not allowed by the schema, they can still be inserted nested inside other nodes e.g. layouts
const $04e29bf458c24792$var$EXTENSION_NODES = new Set([
    'inlineExtension',
    'extension',
    'bodiedExtension'
]);
const $04e29bf458c24792$var$fragmentContainsExtension = (fragment)=>{
    let found = false;
    fragment.forEach((node)=>{
        if (found) return;
        if ($04e29bf458c24792$var$EXTENSION_NODES.has(node.type.name)) found = true;
        else if (node.content.size) {
            if ($04e29bf458c24792$var$fragmentContainsExtension(node.content)) found = true;
        }
    });
    return found;
};
const $04e29bf458c24792$var$sliceContainsExtension = (slice)=>$04e29bf458c24792$var$fragmentContainsExtension(slice.content);
const $04e29bf458c24792$export$ecac802907d15d9a = (tr, state)=>{
    if (!tr.docChanged || tr.getMeta('isRemote')) return undefined;
    const { bodiedSyncBlock: bodiedSyncBlock } = state.schema.nodes;
    if (!bodiedSyncBlock) return undefined;
    const docs = tr.docs;
    // When docs is available (e.g. from history plugin), check each replace step
    if (docs && docs.length > 0) {
        for(let i = 0; i < tr.steps.length; i++){
            const step = tr.steps[i];
            const isReplaceStep = step instanceof (0, $eOaGc.ReplaceStep) || step instanceof (0, $eOaGc.ReplaceAroundStep);
            if (!isReplaceStep || !('slice' in step) || !('from' in step)) continue;
            const replaceStep = step;
            if (!$04e29bf458c24792$var$sliceContainsExtension(replaceStep.slice)) continue;
            const docAfterStep = docs[i + 1] ?? tr.doc;
            try {
                const $pos = docAfterStep.resolve(replaceStep.from);
                const parent = (0, $bjg0G.findParentNodeOfTypeClosestToPos)($pos, bodiedSyncBlock);
                if (parent?.node.attrs.resourceId) return parent.node.attrs.resourceId;
            } catch  {
            // resolve() can throw if position is invalid
            }
        }
        return undefined;
    }
    // Fallback: scan final doc for inline extensions inside bodied sync block that were added
    let resourceId;
    tr.doc.descendants((node, pos)=>{
        if (resourceId !== undefined) return false;
        if ($04e29bf458c24792$var$EXTENSION_NODES.has(node.type.name)) {
            const $pos = tr.doc.resolve(pos);
            const parent = (0, $bjg0G.findParentNodeOfTypeClosestToPos)($pos, bodiedSyncBlock);
            if (parent?.node.attrs.resourceId) {
                const mappedPos = tr.mapping.invert().map(pos);
                const nodeBefore = state.doc.nodeAt(mappedPos);
                if (!nodeBefore || $04e29bf458c24792$var$EXTENSION_NODES.has(nodeBefore.type.name)) {
                    resourceId = parent.node.attrs.resourceId;
                    return false;
                }
            }
        }
        return true;
    });
    return resourceId;
};


const $978b73c23f40d240$var$onRetry = (api, resourceId)=>{
    return ()=>{
        api?.core?.actions.focus();
        api?.core?.actions.execute(({ tr: tr })=>{
            const pos = api?.syncedBlock?.sharedState.currentState()?.retryCreationPosMap?.get(resourceId);
            const from = pos?.from;
            const to = pos?.to;
            if (from === undefined || to === undefined) return tr;
            tr.setSelection((0, $kCECX.TextSelection).create(tr.doc, from, to)).setMeta((0, $92ceda184e2df47e$export$cb5a03b39dafc9cc), {
                activeFlag: false
            });
            api?.syncedBlock?.commands.insertSyncedBlock()({
                tr: tr
            });
            return tr;
        });
    };
};
const $978b73c23f40d240$var$getRevertCreationPos = (api, doc, resourceId)=>{
    const retryCreationPos = api?.syncedBlock?.sharedState.currentState()?.retryCreationPosMap?.get(resourceId);
    if (retryCreationPos) return retryCreationPos;
    // Fallback to find the positions in case BE call returns before plugin state becomes available
    // which is highly unlikely
    let currentPos;
    doc.descendants((node, pos)=>{
        if (currentPos) return false;
        if (node.type.name === 'bodiedSyncBlock' && resourceId === node.attrs.resourceId) {
            currentPos = {
                from: pos,
                to: pos + node.nodeSize
            };
            return false;
        }
    });
    return currentPos;
};
const $978b73c23f40d240$var$buildRevertCreationTr = (tr, pos)=>{
    const content = tr.doc.nodeAt(pos.from)?.content;
    if (content) {
        tr.replaceWith(pos.from, pos.to, content);
        const contentFrom = tr.mapping.map(pos.from);
        tr.setSelection((0, $kCECX.TextSelection).create(tr.doc, contentFrom, contentFrom + content.size));
    } else tr.delete(pos.from, pos.to);
    return tr;
};
const $978b73c23f40d240$export$4ef10a0a6b609715 = (bodiedSyncBlockAdded, editorState, api, enrichment)=>{
    const syncBlockStore = (0, $92ceda184e2df47e$export$cb5a03b39dafc9cc).getState(editorState).syncBlockStore;
    bodiedSyncBlockAdded.forEach((node)=>{
        if (node.from === undefined || node.to === undefined) return;
        const retryCreationPos = {
            from: node.from,
            to: node.to
        };
        const resourceId = node.attrs.resourceId;
        (0, $04e29bf458c24792$export$fb2d0f31ec71c7e9)(()=>{
            api?.core?.actions.execute(({ tr: tr })=>{
                return tr.setMeta((0, $92ceda184e2df47e$export$cb5a03b39dafc9cc), {
                    retryCreationPos: {
                        resourceId: resourceId,
                        pos: retryCreationPos
                    }
                });
            });
        });
        syncBlockStore.sourceManager.createBodiedSyncBlockNode(node.attrs, node.node, (success)=>{
            if (success) {
                api?.core?.actions.execute(({ tr: tr })=>{
                    return tr.setMeta((0, $92ceda184e2df47e$export$cb5a03b39dafc9cc), {
                        retryCreationPos: {
                            resourceId: resourceId,
                            pos: undefined
                        }
                    });
                });
                api?.core?.actions.focus();
            } else api?.core?.actions.execute(({ tr: tr })=>{
                const revertCreationPos = $978b73c23f40d240$var$getRevertCreationPos(api, tr.doc, resourceId);
                if (!revertCreationPos) return tr;
                const revertTr = $978b73c23f40d240$var$buildRevertCreationTr(tr, revertCreationPos);
                return revertTr.setMeta('isConfirmedSyncBlockDeletion', true).setMeta('addToHistory', false).setMeta((0, $92ceda184e2df47e$export$cb5a03b39dafc9cc), {
                    activeFlag: {
                        id: (0, $ec0a253b1ada3f34$export$5881677fb314e6d9).CANNOT_CREATE_SYNC_BLOCK,
                        onRetry: $978b73c23f40d240$var$onRetry(api, resourceId),
                        onDismissed: (tr)=>tr.setMeta((0, $92ceda184e2df47e$export$cb5a03b39dafc9cc), {
                                ...tr.getMeta((0, $92ceda184e2df47e$export$cb5a03b39dafc9cc)),
                                retryCreationPos: {
                                    resourceId: resourceId,
                                    pos: undefined
                                }
                            })
                    }
                });
            });
        }, enrichment);
    });
};













/**
 * Whether `node` is the source block requested by `wanted`.
 *
 * Matching is done *per requested block* (rather than against global pools of
 * every requested localId/resourceId) so a node cannot be matched by combining
 * one block's `localId` with a different block's `resourceId`. We match on the
 * requested block's `localId` first and only fall back to its `resourceId` when
 * the `localId` has been regenerated (so it no longer matches the live node).
 */ const $1f55c2daca4420d4$var$matchesRequestedBlock = (node, wanted)=>{
    const { localId: localId, resourceId: resourceId } = node.attrs;
    if (wanted.localId && localId && wanted.localId === localId) return true;
    return Boolean(wanted.resourceId && resourceId && wanted.resourceId === resourceId);
};
/**
 * Locate the live positions of the source `bodiedSyncBlock` nodes identified by
 * `syncBlockIds`, matching first on `localId` and falling back to `resourceId`.
 *
 * This walks the *current* document (`tr.doc`) rather than relying on positions
 * captured when the delete was first triggered, so it is robust to intervening
 * local edits and remote collab changes that occur while the confirmation modal
 * is open.
 */ const $1f55c2daca4420d4$var$findSourceBlocks = (tr, isSourceBlock, syncBlockIds)=>{
    const matches = [];
    tr.doc.descendants((node, pos)=>{
        if (!isSourceBlock(node)) // bodiedSyncBlock is always a top-level node, so there is no need to
        // descend into other branches looking for one.
        return false;
        if (syncBlockIds.some((wanted)=>$1f55c2daca4420d4$var$matchesRequestedBlock(node, wanted))) matches.push({
            node: node,
            pos: pos
        });
        // Never recurse into a source block's body.
        return false;
    });
    return matches;
};
const $1f55c2daca4420d4$export$71458047dba8e515 = (tr, isSourceBlock, syncBlockIds)=>{
    const matches = $1f55c2daca4420d4$var$findSourceBlocks(tr, isSourceBlock, syncBlockIds);
    if (matches.length === 0) return undefined;
    // Delete in reverse document order so positions remain valid across deletes.
    matches.sort((a, b)=>b.pos - a.pos).forEach(({ node: node, pos: pos })=>{
        tr.delete(pos, pos + node.nodeSize);
    });
    return tr;
};
const $1f55c2daca4420d4$export$43dcf6cfb7f47f27 = (tr, isSourceBlock, syncBlockIds)=>{
    const matches = $1f55c2daca4420d4$var$findSourceBlocks(tr, isSourceBlock, syncBlockIds);
    if (matches.length === 0) return undefined;
    // Unwrap in reverse document order so positions remain valid across edits.
    // Use a raw zero-open Slice replace (not `replaceWith`) so the block's content
    // is inserted verbatim as top-level nodes without ProseMirror's replaceRange
    // heuristics collapsing a trailing block (EDITOR-8230).
    const orderedMatches = matches.sort((a, b)=>b.pos - a.pos);
    for (const { node: node, pos: pos } of orderedMatches)// This is ProseMirror's Transaction.replace (a document edit), not String.replace — the
    // perf rule misfires on the method name, and there is nothing to hoist.
    // eslint-disable-next-line @atlassian/perf-linting/no-expensive-split-replace
    tr.replace(pos, pos + node.nodeSize, new (0, $aPdNQ.Slice)(node.content, 0, 0));
    return tr;
};


const $60b0521823ac38c9$var$onRetry = (api, syncBlockStore)=>()=>{
        api?.core?.actions.execute(({ tr: tr })=>{
            return tr.setMeta((0, $92ceda184e2df47e$export$cb5a03b39dafc9cc), {
                bodiedSyncBlockDeletionStatus: 'processing',
                activeFlag: false
            });
        });
        syncBlockStore.sourceManager.retryDeletion();
    };
const $60b0521823ac38c9$var$onDismissed = (syncBlockStore)=>(tr)=>{
        syncBlockStore.sourceManager.clearPendingDeletion();
        return tr.setMeta((0, $92ceda184e2df47e$export$cb5a03b39dafc9cc), {
            bodiedSyncBlockDeletionStatus: 'none'
        });
    };
const $60b0521823ac38c9$export$4d68be81d3ab4a0d = (bodiedSyncBlockRemoved, syncBlockStore, api, confirmationTransactionRef, deletionReason, mechanism, feedbackCallbacks)=>{
    // Clear potential old pending deletion to retreat the deletion as first attempt
    syncBlockStore.sourceManager.clearPendingDeletion();
    // If there are source sync blocks being removed, and we need to confirm with user before deleting,
    // we block the transaction here, and wait for user confirmation to proceed with deletion.
    // See editor-common/src/sync-block/sync-block-store-manager.ts for how we handle user confirmation and
    // proceed with deletion.
    syncBlockStore.sourceManager.deleteSyncBlocksWithConfirmation(bodiedSyncBlockRemoved.map((node)=>node.attrs), deletionReason, ()=>{
        // Recompute the delete fresh from the live document instead of
        // replaying a stashed-and-rebased transaction. The stash/rebase
        // approach produced stale, schema-invalid transactions when the
        // document changed shape (local edits or remote collab) while the
        // confirmation modal was open — the dominant signature being
        // "Invalid content for node bodiedSyncBlock: <>". See EDITOR-7889.
        api?.core?.actions.execute(({ tr: tr })=>{
            // EDITOR-8230: unsync must remove only the sync wrapper and keep the block's
            // content inline, whereas delete removes the whole block. Before this branch,
            // the confirm path always recomputed a full delete, so unsyncing a source block
            // silently deleted its content. When the deletion was actually triggered by
            // unsync, recompute an unwrap (replaceWith content) instead of a delete.
            const recomputedTr = deletionReason === 'source-block-unsynced' ? (0, $1f55c2daca4420d4$export$43dcf6cfb7f47f27)(tr, syncBlockStore.sourceManager.isSourceBlock, bodiedSyncBlockRemoved.map((node)=>node.attrs)) : (0, $1f55c2daca4420d4$export$71458047dba8e515)(tr, syncBlockStore.sourceManager.isSourceBlock, bodiedSyncBlockRemoved.map((node)=>node.attrs));
            // The target node(s) no longer exist in the live document (e.g.
            // a remote collaborator already removed them). There is nothing
            // to delete locally, so return `null` to skip the dispatch
            // entirely — dispatching the untouched transaction would be a
            // no-op that still runs the plugin's filter/append hooks. The
            // backend deletion has already been issued by the store manager.
            if (!recomputedTr) return null;
            if ((0, $iDrrr.fg)('platform_editor_blocks_patch_10')) // The original transaction's closeMenu meta was rejected along with it above,
            // so re-apply it here to close the block menu once the delete actually lands.
            api?.blockControls?.commands?.toggleBlockMenu({
                closeMenu: true
            })({
                tr: recomputedTr
            });
            recomputedTr.setMeta('isConfirmedSyncBlockDeletion', true);
            feedbackCallbacks?.onDeleteTransaction(recomputedTr);
            if (!recomputedTr.getMeta((0, $2w79Z.pmHistoryPluginKey))) // bodiedSyncBlock deletion is expected to be permanent (cannot undo)
            // For a normal deletion (not triggered by undo), remove it from history so that it cannot be undone
            recomputedTr.setMeta('addToHistory', false);
            return recomputedTr;
        });
    }, (success)=>{
        feedbackCallbacks?.onDeleteCompleted(success);
        api?.core?.actions.execute(({ tr: tr })=>{
            let newState;
            if (!success) newState = {
                activeFlag: {
                    id: (0, $ec0a253b1ada3f34$export$5881677fb314e6d9).FAIL_TO_DELETE,
                    onRetry: $60b0521823ac38c9$var$onRetry(api, syncBlockStore),
                    onDismissed: $60b0521823ac38c9$var$onDismissed(syncBlockStore)
                }
            };
            else newState = {
                activeFlag: false
            };
            newState = {
                ...newState,
                bodiedSyncBlockDeletionStatus: syncBlockStore.sourceManager.isRetryingDeletion() ? 'none' : 'completed'
            };
            return tr.setMeta((0, $92ceda184e2df47e$export$cb5a03b39dafc9cc), newState);
        });
    }, ()=>{
        confirmationTransactionRef.current = undefined;
        feedbackCallbacks?.onDestroy();
    }, mechanism);
    return false;
};


const $bb93622324819e61$export$cf93eddb8b14708a = (doc)=>{
    for(let i = 0; i < doc.childCount; i++){
        const node = doc.child(i);
        if (node.type.name === 'syncBlock' || node.type.name === 'bodiedSyncBlock') return true;
    }
    return false;
};





const $6fe83dd5984ba2f3$export$6b191088ef76a6be = (view, event, api)=>{
    if (api?.connectivity?.sharedState.currentState()?.mode !== 'offline') return;
    const { bodiedSyncBlock: bodiedSyncBlock } = view.state.schema.nodes;
    const pos = view.posAtCoords({
        left: event.clientX,
        top: event.clientY
    })?.pos;
    if (pos === undefined) return;
    const $pos = view.state.doc.resolve(pos);
    const maybeNode = (0, $bjg0G.findParentNodeOfTypeClosestToPos)($pos, bodiedSyncBlock);
    if (maybeNode) return true;
};











const $895c7941d473c11e$export$aee83dbd972779dd = (doc, selection, schema)=>{
    const { bodiedSyncBlock: bodiedSyncBlock } = schema.nodes;
    const syncBlockParent = (0, $bjg0G.findParentNodeOfType)(bodiedSyncBlock)(selection);
    if (syncBlockParent) {
        const { node: node, pos: pos } = syncBlockParent;
        const decoration = (0, $8nvEM.Decoration).node(pos, pos + node.nodeSize, {
            class: `${(0, $95bQO.BodiedSyncBlockSharedCssClassName).selectionInside}`
        });
        return (0, $8nvEM.DecorationSet).create(doc, [
            decoration
        ]);
    }
    return (0, $8nvEM.DecorationSet).empty;
};








const $96d8d664fb910a31$export$a1196481035d4d42 = (predicate, tr, state)=>{
    const removed = {};
    const added = {};
    if (!tr.docChanged) return {
        removed: [],
        added: []
    };
    // and cast to specific step types
    const replaceSteps = tr.steps.filter((step)=>step instanceof (0, $eOaGc.ReplaceStep) || step instanceof (0, $eOaGc.ReplaceAroundStep));
    // this is a quick check to see if any insertion/deletion of sync block happened
    const hasSyncBlockChanges = replaceSteps.some((step)=>{
        const { from: from, to: to } = step;
        const docAtStep = tr.docs[tr.steps.indexOf(step)];
        let hasChange = false;
        if (from !== to) step.getMap().forEach((oldStart, oldEnd)=>{
            if (oldStart !== oldEnd && !hasChange) {
                const deletedSlice = docAtStep.slice(Math.max(0, oldStart), Math.min(docAtStep.content.size, oldEnd));
                deletedSlice.content.forEach((node)=>{
                    if (hasChange) return;
                    // for top level nodes
                    if (predicate(node)) hasChange = true;
                });
            }
        });
        // no need to check insertions if we already found deletions
        if (step.slice.content.size > 0 && !hasChange) step.slice.content.forEach((node)=>{
            if (predicate(node) && !hasChange) hasChange = true;
        });
        return hasChange;
    });
    if (hasSyncBlockChanges) {
        const oldDoc = state.doc;
        const newDoc = tr.doc;
        const syncBlockMapOld = {};
        const syncBlockMapNew = {};
        oldDoc.content.forEach((node)=>{
            if (predicate(node)) {
                const syncBlockAttr = node.attrs;
                syncBlockMapOld[syncBlockAttr.localId] = {
                    attrs: syncBlockAttr
                };
            }
        });
        newDoc.content.forEach((node, offset)=>{
            if (predicate(node)) {
                const syncBlockAttr = node.attrs;
                syncBlockMapNew[syncBlockAttr.localId] = {
                    attrs: syncBlockAttr,
                    node: node,
                    from: offset,
                    to: offset + node.nodeSize
                };
            }
        });
        // Find removed sync blocks
        for(const localId in syncBlockMapOld)if (!syncBlockMapNew[localId]) removed[localId] = syncBlockMapOld[localId];
        // Find added sync blocks
        for(const localId in syncBlockMapNew)if (!syncBlockMapOld[localId]) added[localId] = syncBlockMapNew[localId];
    }
    return {
        removed: Object.values(removed),
        added: Object.values(added)
    };
};
const $96d8d664fb910a31$export$7531459b60818a32 = (tr, state)=>{
    const { bodiedSyncBlock: bodiedSyncBlock } = state.schema.nodes;
    for(let i = 0; i < tr.steps.length; i++){
        const step = tr.steps[i];
        const map = step.getMap();
        const docAfterStep = tr.docs[i + 1] ?? tr.doc;
        const positions = [];
        // Extract positions from steps dynamically based on applicable properties
        if ('from' in step && typeof step.from === 'number' && 'to' in step && typeof step.to === 'number') {
            const { from: from, to: to } = step;
            positions.push(from, to);
        } else if ('pos' in step && typeof step.pos === 'number') {
            const { pos: pos } = step;
            positions.push(pos);
        }
        for (const pos of positions){
            const newPos = map.map(pos);
            if (newPos >= 0 && newPos <= docAfterStep.content.size) {
                if ((0, $bjg0G.findParentNodeOfTypeClosestToPos)(docAfterStep.resolve(newPos), bodiedSyncBlock)) return true;
            }
        }
    }
    return false;
};





const $9173991c8121bb66$export$d7a680e133c792af = (tr)=>{
    if (!tr.docChanged) return false;
    for (const step of tr.steps){
        if (!(step instanceof (0, $eOaGc.ReplaceStep) || step instanceof (0, $eOaGc.ReplaceAroundStep))) continue;
        const childCount = step.slice.content.childCount;
        for(let i = 0; i < childCount; i++){
            const child = step.slice.content.child(i);
            if (child.type.name === 'syncBlock' || child.type.name === 'bodiedSyncBlock') return true;
        }
    }
    return false;
};



const $92ceda184e2df47e$export$cb5a03b39dafc9cc = new (0, $kCECX.PluginKey)('syncedBlockPlugin');
const $92ceda184e2df47e$export$84cb2650bbe09e82 = new (0, $kCECX.PluginKey)('syncedBlockDeleteMechanism');
const $92ceda184e2df47e$var$syncedBlockPromptedFeedbackMetaKey = new (0, $kCECX.PluginKey)('syncedBlockPromptedFeedback');
const $92ceda184e2df47e$export$cde24468c2642688 = new (0, $kCECX.PluginKey)('syncedBlockCreationMeta');
const $92ceda184e2df47e$var$mapRetryCreationPosMap = (oldMap, newRetryCreationPos, mapPos)=>{
    const resourceId = newRetryCreationPos?.resourceId;
    // Fast path: no new entry and nothing to remap — return the same reference.
    // This is critical for PR-E (EDITOR-6929) which relies on reference equality
    // to short-circuit SharedStateAPI deep-equality checks.
    if (!resourceId && oldMap.size === 0) return oldMap;
    const newMap = new Map(oldMap);
    if (resourceId) {
        const { pos: pos } = newRetryCreationPos;
        if (!pos) newMap.delete(resourceId);
        else newMap.set(resourceId, pos);
    }
    if (newMap.size === 0) return newMap;
    for (const [id, pos] of newMap.entries())newMap.set(id, {
        from: mapPos(pos.from),
        to: mapPos(pos.to)
    });
    return newMap;
};
const $92ceda184e2df47e$var$showCopiedFlag = (api, isLivePage, isSourceContentUnpublished, sourceProduct)=>{
    (0, $04e29bf458c24792$export$fb2d0f31ec71c7e9)(()=>{
        api?.core.actions.execute(({ tr: tr })=>tr.setMeta($92ceda184e2df47e$export$cb5a03b39dafc9cc, {
                activeFlag: {
                    id: (0, $ec0a253b1ada3f34$export$5881677fb314e6d9).SYNC_BLOCK_COPIED,
                    isLivePage: isLivePage,
                    isSourceContentUnpublished: isSourceContentUnpublished,
                    sourceProduct: sourceProduct
                }
            }));
    });
};
const $92ceda184e2df47e$var$showExtensionInSyncBlockWarningIfNeeded = (tr, state, api, extensionFlagShown)=>{
    if (!tr.docChanged || tr.getMeta('isRemote') || Boolean(tr.getMeta((0, $2w79Z.pmHistoryPluginKey))) || (0, $jaFVy.isOfflineMode)(api?.connectivity?.sharedState.currentState()?.mode)) return;
    const resourceId = (0, $04e29bf458c24792$export$ecac802907d15d9a)(tr, state);
    // Only show the flag on the first instance per sync block (same as UNPUBLISHED_SYNC_BLOCK_PASTED)
    if (resourceId && !extensionFlagShown.has(resourceId)) {
        extensionFlagShown.add(resourceId);
        (0, $04e29bf458c24792$export$fb2d0f31ec71c7e9)(()=>{
            api?.core.actions.execute(({ tr: tr })=>tr.setMeta($92ceda184e2df47e$export$cb5a03b39dafc9cc, {
                    activeFlag: {
                        id: (0, $ec0a253b1ada3f34$export$5881677fb314e6d9).EXTENSION_IN_SYNC_BLOCK
                    }
                }));
        });
    }
};
const $92ceda184e2df47e$var$getDeleteReason = (tr)=>{
    const reason = tr.getMeta('deletionReason');
    if (!reason) return 'source-block-deleted';
    return reason;
};
/** Narrows the history plugin meta, matching the editor-plugin-card pattern. */ const $92ceda184e2df47e$var$isHistoryMeta = (meta)=>typeof meta === 'object' && meta !== null && 'redo' in meta && typeof meta.redo === 'boolean';
const $92ceda184e2df47e$export$d9923c7a8cbf31ed = (tr, state)=>{
    // Keep the legacy analytics classification unchanged while activation is off.
    // The stricter history, structural-step, and reference-selection handling is
    // only needed by the prompted feedback rollout.
    const isSyncBlockActivationEnabled = (0, $anBbz.expValEqualsNoExposure)('platform_editor_sync_block_activation', 'isEnabled', true);
    const historyMeta = tr.getMeta((0, $2w79Z.pmHistoryPluginKey));
    if (historyMeta) {
        if (isSyncBlockActivationEnabled && !$92ceda184e2df47e$var$isHistoryMeta(historyMeta)) return 'other';
        return $92ceda184e2df47e$var$isHistoryMeta(historyMeta) && historyMeta.redo ? 'redo' : 'undo';
    }
    // The toolbar Delete control tags its transaction so we can report it
    // distinctly from a keyboard delete (both produce a plain ReplaceStep).
    if (tr.getMeta($92ceda184e2df47e$export$84cb2650bbe09e82) === 'deleteButton') return 'deleteButton';
    const hasStructuralStep = isSyncBlockActivationEnabled && tr.steps.some((step)=>step instanceof (0, $eOaGc.ReplaceAroundStep));
    const hasReplaceStep = tr.steps.some((step)=>step instanceof (0, $eOaGc.ReplaceStep));
    if (hasStructuralStep || !hasReplaceStep) return 'other';
    const { selection: selection } = state;
    const isNodeSelected = selection instanceof (0, $kCECX.NodeSelection) && (selection.node?.type.name === 'bodiedSyncBlock' || isSyncBlockActivationEnabled && selection.node?.type.name === 'syncBlock');
    return isNodeSelected ? 'selectionReplaced' : 'keyboardDelete';
};
const $92ceda184e2df47e$export$9feff71901283088 = (mechanism)=>{
    if (mechanism === 'undo') return 'prompted-undo';
    if (mechanism === 'deleteButton' || mechanism === 'keyboardDelete' || mechanism === 'selectionReplaced') return 'prompted-delete';
    return undefined;
};
/**
 * True when a source `bodiedSyncBlock` holds user content — i.e. not just the
 * single empty paragraph it is created with (used to detect empty→content).
 */ const $92ceda184e2df47e$var$bodiedSyncBlockHasContent = (node)=>{
    if (node.childCount === 0) return false;
    if (node.childCount === 1) {
        const child = node.firstChild;
        // A freshly-created block is a single empty paragraph; anything else
        // (non-empty paragraph, or a different/first block) counts as content.
        return !(child?.type.name === 'paragraph' && child.content.size === 0);
    }
    return true;
};
/**
 * Ask the store manager to fire the one-shot first-content-added event for every
 * populated source block. The manager only emits for blocks it created empty
 * this session and dedupes per block, so iterating all populated blocks is safe
 * and self-limiting. Called only when `hasEditInSyncBlock` flagged an in-block
 * edit, so this walk runs rarely.
 */ const $92ceda184e2df47e$var$emitFirstContentAddedForEditedBlocks = (tr, state, syncBlockStore)=>{
    const { bodiedSyncBlock: bodiedSyncBlock } = state.schema.nodes;
    tr.doc.descendants((node)=>{
        if (node.type === bodiedSyncBlock) {
            if ($92ceda184e2df47e$var$bodiedSyncBlockHasContent(node)) syncBlockStore.sourceManager.maybeEmitFirstContentAdded(node.attrs.resourceId, node.attrs.localId);
            // bodiedSyncBlocks are top-level and not nested, so no need to descend.
            return false;
        }
        return true;
    });
};
const $92ceda184e2df47e$var$filterTransactionOnline = ({ tr: tr, state: state, syncBlockStore: syncBlockStore, api: api, confirmationTransactionRef: confirmationTransactionRef, ctx: ctx, bodiedSyncBlockRemoved: bodiedSyncBlockRemoved, bodiedSyncBlockAdded: bodiedSyncBlockAdded, extensionFlagShown: extensionFlagShown })=>{
    const { removed: syncBlockRemoved, added: syncBlockAdded } = (0, $96d8d664fb910a31$export$a1196481035d4d42)(syncBlockStore.referenceManager.isReferenceBlock, tr, state);
    syncBlockRemoved.forEach((syncBlock)=>{
        api?.analytics?.actions?.fireAnalyticsEvent({
            action: (0, $krYZG.ACTION).DELETED,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).SYNCED_BLOCK,
            actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).REFERENCE_SYNCED_BLOCK_DELETE,
            attributes: {
                resourceId: syncBlock.attrs.resourceId,
                blockInstanceId: syncBlock.attrs.localId
            },
            eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL
        });
    });
    // Annotate every reference-block insertion with `sourceProduct`
    // (derived from the resourceId) and `isPaste` (when the originating transaction was a
    // paste). Together with the host product reported by the embedding product's pageview
    // events this lets us triangulate cross-product paste behaviour without standing up a
    // dedicated `cross_product_paste` event subject.
    const isPaste = Boolean(tr.getMeta('paste') ?? tr.getMeta('uiEvent') === 'paste');
    const isPasteOrDrop = isPaste || tr.getMeta('uiEvent') === 'drop';
    const hasRemovedSyncBlock = syncBlockRemoved.length > 0 || bodiedSyncBlockRemoved.length > 0;
    const isCutRemoval = hasRemovedSyncBlock && ctx.consumeCutRemoval();
    const canPromptForRemoval = Boolean(ctx.onGiveFeedback) && hasRemovedSyncBlock && !(0, $jbOus.isDirtyTransaction)(tr) && !isCutRemoval && !isPasteOrDrop;
    const promptedFeedbackEntryPoint = canPromptForRemoval ? $92ceda184e2df47e$export$9feff71901283088($92ceda184e2df47e$export$d9923c7a8cbf31ed(tr, state)) : undefined;
    const entryPoint = promptedFeedbackEntryPoint && (0, $anBbz.expValEqualsNoExposure)('platform_editor_sync_block_activation', 'isEnabled', true) ? promptedFeedbackEntryPoint : undefined;
    if (entryPoint && syncBlockRemoved.length > 0 && bodiedSyncBlockRemoved.length === 0) tr.setMeta($92ceda184e2df47e$var$syncedBlockPromptedFeedbackMetaKey, {
        context: {
            blockType: 'reference',
            entryPoint: entryPoint
        }
    });
    syncBlockAdded.forEach((syncBlock)=>{
        api?.analytics?.actions?.fireAnalyticsEvent({
            action: (0, $krYZG.ACTION).INSERTED,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).DOCUMENT,
            actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).SYNCED_BLOCK,
            attributes: {
                resourceId: syncBlock.attrs.resourceId,
                blockInstanceId: syncBlock.attrs.localId,
                sourceProduct: (0, $d04Ge.getSourceProductFromResourceIdSafe)(syncBlock.attrs.resourceId),
                isPaste: isPaste
            },
            eventType: (0, $krYZG.EVENT_TYPE).TRACK
        });
    });
    if (bodiedSyncBlockRemoved.length > 0) {
        // Recompute the delete fresh from the live document on confirm
        // (see handleBodiedSyncBlockRemoval). See EDITOR-7889.
        const mechanism = $92ceda184e2df47e$export$d9923c7a8cbf31ed(tr, state);
        const feedbackContext = entryPoint && $92ceda184e2df47e$var$getDeleteReason(tr) !== 'source-block-unsynced' ? {
            blockType: 'source',
            entryPoint: entryPoint
        } : undefined;
        if (feedbackContext) {
            const sourceAttempt = ctx.queueSourceFeedback(feedbackContext);
            return (0, $60b0521823ac38c9$export$4d68be81d3ab4a0d)(bodiedSyncBlockRemoved, syncBlockStore, api, confirmationTransactionRef, $92ceda184e2df47e$var$getDeleteReason(tr), mechanism, {
                onDeleteCompleted: (success)=>ctx.completeSourceDeletion(sourceAttempt, success),
                onDeleteTransaction: (deleteTr)=>deleteTr.setMeta($92ceda184e2df47e$var$syncedBlockPromptedFeedbackMetaKey, {
                        context: feedbackContext,
                        sourceAttempt: sourceAttempt
                    }),
                onDestroy: ()=>ctx.clearSourceFeedback(sourceAttempt)
            });
        }
        return (0, $60b0521823ac38c9$export$4d68be81d3ab4a0d)(bodiedSyncBlockRemoved, syncBlockStore, api, confirmationTransactionRef, $92ceda184e2df47e$var$getDeleteReason(tr), mechanism, undefined);
    }
    if (bodiedSyncBlockAdded.length > 0) {
        if (tr.getMeta((0, $2w79Z.pmHistoryPluginKey))) // We don't allow bodiedSyncBlock creation via redo, however, we need to return true here to let transaction through so history can be updated properly.
        // If we simply returns false, creation from redo is blocked as desired, but this results in editor showing redo as possible even though it's not.
        // After true is returned here and the node is created, we delete the node in the filterTransaction immediately, which cancels out the creation
        return true;
        // Defense-in-depth: if a bodiedSyncBlock arrives via paste or drag-and-drop,
        // it may have bypassed transformCopied (e.g. cut, browser clipboard).
        // Do not call createBlock — it would use this page's parentId which may
        // be wrong. The bodiedSyncBlock content will still be inserted but will
        // not be registered as a source block in Block Service, which is safer
        // than creating a zombie block under the wrong ARI.
        if (isPasteOrDrop) return true;
        // Forward creation-type signals captured by createSyncedBlock onto the async
        // `syncedBlockCreate` success event.
        const creationMeta = tr.getMeta($92ceda184e2df47e$export$cde24468c2642688);
        (0, $978b73c23f40d240$export$4ef10a0a6b609715)(bodiedSyncBlockAdded, state, api, creationMeta);
        return true;
    }
    // On an in-block edit, let the store manager fire the one-shot first-content
    // event (dedupe + empty→content scoping live there). After the add/remove
    // branches so it never runs for the creation transaction itself.
    if ((0, $96d8d664fb910a31$export$7531459b60818a32)(tr, state)) $92ceda184e2df47e$var$emitFirstContentAddedForEditedBlocks(tr, state, syncBlockStore);
    $92ceda184e2df47e$var$showExtensionInSyncBlockWarningIfNeeded(tr, state, api, extensionFlagShown);
    return true;
};
const $92ceda184e2df47e$var$filterTransactionOffline = ({ tr: tr, state: state, syncBlockStore: syncBlockStore, api: api, isConfirmedSyncBlockDeletion: isConfirmedSyncBlockDeletion, bodiedSyncBlockRemoved: bodiedSyncBlockRemoved, bodiedSyncBlockAdded: bodiedSyncBlockAdded })=>{
    const { removed: syncBlockRemoved, added: syncBlockAdded } = (0, $96d8d664fb910a31$export$a1196481035d4d42)(syncBlockStore.referenceManager.isReferenceBlock, tr, state);
    let errorFlag = false;
    if (isConfirmedSyncBlockDeletion || bodiedSyncBlockRemoved.length > 0 || syncBlockRemoved.length > 0) errorFlag = (0, $ec0a253b1ada3f34$export$5881677fb314e6d9).CANNOT_DELETE_WHEN_OFFLINE;
    else if (bodiedSyncBlockAdded.length > 0 || syncBlockAdded.length > 0) errorFlag = (0, $ec0a253b1ada3f34$export$5881677fb314e6d9).CANNOT_CREATE_WHEN_OFFLINE;
    else if ((0, $96d8d664fb910a31$export$7531459b60818a32)(tr, state)) errorFlag = (0, $ec0a253b1ada3f34$export$5881677fb314e6d9).CANNOT_EDIT_WHEN_OFFLINE;
    if (errorFlag) {
        (0, $04e29bf458c24792$export$fb2d0f31ec71c7e9)(()=>{
            api?.core.actions.execute(({ tr: tr })=>tr.setMeta($92ceda184e2df47e$export$cb5a03b39dafc9cc, {
                    activeFlag: {
                        id: errorFlag
                    }
                }));
        });
        return false;
    }
    return true;
};
/**
 * Build the status decoration set for sync-block nodes. This performs a full
 * `doc.descendants()` walk so it must only be called when a status signal
 * actually changes (offline, view-mode, dragging, pending-creation). Between
 * status changes the caller should use `decorationSet.map(tr.mapping, tr.doc)`
 * instead (see EDITOR-6930).
 */ const $92ceda184e2df47e$var$buildStatusDecorations = (doc, syncBlockStore, isOffline, isViewMode, isDragging)=>{
    // Fast path: when all status flags are off and no creations are in flight,
    // no node can produce a decoration — skip the full doc traversal.
    if (!isOffline && !isViewMode && !isDragging && !syncBlockStore.sourceManager.hasPendingCreations()) return (0, $8nvEM.DecorationSet).empty;
    const offlineDecorations = [];
    const viewModeDecorations = [];
    const loadingDecorations = [];
    const dragDecorations = [];
    doc.descendants((node, pos)=>{
        if (node.type.name === 'bodiedSyncBlock' && isOffline) offlineDecorations.push((0, $8nvEM.Decoration).node(pos, pos + node.nodeSize, {
            class: (0, $95bQO.SyncBlockStateCssClassName).disabledClassName
        }));
        if (syncBlockStore.isSyncBlock(node) && isViewMode) viewModeDecorations.push((0, $8nvEM.Decoration).node(pos, pos + node.nodeSize, {
            class: (0, $95bQO.SyncBlockStateCssClassName).viewModeClassName
        }));
        if (node.type.name === 'bodiedSyncBlock' && syncBlockStore.sourceManager.isPendingCreation(node.attrs.resourceId)) loadingDecorations.push((0, $8nvEM.Decoration).node(pos, pos + node.nodeSize, {
            class: (0, $95bQO.SyncBlockStateCssClassName).creationLoadingClassName
        }));
        if (isDragging && syncBlockStore.isSyncBlock(node)) dragDecorations.push((0, $8nvEM.Decoration).node(pos, pos + node.nodeSize, {
            class: (0, $95bQO.SyncBlockStateCssClassName).draggingClassName
        }));
        // only traverse the top-level node of the document, as syncBlock and bodiedSyncBlock are top-level nodes
        return false;
    });
    return (0, $8nvEM.DecorationSet).create(doc, [
        ...offlineDecorations,
        ...viewModeDecorations,
        ...loadingDecorations,
        ...dragDecorations
    ]);
};
/**
 * Encapsulates mutable state that persists across transactions in the
 * synced block plugin. Replaces module-level closure variables so state
 * is explicitly scoped to a single plugin instance.
 */ class $92ceda184e2df47e$var$SyncedBlockPluginContext {
    get isCopyEvent() {
        return this._isCopyEvent;
    }
    markCopyEvent() {
        this._isCopyEvent = true;
    }
    markCutEvent() {
        this._isCutEvent = true;
    }
    consumeCopyEvent() {
        const was = this._isCopyEvent;
        this._isCopyEvent = false;
        return was;
    }
    consumeCutEvent() {
        const was = this._isCutEvent;
        this._isCutEvent = false;
        return was;
    }
    markCutRemovalPending() {
        this._cutRemovalPending = true;
        const generation = ++this.cutRemovalGeneration;
        queueMicrotask(()=>{
            if (this.cutRemovalGeneration === generation) this._cutRemovalPending = false;
        });
    }
    consumeCutRemoval() {
        const wasPending = this._cutRemovalPending;
        this._cutRemovalPending = false;
        this.cutRemovalGeneration += 1;
        return wasPending;
    }
    queueSourceFeedback(context) {
        const sourceAttempt = Symbol('syncedBlockSourceFeedbackAttempt');
        this.pendingSourceFeedback = {
            context: context,
            deletionSucceeded: false,
            sourceAttempt: sourceAttempt,
            transactionApplied: false
        };
        return sourceAttempt;
    }
    completeSourceDeletion(sourceAttempt, success) {
        if (this.pendingSourceFeedback?.sourceAttempt !== sourceAttempt) return;
        if (!success) // Keep the attempt pending because retryDeletion reuses these callbacks.
        // Dismissal or cancellation clears it through the destroy callback.
        return;
        this.pendingSourceFeedback.deletionSucceeded = true;
        this.flushSourceFeedback(sourceAttempt);
    }
    clearSourceFeedback(sourceAttempt) {
        if (this.pendingSourceFeedback?.sourceAttempt === sourceAttempt) this.pendingSourceFeedback = undefined;
    }
    handleAppliedFeedback({ context: context, sourceAttempt: sourceAttempt }) {
        if (context.blockType === 'source' && sourceAttempt && this.pendingSourceFeedback?.sourceAttempt === sourceAttempt) {
            this.pendingSourceFeedback.transactionApplied = true;
            this.flushSourceFeedback(sourceAttempt);
            return;
        }
        if (context.blockType === 'reference') this.requestFeedbackPrompt(context);
    }
    flushSourceFeedback(sourceAttempt) {
        if (this.pendingSourceFeedback?.sourceAttempt === sourceAttempt && this.pendingSourceFeedback?.deletionSucceeded && this.pendingSourceFeedback.transactionApplied) {
            const { context: context } = this.pendingSourceFeedback;
            this.pendingSourceFeedback = undefined;
            this.requestFeedbackPrompt(context);
        }
    }
    requestFeedbackPrompt(context) {
        if (this.feedbackPromptConsumed) return;
        this.feedbackPromptConsumed = true;
        (0, $04e29bf458c24792$export$fb2d0f31ec71c7e9)(()=>{
            try {
                const shouldShow = this.shouldShowFeedbackPrompt?.() ?? true;
                Promise.resolve(shouldShow).then((isEligible)=>{
                    if (!isEligible) return;
                    this.api?.core.actions.execute(({ tr: tr })=>tr.setMeta($92ceda184e2df47e$export$cb5a03b39dafc9cc, {
                            activeFlag: {
                                id: (0, $ec0a253b1ada3f34$export$5881677fb314e6d9).SYNC_BLOCK_FEEDBACK_PROMPT,
                                feedbackContext: context
                            }
                        }));
                }).catch(()=>{});
            } catch  {
            // Persisted feedback eligibility is optional product UI.
            }
        });
    }
    constructor(onGiveFeedback, shouldShowFeedbackPrompt, api){
        this.onGiveFeedback = onGiveFeedback;
        this.shouldShowFeedbackPrompt = shouldShowFeedbackPrompt;
        this.api = api;
        this.confirmationTransactionRef = {
            current: undefined
        };
        this._cutRemovalPending = false;
        this.cutRemovalGeneration = 0;
        this._isCopyEvent = false;
        this._isCutEvent = false;
        this.feedbackPromptConsumed = false;
        this.pendingSourceFeedback = void 0;
        this.unpublishedFlagShown = new Set();
        this.extensionFlagShown = new Set();
    }
}
const $92ceda184e2df47e$export$ae829ec7b2625219 = (options, pmPluginFactoryParams, syncBlockStore, api)=>{
    const { useLongPressSelection: useLongPressSelection = false } = options || {};
    const ctx = new $92ceda184e2df47e$var$SyncedBlockPluginContext(options?.onGiveFeedback, options?.shouldShowFeedbackPrompt, api);
    const confirmationTransactionRef = ctx.confirmationTransactionRef;
    const unpublishedFlagShown = ctx.unpublishedFlagShown;
    const extensionFlagShown = ctx.extensionFlagShown;
    // Update plugin state post-flush to sync hasUnsavedBodiedSyncBlockChanges.
    // It prevents false "Changes may not be saved" warnings when publishing
    // Classic pages with sync blocks.
    syncBlockStore.sourceManager.registerFlushCompletionCallback(()=>{
        (0, $04e29bf458c24792$export$fb2d0f31ec71c7e9)(()=>{
            api?.core.actions.execute(({ tr: tr })=>tr);
        });
    });
    // Trigger a deferred flush when block creation completes after the initial
    // flush timed out waiting for it. This ensures content created from
    // existing text is eventually persisted even if no further edits are made.
    // See EDITOR-7112.
    syncBlockStore.sourceManager.registerPostCreationFlushCallback(()=>{
        (0, $04e29bf458c24792$export$fb2d0f31ec71c7e9)(()=>{
            syncBlockStore.sourceManager.flush();
        });
    });
    // Set up callback to detect unpublished sync blocks when they're fetched
    syncBlockStore.referenceManager.setOnUnpublishedSyncBlockDetected((resourceId)=>{
        // Only show the flag once per sync block
        if (!unpublishedFlagShown.has(resourceId)) {
            unpublishedFlagShown.add(resourceId);
            // Surface the source product so the flag's copy can be tailored — Jira work
            // items get "Pasted from unsaved item" / "...when the item's description is
            // saved" rather than the Confluence page-flavoured default. Falls back to
            // undefined when the resourceId can't be parsed (legacy shapes), in which
            // case the Confluence default is used.
            const sourceProduct = (0, $d04Ge.getSourceProductFromResourceIdSafe)(resourceId);
            (0, $04e29bf458c24792$export$fb2d0f31ec71c7e9)(()=>{
                api?.core.actions.execute(({ tr: tr })=>tr.setMeta($92ceda184e2df47e$export$cb5a03b39dafc9cc, {
                        activeFlag: {
                            id: (0, $ec0a253b1ada3f34$export$5881677fb314e6d9).UNPUBLISHED_SYNC_BLOCK_PASTED,
                            sourceProduct: sourceProduct
                        }
                    }));
            });
        }
    });
    return new (0, $kpCD8.SafePlugin)({
        key: $92ceda184e2df47e$export$cb5a03b39dafc9cc,
        state: {
            init (_, instance) {
                // When the document has no synced blocks, we skip the eager fetch +
                // cache walks. They will be re-run lazily by `apply` the first time a
                // synced block enters the document (paste, collab insert, or
                // programmatic insert).
                const docHasSyncedBlocks = (0, $bb93622324819e61$export$cf93eddb8b14708a)(instance.doc);
                if (docHasSyncedBlocks) {
                    const syncBlockNodes = instance.doc.children.filter(syncBlockStore.referenceManager.isReferenceBlock);
                    syncBlockStore.referenceManager.fetchSyncBlocksData((0, $d04Ge.convertPMNodesToSyncBlockNodes)(syncBlockNodes));
                    // Populate source sync block cache from initial document.
                    // This replaces the constructor call in the nodeview.
                    instance.doc.forEach((node)=>{
                        if (syncBlockStore.sourceManager.isSourceBlock(node)) syncBlockStore.sourceManager.updateSyncBlockData(node, false);
                    });
                    // Fetch statuses from the backend so we can identify unpublished blocks on cancel
                    syncBlockStore.sourceManager.fetchAndCacheStatuses();
                }
                // Read initial shared-state signals for status decorations
                const initIsOffline = (0, $jaFVy.isOfflineMode)(api?.connectivity?.sharedState.currentState()?.mode);
                const initIsViewMode = api?.editorViewMode?.sharedState.currentState()?.mode === 'view';
                const initIsDragging = api?.userIntent?.sharedState.currentState()?.currentUserIntent === 'dragging';
                // Build initial status decoration set (EDITOR-6930).
                // When the perf gate is ON and the doc has synced blocks we do a
                // single traversal here; afterwards `apply()` will map or rebuild
                // only when a status signal changes.
                const initStatusDecorationSet = docHasSyncedBlocks ? $92ceda184e2df47e$var$buildStatusDecorations(instance.doc, syncBlockStore, initIsOffline, initIsViewMode, initIsDragging) : (0, $8nvEM.DecorationSet).empty;
                return {
                    selectionDecorationSet: (0, $895c7941d473c11e$export$aee83dbd972779dd)(instance.doc, instance.selection, instance.schema),
                    activeFlag: false,
                    syncBlockStore: syncBlockStore,
                    retryCreationPosMap: new Map(),
                    hasSyncedBlocks: docHasSyncedBlocks,
                    hasUnsavedBodiedSyncBlockChanges: syncBlockStore.sourceManager.hasUnsavedChanges(),
                    statusDecorationSet: initStatusDecorationSet,
                    prevIsOffline: initIsOffline,
                    prevIsViewMode: initIsViewMode,
                    prevIsDragging: initIsDragging
                };
            },
            apply: (tr, currentPluginState, oldEditorState)=>{
                const meta = tr.getMeta($92ceda184e2df47e$export$cb5a03b39dafc9cc);
                const { activeFlag: activeFlag, selectionDecorationSet: selectionDecorationSet, bodiedSyncBlockDeletionStatus: bodiedSyncBlockDeletionStatus, retryCreationPosMap: retryCreationPosMap, hasSyncedBlocks: prevHasSyncedBlocks, statusDecorationSet: prevStatusDecorationSet, prevIsOffline: prevOffline, prevIsViewMode: prevViewMode, prevIsDragging: prevDragging } = currentPluginState;
                // Pre-compute once so the fast-path probe and the bottom ref-equality
                // short-circuit share the same source-manager snapshot. Track C will make this O(1).
                const nextHasUnsavedBodiedSyncBlockChanges = syncBlockStore.sourceManager.hasUnsavedChanges();
                // --- Fast path (EDITOR-6934 follow-up, see Confluence 7050540723 §9.3 / §9.9):
                // when no plugin meta is set, and neither the document nor selection changed,
                // most synced-block plugin state cannot change. The source manager is mutable
                // outside ProseMirror transactions, though, so preserve existing empty-transaction
                // sync semantics by checking that snapshot first.
                //
                // Note: selection-only transactions intentionally fall through to the normal
                // apply path because calculateDecorations depends on drag/view-mode state
                // that is not captured here.
                //
                // We also need to ensure shared-state signals (drag, offline, view-mode)
                // haven't changed — these are propagated via empty transactions and drive
                // status decoration rebuilds (e.g. drag border). Without this check the
                // fast path would swallow drag-start transactions and the synced block
                // border would never appear (see VR test: synced-block-drag-selection).
                if (!meta && !tr.docChanged && tr.selection.eq(oldEditorState.selection) && nextHasUnsavedBodiedSyncBlockChanges === currentPluginState.hasUnsavedBodiedSyncBlockChanges && api?.userIntent?.sharedState.currentState()?.currentUserIntent === 'dragging' === prevDragging && (0, $jaFVy.isOfflineMode)(api?.connectivity?.sharedState.currentState()?.mode) === prevOffline && api?.editorViewMode?.sharedState.currentState()?.mode === 'view' === prevViewMode) return currentPluginState;
                // Lazy-init bookkeeping: once a synced block enters the document we
                // flip `hasSyncedBlocks` to `true` for the lifetime of this editor
                let nextHasSyncedBlocks = prevHasSyncedBlocks;
                if (!prevHasSyncedBlocks && tr.docChanged) {
                    if ((0, $9173991c8121bb66$export$d7a680e133c792af)(tr)) nextHasSyncedBlocks = true;
                }
                let newDecorationSet = tr.docChanged ? selectionDecorationSet.map(tr.mapping, tr.doc) // only map if document changed
                 : selectionDecorationSet;
                if (!tr.selection.eq(oldEditorState.selection)) newDecorationSet = (0, $895c7941d473c11e$export$aee83dbd972779dd)(tr.doc, tr.selection, tr.doc.type.schema);
                else if (tr.docChanged) {
                    const existingDecorationsLength = selectionDecorationSet.find().length;
                    const newDecorationsLength = newDecorationSet.find().length;
                    // Edge case: When document nodes are replaced, the mapping can lose decorations
                    // We rebuild decorations when the document changes but the selection hasn't.
                    // We can do this check because we only expect 1 decoration for the selection
                    if (existingDecorationsLength !== newDecorationsLength) newDecorationSet = (0, $895c7941d473c11e$export$aee83dbd972779dd)(tr.doc, tr.selection, tr.doc.type.schema);
                }
                // --- Status decoration set (EDITOR-6930) ---
                // When the perf gate is ON we maintain `statusDecorationSet` in
                // plugin state so the `decorations` prop becomes an O(1) lookup.
                let nextStatusDecorationSet = prevStatusDecorationSet;
                let nextIsOffline = prevOffline;
                let nextIsViewMode = prevViewMode;
                let nextIsDragging = prevDragging;
                if (!nextHasSyncedBlocks) // No synced blocks → keep empty status decorations
                nextStatusDecorationSet = (0, $8nvEM.DecorationSet).empty;
                else {
                    // Read current shared-state signals
                    nextIsOffline = (0, $jaFVy.isOfflineMode)(api?.connectivity?.sharedState.currentState()?.mode);
                    nextIsViewMode = api?.editorViewMode?.sharedState.currentState()?.mode === 'view';
                    nextIsDragging = api?.userIntent?.sharedState.currentState()?.currentUserIntent === 'dragging';
                    // Determine whether we need a full rebuild or a cheap map
                    const hasSyncedBlocksJustFlipped = nextHasSyncedBlocks && !prevHasSyncedBlocks;
                    const statusSignalChanged = nextIsOffline !== prevOffline || nextIsViewMode !== prevViewMode || nextIsDragging !== prevDragging;
                    // Meta-driven status changes (e.g. pending creation
                    // completed, retry creation pos updated)
                    const hasMetaStatusChange = !!meta?.retryCreationPos || !!meta?.activeFlag;
                    if (hasSyncedBlocksJustFlipped || statusSignalChanged || hasMetaStatusChange) // Full rebuild — a status signal changed
                    nextStatusDecorationSet = $92ceda184e2df47e$var$buildStatusDecorations(tr.doc, syncBlockStore, nextIsOffline, nextIsViewMode, nextIsDragging);
                    else if (tr.docChanged) // Cheap map — positions shifted but status unchanged
                    nextStatusDecorationSet = prevStatusDecorationSet.map(tr.mapping, tr.doc);
                // else: nothing changed, keep same reference
                }
                const newPosEntry = meta?.retryCreationPos;
                const newRetryCreationPosMap = $92ceda184e2df47e$var$mapRetryCreationPosMap(retryCreationPosMap, newPosEntry, tr.mapping.map.bind(tr.mapping));
                const nextActiveFlag = meta?.activeFlag ?? activeFlag;
                const nextBodiedSyncBlockDeletionStatus = meta?.bodiedSyncBlockDeletionStatus ?? bodiedSyncBlockDeletionStatus;
                // --- Reference equality (EDITOR-6929): return the same object
                // when ALL fields are reference-equal to avoid SharedStateAPI
                // notifying subscribers and triggering React re-renders. ---
                if (nextActiveFlag === activeFlag && newDecorationSet === selectionDecorationSet && newRetryCreationPosMap === retryCreationPosMap && nextHasSyncedBlocks === prevHasSyncedBlocks && nextBodiedSyncBlockDeletionStatus === bodiedSyncBlockDeletionStatus && nextHasUnsavedBodiedSyncBlockChanges === currentPluginState.hasUnsavedBodiedSyncBlockChanges && nextStatusDecorationSet === prevStatusDecorationSet && nextIsOffline === prevOffline && nextIsViewMode === prevViewMode && nextIsDragging === prevDragging) return currentPluginState;
                return {
                    activeFlag: nextActiveFlag,
                    selectionDecorationSet: newDecorationSet,
                    syncBlockStore: syncBlockStore,
                    retryCreationPosMap: newRetryCreationPosMap,
                    hasSyncedBlocks: nextHasSyncedBlocks,
                    bodiedSyncBlockDeletionStatus: nextBodiedSyncBlockDeletionStatus,
                    hasUnsavedBodiedSyncBlockChanges: nextHasUnsavedBodiedSyncBlockChanges,
                    statusDecorationSet: nextStatusDecorationSet,
                    prevIsOffline: nextIsOffline,
                    prevIsViewMode: nextIsViewMode,
                    prevIsDragging: nextIsDragging
                };
            }
        },
        props: {
            nodeViews: {
                syncBlock: (node, view, getPos, _decorations)=>// To support SSR, pass `syncBlockStore` here
                    // and do not use lazy loading.
                    // We cannot start rendering and then load `syncBlockStore` asynchronously,
                    // because obtaining it is asynchronous (sharedPluginState.currentState() is delayed).
                    new (0, $64e6e0cab8437f11$export$5dd7fae087dd8061)({
                        api: api,
                        options: options,
                        node: node,
                        view: view,
                        getPos: getPos,
                        portalProviderAPI: pmPluginFactoryParams.portalProviderAPI,
                        eventDispatcher: pmPluginFactoryParams.eventDispatcher,
                        syncBlockStore: syncBlockStore,
                        intl: pmPluginFactoryParams.getIntl()
                    }).init(),
                bodiedSyncBlock: (0, $d6e50e685ac89fcf$export$89bdce39123f4223)({
                    pluginOptions: options,
                    pmPluginFactoryParams: pmPluginFactoryParams,
                    api: api,
                    syncBlockStore: syncBlockStore
                })
            },
            decorations: (state)=>{
                const currentPluginState = $92ceda184e2df47e$export$cb5a03b39dafc9cc.getState(state);
                if (!currentPluginState) return (0, $8nvEM.DecorationSet).empty;
                const { selectionDecorationSet: selectionDecorationSet, statusDecorationSet: statusDecorationSet, hasSyncedBlocks: docHasSyncedBlocks } = currentPluginState;
                // When the perf gate is ON, both `selectionDecorationSet` and
                // `statusDecorationSet` are maintained in plugin state by
                // `apply()`. The `decorations` prop is now an O(1) merge of
                // the two cached sets — no `doc.descendants()` walk, no
                // shared-state reads.
                if (!docHasSyncedBlocks) return selectionDecorationSet;
                // Focus state is read live here (single cheap read) because
                // it only gates whether selection decorations are included —
                // it does not affect the status decoration set and can change
                // within the same transaction cycle.
                const hasFocus = api?.focus?.sharedState?.currentState()?.hasFocus ?? true;
                // Merge selection + status decorations.
                // When the editor is unfocused,
                // omit selection decorations (matches old behaviour).
                const statusDecorations = statusDecorationSet.find();
                if (statusDecorations.length === 0) return hasFocus ? selectionDecorationSet : (0, $8nvEM.DecorationSet).empty;
                else return hasFocus ? selectionDecorationSet.add(state.doc, statusDecorations) : statusDecorationSet;
            },
            handleClickOn: (0, $lp7sw.createSelectionClickHandler)([
                'bodiedSyncBlock'
            ], (target)=>!!target.closest(`.${(0, $95bQO.BodiedSyncBlockSharedCssClassName).prefix}`), {
                useLongPressSelection: useLongPressSelection
            }),
            handleDOMEvents: {
                mouseover (view, event) {
                    return (0, $6fe83dd5984ba2f3$export$6b191088ef76a6be)(view, event, api);
                },
                mousedown (view, event) {
                    return (0, $6fe83dd5984ba2f3$export$6b191088ef76a6be)(view, event, api);
                },
                copy: ()=>{
                    ctx.markCopyEvent();
                    return false;
                },
                cut: ()=>{
                    ctx.consumeCutEvent();
                    ctx.markCutEvent();
                    return false;
                }
            },
            transformPasted: (slice, _view)=>{
                // Defense against bodiedSyncBlock nodes arriving via paste
                // (e.g. drag-and-drop, cut-paste, or browser-level clipboard
                // operations that bypass the transformCopied handler).
                // We cannot convert to a syncBlock reference here because we don't
                // know the source page's parentId (generateResourceIdForReference
                // would use the current page's parentId which is wrong).
                // Instead, strip the bodiedSyncBlock wrapper and keep only the
                // inner content to prevent createBlock being called with the
                // wrong parentId.
                return (0, $fud2r.mapSlice)(slice, (node)=>{
                    if (node.type.name === 'bodiedSyncBlock' && node.attrs.resourceId) // Return the inner content without the sync block wrapper.
                    // This is the same behavior as when a partial selection of
                    // a bodiedSyncBlock is copied (see transformCopied line 937).
                    return node.content;
                    return node;
                });
            },
            transformCopied: (slice, { state: state })=>{
                const pluginState = $92ceda184e2df47e$export$cb5a03b39dafc9cc.getState(state);
                const syncBlockStore = pluginState?.syncBlockStore;
                const { schema: schema } = state;
                const isCopy = ctx.consumeCopyEvent();
                const isCut = ctx.consumeCutEvent();
                // A prompted feedback cut is always a cut, so the two never need combining.
                const isPromptedFeedbackCut = Boolean(syncBlockStore && options?.onGiveFeedback && isCut) && (0, $anBbz.expValEqualsNoExposure)('platform_editor_sync_block_activation', 'isEnabled', true);
                if (!syncBlockStore || !isCopy && !isCut) return slice;
                let containsCutSyncBlock = false;
                const transformedSlice = (0, $fud2r.mapSlice)(slice, (node)=>{
                    if (syncBlockStore.referenceManager.isReferenceBlock(node)) {
                        if (isCut) {
                            containsCutSyncBlock = isPromptedFeedbackCut;
                            return node;
                        }
                        $92ceda184e2df47e$var$showCopiedFlag(api, options?.__livePage, syncBlockStore.referenceManager.getFromCache(node.attrs.resourceId)?.data?.status === 'unpublished', (0, $d04Ge.getSourceProductFromResourceIdSafe)(node.attrs.resourceId));
                        return node;
                    }
                    if (node.type.name === 'bodiedSyncBlock' && node.attrs.resourceId) {
                        if (isPromptedFeedbackCut && (0, $04e29bf458c24792$export$384f6683328fd2fe)(slice, node)) containsCutSyncBlock = true;
                        // if we only selected part of the bodied sync block content,
                        // remove the sync block node and only keep the content
                        if (!(0, $04e29bf458c24792$export$384f6683328fd2fe)(slice, node)) return node.content;
                        if (isCut) return node;
                        const newResourceId = syncBlockStore.referenceManager.generateResourceIdForReference(node.attrs.resourceId);
                        $92ceda184e2df47e$var$showCopiedFlag(api, options?.__livePage, syncBlockStore.sourceManager.getStatus(node.attrs.resourceId) !== 'active', (0, $d04Ge.getSourceProductFromResourceIdSafe)(newResourceId));
                        // Convert bodiedSyncBlock to syncBlock
                        // The paste transformation will regenrate the localId
                        const newAttrs = {
                            ...node.attrs,
                            resourceId: newResourceId
                        };
                        const newMarks = schema.nodes.syncBlock.markSet ? node.marks.filter((mark)=>schema.nodes.syncBlock.markSet?.includes(mark.type)) : node.marks;
                        return schema.nodes.syncBlock.create(newAttrs, null, newMarks);
                    }
                    return node;
                });
                if (containsCutSyncBlock) ctx.markCutRemovalPending();
                return transformedSlice;
            }
        },
        filterTransaction: (tr, state)=>{
            // Lazy-init: when no synced block currently exists in the doc and the
            // transaction does not insert one, all downstream filter logic is a
            // no-op. Avoid both the shared-state reads and the `trackSyncBlocks`
            // walks for the ~99.97% of pages that have no synced blocks.
            const pluginState = $92ceda184e2df47e$export$cb5a03b39dafc9cc.getState(state);
            if (pluginState && !pluginState.hasSyncedBlocks && !(0, $9173991c8121bb66$export$d7a680e133c792af)(tr)) return true;
            const viewMode = api?.editorViewMode?.sharedState.currentState()?.mode;
            if (viewMode === 'view') return true;
            const isOffline = (0, $jaFVy.isOfflineMode)(api?.connectivity?.sharedState.currentState()?.mode);
            const isConfirmedSyncBlockDeletion = Boolean(tr.getMeta('isConfirmedSyncBlockDeletion'));
            // Track newly added reference sync blocks before processing the transaction
            if (tr.docChanged && !tr.getMeta('isRemote')) {
                const { added: added } = (0, $96d8d664fb910a31$export$a1196481035d4d42)(syncBlockStore.referenceManager.isReferenceBlock, tr, state);
                added.forEach((nodeInfo)=>{
                    if (nodeInfo.attrs?.resourceId) syncBlockStore.referenceManager.markAsNewlyAdded(nodeInfo.attrs.resourceId);
                });
            }
            // if doc changed and it's a remote transaction, check if any synced block were added,
            // and if so, for source synced blocks, ensure we update the cache with them
            // and for reference synced blocks, ensure we fetch the data from the server
            if (tr.docChanged && tr.getMeta('isRemote')) {
                const { added: added } = (0, $96d8d664fb910a31$export$a1196481035d4d42)((node)=>syncBlockStore.isSyncBlock(node), tr, state);
                const sourceSyncBlockNodes = added.filter((nodeInfo)=>nodeInfo.node && syncBlockStore.sourceManager.isSourceBlock(nodeInfo.node));
                const referenceSyncBlockNodes = added.filter((nodeInfo)=>nodeInfo.node && syncBlockStore.referenceManager.isReferenceBlock(nodeInfo.node));
                sourceSyncBlockNodes.forEach((nodeInfo)=>{
                    if (nodeInfo.attrs?.resourceId && nodeInfo.node) syncBlockStore.sourceManager.updateSyncBlockData(nodeInfo.node, tr.getMeta('isRemote'));
                });
                // Fetch statuses for remotely-added source sync blocks
                // so we can identify unpublished blocks on cancel
                if (sourceSyncBlockNodes.length > 0) syncBlockStore.sourceManager.fetchAndCacheStatuses();
                const syncBlockNodes = referenceSyncBlockNodes.map((nodeInfo)=>nodeInfo.node).filter((node)=>node !== undefined);
                syncBlockStore.referenceManager.fetchSyncBlocksData((0, $d04Ge.convertPMNodesToSyncBlockNodes)(syncBlockNodes));
            }
            if (!tr.docChanged || Boolean(tr.getMeta('isRemote')) || !isOffline && isConfirmedSyncBlockDeletion) return true;
            const { removed: bodiedSyncBlockRemoved, added: bodiedSyncBlockAdded } = (0, $96d8d664fb910a31$export$a1196481035d4d42)(syncBlockStore.sourceManager.isSourceBlock, tr, state);
            return isOffline ? $92ceda184e2df47e$var$filterTransactionOffline({
                tr: tr,
                state: state,
                syncBlockStore: syncBlockStore,
                api: api,
                isConfirmedSyncBlockDeletion: isConfirmedSyncBlockDeletion,
                bodiedSyncBlockRemoved: bodiedSyncBlockRemoved,
                bodiedSyncBlockAdded: bodiedSyncBlockAdded
            }) : $92ceda184e2df47e$var$filterTransactionOnline({
                tr: tr,
                state: state,
                syncBlockStore: syncBlockStore,
                api: api,
                confirmationTransactionRef: confirmationTransactionRef,
                ctx: ctx,
                bodiedSyncBlockRemoved: bodiedSyncBlockRemoved,
                bodiedSyncBlockAdded: bodiedSyncBlockAdded,
                extensionFlagShown: extensionFlagShown
            });
        },
        appendTransaction: (trs, oldState, newState)=>{
            // Lazy-init: when neither the previous nor the new state contains a
            // synced block (and none of the dispatched transactions inserts one),
            // skip all downstream work. This is the hot path on the ~99.97% of
            // pages that don't use synced blocks (see EDITOR-6586).
            const oldPluginState = $92ceda184e2df47e$export$cb5a03b39dafc9cc.getState(oldState);
            const newPluginState = $92ceda184e2df47e$export$cb5a03b39dafc9cc.getState(newState);
            const hadOrHasSyncedBlocks = !!oldPluginState?.hasSyncedBlocks || !!newPluginState?.hasSyncedBlocks;
            if (!hadOrHasSyncedBlocks) return null;
            const viewMode = api?.editorViewMode?.sharedState.currentState()?.mode;
            if (viewMode === 'view') return null;
            if (options?.onGiveFeedback) {
                const feedbackContexts = trs.flatMap((tr)=>{
                    const feedbackContext = tr.getMeta($92ceda184e2df47e$var$syncedBlockPromptedFeedbackMetaKey);
                    return feedbackContext ? [
                        feedbackContext
                    ] : [];
                });
                if (feedbackContexts.length > 0 && (0, $anBbz.expValEqualsNoExposure)('platform_editor_sync_block_activation', 'isEnabled', true)) feedbackContexts.forEach((feedbackContext)=>{
                    ctx.handleAppliedFeedback(feedbackContext);
                });
            }
            // Update source sync block cache for user-initiated changes only.
            // Cache updates are handled here instead of in the nodeview update() so we
            // can filter out non-user changes (remote collab, dirty programmatic txns).
            const isUserChange = (tr)=>tr.docChanged && !(0, $jbOus.isDirtyTransaction)(tr) && !tr.getMeta('isRemote');
            const hasSourceBlockEdit = trs.some((tr)=>isUserChange(tr) && (0, $96d8d664fb910a31$export$7531459b60818a32)(tr, oldState));
            if (hasSourceBlockEdit) newState.doc.forEach((node)=>{
                if (syncBlockStore.sourceManager.isSourceBlock(node)) syncBlockStore.sourceManager.updateSyncBlockData(node, false);
            });
            for (const tr of trs)if (tr.getMeta((0, $2w79Z.pmHistoryPluginKey))) {
                const { added: added } = (0, $96d8d664fb910a31$export$a1196481035d4d42)(syncBlockStore.sourceManager.isSourceBlock, tr, oldState);
                if (added.length > 0) {
                    // Delete bodiedSyncBlock if it's originated from history, i.e. redo creation
                    // See filterTransaction above for more details
                    const { tr: tr } = newState;
                    added.forEach((node)=>{
                        if (node.from !== undefined && node.to !== undefined) tr.delete(node.from, node.to);
                    });
                    return tr;
                }
            }
            // Detect and remove duplicate bodiedSyncBlock resourceIds.
            // When a block template containing a source sync block is inserted into the
            // same document, it creates a duplicate with the same resourceId. We keep the
            // first occurrence and delete subsequent duplicates entirely (including their
            // contents), since a document must not contain two source sync blocks with the
            // same resourceId.
            if (trs.some((tr)=>tr.docChanged && !tr.getMeta('isRemote'))) {
                // Quick check: only walk the full document when at least one
                // transaction inserted a source synced block. This avoids an
                // expensive descendants() traversal on every local edit.
                const hasInsertedSourceBlock = trs.some((tr)=>{
                    if (!tr.docChanged || tr.getMeta('isRemote')) return false;
                    return tr.steps.some((step)=>{
                        if (!(step instanceof (0, $eOaGc.ReplaceStep) || step instanceof (0, $eOaGc.ReplaceAroundStep)) || !('slice' in step)) return false;
                        const { slice: slice } = step;
                        let found = false;
                        slice.content.descendants((node)=>{
                            if (syncBlockStore.sourceManager.isSourceBlock(node) && node.attrs.resourceId) found = true;
                            return false;
                        });
                        return found;
                    });
                });
                if (!hasInsertedSourceBlock) return null;
                const seenResourceIds = new Set();
                const duplicates = [];
                newState.doc.descendants((node, pos)=>{
                    if (syncBlockStore.sourceManager.isSourceBlock(node) && node.attrs.resourceId) {
                        if (seenResourceIds.has(node.attrs.resourceId)) duplicates.push({
                            pos: pos,
                            nodeSize: node.nodeSize
                        });
                        else seenResourceIds.add(node.attrs.resourceId);
                        return false;
                    }
                });
                if (duplicates.length > 0) {
                    const { tr: tr } = newState;
                    // Delete in reverse document order so positions remain valid
                    for(let i = duplicates.length - 1; i >= 0; i--){
                        const dup = duplicates[i];
                        tr.delete(dup.pos, dup.pos + dup.nodeSize);
                    }
                    tr.setMeta('addToHistory', false);
                    (0, $04e29bf458c24792$export$fb2d0f31ec71c7e9)(()=>{
                        api?.core?.actions.execute(({ tr: tr })=>tr.setMeta($92ceda184e2df47e$export$cb5a03b39dafc9cc, {
                                activeFlag: {
                                    id: (0, $ec0a253b1ada3f34$export$5881677fb314e6d9).DUPLICATE_SOURCE_SYNC_BLOCK
                                }
                            }));
                    });
                    return tr;
                }
            }
            return null;
        }
    });
};




const $98a9fe325c1fc315$export$ce51166f6717ba9c = (state, localId)=>{
    let result;
    state.doc.descendants((node, pos)=>{
        if (result) return false;
        if (node.type === state.schema.nodes.bodiedSyncBlock && node.attrs.localId === localId) {
            result = {
                node: node,
                pos: pos
            };
            return false;
        }
        return true;
    });
    return result;
};
const $98a9fe325c1fc315$export$a97704a00c7e213a = (contentDOM, view)=>{
    const tmpDiv = document.createElement('div');
    tmpDiv.appendChild(contentDOM);
    // This is required so that prosemirror can read the fragment context and slice properly
    if (tmpDiv.firstChild instanceof HTMLElement) {
        tmpDiv.firstChild.setAttribute('data-pm-slice', '0 0 []');
        // As per requirement - when unsync reference block, it should render its content as copy&paste behaviour
        // Hence here we call pasteHTML to evoke editor paste logic that handles any unsupported nodes/marks
        return view.pasteHTML(tmpDiv.innerHTML);
    }
    return false;
};


/**
 * Place the caret on the first editable position inside the newly created bodied
 * sync block, identified by its unique localId.
 *
 * - Empty selection: lands inside the block's empty paragraph.
 * - Converted content: lands at the start of the first editable child.
 *
 * `createSyncedBlock` builds the node but neither `safeInsert` (empty case) nor
 * `replaceWith` (convert case) leaves the selection inside the new block, so
 * without this the caret ends up outside/adjacent to the block after creation
 * from the block menu or toolbar (EDITOR-7949). The typeahead path avoids this
 * because `typeAheadInsert` positions the caret for us.
 *
 * Note: when created from the block menu, block-controls' selection preservation
 * is active and will restore a whole-node NodeSelection over this caret. The
 * caller (block-menu item) is responsible for calling `stopPreservingSelection`
 * in the same flow so the caret survives — mirroring the block-menu delete item.
 */ const $4d68281089368b28$var$placeCaretInsideBodiedSyncBlock = (tr, localId)=>{
    const bodiedSyncBlockType = tr.doc.type.schema.nodes.bodiedSyncBlock;
    let blockPos;
    tr.doc.descendants((node, pos)=>{
        if (blockPos !== undefined) return false;
        if (node.type === bodiedSyncBlockType && node.attrs.localId === localId) {
            blockPos = pos;
            return false;
        }
        return true;
    });
    if (blockPos === undefined) return tr;
    // Find the first valid text position at or after the block's start. `findFrom`
    // with textOnly=true descends into the first editable child (empty paragraph or
    // start of the converted content), which is exactly what we want for both cases.
    const selection = (0, $kCECX.Selection).findFrom(tr.doc.resolve(blockPos), 1, true);
    if (selection) tr.setSelection(selection).scrollIntoView();
    else // Fallback: `bodiedSyncBlock` is always created with a paragraph as its first
    // child, so a text position should always be found above. This guards against
    // future schema changes where the first child isn't immediately text-editable
    // — place the caret just inside the block rather than leaving it outside.
    // `blockPos + 1` is the position immediately after the block's opening token,
    // which is a node boundary rather than a valid text position, so use
    // `TextSelection.near` to snap forward to the nearest selectable cursor. It
    // also clamps to the document bounds internally, so no explicit end-of-doc
    // check is required.
    tr.setSelection((0, $kCECX.TextSelection).near(tr.doc.resolve(blockPos + 1), 1)).scrollIntoView();
    return tr;
};
const $4d68281089368b28$export$fbc30658d812c800 = ({ tr: tr, syncBlockStore: syncBlockStore, typeAheadInsert: typeAheadInsert, fireAnalyticsEvent: fireAnalyticsEvent, inputMethod: inputMethod })=>{
    const { schema: { nodes: { bodiedSyncBlock: bodiedSyncBlock, paragraph: paragraph } } } = tr.doc.type;
    // Capture createdEmpty before any insertion mutates the selection. The meta is
    // set on the final transaction before returning (see below), since the
    // typeahead path may reassign `tr` and drop meta set here.
    const createdEmpty = tr.selection.empty;
    // If the selection is empty, we want to insert the sync block on a new line
    if (tr.selection.empty) {
        const attrs = syncBlockStore.sourceManager.generateBodiedSyncBlockAttrs();
        const paragraphNode = paragraph.createAndFill({});
        const newBodiedSyncBlockNode = bodiedSyncBlock.createAndFill(attrs, paragraphNode ? [
            paragraphNode
        ] : []);
        if (!newBodiedSyncBlockNode) {
            fireAnalyticsEvent?.({
                action: (0, $krYZG.ACTION).ERROR,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).SYNCED_BLOCK,
                actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).SYNCED_BLOCK_CREATE,
                attributes: {
                    error: 'Create and fill for empty content failed'
                },
                eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL
            });
            return false;
        }
        if (typeAheadInsert) tr = typeAheadInsert(newBodiedSyncBlockNode);
        else {
            tr = (0, $bjg0G.safeInsert)(newBodiedSyncBlockNode)(tr).scrollIntoView();
            // safeInsert does not move the selection into the new block, so place the
            // caret inside the block's empty paragraph so typing continues inside the
            // synced block (EDITOR-7949).
            tr = $4d68281089368b28$var$placeCaretInsideBodiedSyncBlock(tr, newBodiedSyncBlockNode.attrs.localId);
        }
    } else {
        const conversionInfo = (0, $04e29bf458c24792$export$a912fa82dfd54783)(tr.selection);
        if (!conversionInfo) {
            fireAnalyticsEvent?.({
                action: (0, $krYZG.ACTION).ERROR,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).SYNCED_BLOCK,
                actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).SYNCED_BLOCK_CREATE,
                attributes: {
                    error: 'Content cannot be converted to sync block'
                },
                eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL
            });
            return false;
        }
        const attrs = syncBlockStore.sourceManager.generateBodiedSyncBlockAttrs();
        const newBodiedSyncBlockNode = bodiedSyncBlock.createAndFill(attrs, conversionInfo.contentToInclude, (0, $iDrrr.fg)('platform_editor_blocks_patch_8') && conversionInfo.breakoutMark ? [
            conversionInfo.breakoutMark
        ] : undefined);
        if (!newBodiedSyncBlockNode) {
            fireAnalyticsEvent?.({
                action: (0, $krYZG.ACTION).ERROR,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).SYNCED_BLOCK,
                actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).SYNCED_BLOCK_CREATE,
                attributes: {
                    error: 'Create and fill for content failed'
                },
                eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL
            });
            return false;
        }
        tr.replaceWith(conversionInfo.from, conversionInfo.to, newBodiedSyncBlockNode).scrollIntoView();
        // Place the caret on the first editable position inside the converted
        // content so typing continues inside the synced block (EDITOR-7949).
        tr = $4d68281089368b28$var$placeCaretInsideBodiedSyncBlock(tr, newBodiedSyncBlockNode.attrs.localId);
    }
    // Stash creation-type signals on the final transaction (after any typeahead
    // reassignment). Set unconditionally — the store manager only reads it behind
    // the feature gate.
    tr.setMeta((0, $92ceda184e2df47e$export$cde24468c2642688), {
        createdEmpty: createdEmpty,
        inputMethod: inputMethod
    });
    return tr;
};
const $4d68281089368b28$export$c461f640005976aa = (syncBlockStore, inputMethod, api, isLivePage)=>({ tr: tr })=>{
        if ($4d68281089368b28$var$copySyncedBlockReferenceToClipboardInternal(tr.doc.type.schema, tr.selection, syncBlockStore, inputMethod, api, isLivePage)) return tr;
        return null;
    };
const $4d68281089368b28$export$cdf949b884fe546d = (syncBlockStore, inputMethod, api, isLivePage)=>(state, _dispatch, _view)=>$4d68281089368b28$var$copySyncedBlockReferenceToClipboardInternal(state.tr.doc.type.schema, state.tr.selection, syncBlockStore, inputMethod, api, isLivePage);
const $4d68281089368b28$var$copySyncedBlockReferenceToClipboardInternal = (schema, selection, syncBlockStore, inputMethod, api, isLivePage)=>{
    const syncBlockFindResult = (0, $04e29bf458c24792$export$72f89723ce6d6fa3)(schema, selection);
    if (!syncBlockFindResult) {
        api?.analytics?.actions?.fireAnalyticsEvent({
            eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
            action: (0, $krYZG.ACTION).ERROR,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).SYNCED_BLOCK,
            actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).SYNCED_BLOCK_COPY,
            attributes: {
                error: 'No sync block found in selection',
                inputMethod: inputMethod
            }
        });
        return false;
    }
    const isBodiedSyncBlock = (0, $04e29bf458c24792$export$5f971aa95a01794c)(syncBlockFindResult.node, schema.nodes.bodiedSyncBlock);
    let referenceSyncBlockNode = null;
    if (isBodiedSyncBlock) {
        const { nodes: { syncBlock: syncBlock } } = schema;
        // create sync block reference node
        referenceSyncBlockNode = syncBlock.createAndFill({
            resourceId: syncBlockStore.referenceManager.generateResourceIdForReference(syncBlockFindResult.node.attrs.resourceId)
        });
        if (!referenceSyncBlockNode) {
            api?.analytics?.actions?.fireAnalyticsEvent({
                eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
                action: (0, $krYZG.ACTION).ERROR,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).SYNCED_BLOCK,
                actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).SYNCED_BLOCK_COPY,
                attributes: {
                    error: 'Failed to create reference sync block node',
                    resourceId: syncBlockFindResult.node.attrs.resourceId,
                    inputMethod: inputMethod
                }
            });
            return false;
        }
    } else referenceSyncBlockNode = syncBlockFindResult.node;
    if (!referenceSyncBlockNode) {
        api?.analytics?.actions?.fireAnalyticsEvent({
            eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
            action: (0, $krYZG.ACTION).ERROR,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).SYNCED_BLOCK,
            actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).SYNCED_BLOCK_COPY,
            attributes: {
                error: 'No reference sync block node available',
                inputMethod: inputMethod
            }
        });
        return false;
    }
    const domNode = (0, $1TzXg.toDOM)(referenceSyncBlockNode, schema);
    // Bare-uuid join key shared with the create/delete events: for a source
    // bodiedSyncBlock its `localId` is the source uuid (copy was page-form only).
    const sourceJoinKey = isBodiedSyncBlock ? syncBlockFindResult.node.attrs.localId : undefined;
    const isSourceContentUnpublished = isBodiedSyncBlock ? syncBlockStore.sourceManager.getStatus(syncBlockFindResult.node.attrs.resourceId) !== 'active' : syncBlockStore.referenceManager.getFromCache(referenceSyncBlockNode.attrs.resourceId)?.data?.status === 'unpublished';
    const sourceProduct = (0, $d04Ge.getSourceProductFromResourceIdSafe)(referenceSyncBlockNode.attrs.resourceId);
    const copyResult = (0, $1TzXg.copyDomNodeWithResult)(domNode, referenceSyncBlockNode.type, selection);
    if (copyResult === false) {
        api?.analytics?.actions?.fireAnalyticsEvent({
            eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
            action: (0, $krYZG.ACTION).ERROR,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).SYNCED_BLOCK,
            actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).SYNCED_BLOCK_COPY,
            attributes: {
                error: 'Failed to copy synced block to clipboard',
                resourceId: referenceSyncBlockNode.attrs.resourceId,
                inputMethod: inputMethod
            }
        });
        return false;
    }
    (0, $04e29bf458c24792$export$fb2d0f31ec71c7e9)(()=>{
        api?.core.actions.execute(({ tr: tr })=>{
            api?.analytics?.actions?.fireAnalyticsEvent({
                eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
                action: (0, $krYZG.ACTION).COPIED,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).SYNCED_BLOCK,
                actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).SYNCED_BLOCK_COPY,
                attributes: {
                    resourceId: referenceSyncBlockNode.attrs.resourceId,
                    inputMethod: inputMethod,
                    ...sourceJoinKey && {
                        blockInstanceId: sourceJoinKey
                    }
                }
            });
            return tr.setMeta((0, $92ceda184e2df47e$export$cb5a03b39dafc9cc), {
                activeFlag: {
                    id: (0, $ec0a253b1ada3f34$export$5881677fb314e6d9).SYNC_BLOCK_COPIED,
                    isLivePage: isLivePage,
                    isSourceContentUnpublished: isSourceContentUnpublished,
                    sourceProduct: sourceProduct
                }
            });
        });
    });
    return true;
};
const $4d68281089368b28$export$3a389eb361f43fd = (syncBlockStore, api)=>(state, dispatch, _view)=>{
        const syncBlock = (0, $04e29bf458c24792$export$8e2da6078c69a0c6)(state.schema, state.selection);
        const resourceId = syncBlock?.node?.attrs?.resourceId;
        if (!resourceId) return false;
        const syncBlockURL = syncBlockStore.referenceManager.getSyncBlockURL(resourceId);
        const syncBlockData = syncBlockStore.referenceManager.getFromCache(resourceId)?.data;
        const isOnSameDocument = syncBlockData?.onSameDocument === true;
        const sourceBlock = isOnSameDocument && syncBlockData ? (0, $98a9fe325c1fc315$export$ce51166f6717ba9c)(state, syncBlockData.blockInstanceId) : undefined;
        if (syncBlockURL) {
            api?.analytics?.actions.fireAnalyticsEvent({
                eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
                action: (0, $krYZG.ACTION).SYNCED_BLOCK_EDIT_SOURCE,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).SYNCED_BLOCK,
                actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).SYNCED_BLOCK_SOURCE_URL,
                attributes: {
                    resourceId: resourceId,
                    sameDocument: isOnSameDocument
                }
            });
            if (sourceBlock) {
                const tr = state.tr.setSelection((0, $kCECX.NodeSelection).create(state.doc, sourceBlock.pos)).scrollIntoView();
                dispatch?.(tr);
                return true;
            }
            window.open(syncBlockURL, '_blank');
        } else {
            const { tr: tr } = state;
            api?.analytics?.actions?.attachAnalyticsEvent({
                eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
                action: (0, $krYZG.ACTION).ERROR,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).SYNCED_BLOCK,
                actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).SYNCED_BLOCK_SOURCE_URL,
                attributes: {
                    error: 'No URL resolved for synced block'
                }
            })(tr);
            dispatch?.(tr);
        }
        return true;
    };
const $4d68281089368b28$export$1c38da93cd68ba6d = (api)=>(state, dispatch, _view)=>{
        const { schema: { nodes: nodes }, tr: tr } = state;
        if (!dispatch) return false;
        let removeTr = tr;
        if ((0, $bjg0G.findSelectedNodeOfType)(nodes.syncBlock)(tr.selection) || (0, $bjg0G.findSelectedNodeOfType)(nodes.bodiedSyncBlock)(tr.selection)) removeTr = (0, $bjg0G.removeSelectedNode)(tr);
        else removeTr = (0, $bjg0G.removeParentNodeOfType)(nodes.bodiedSyncBlock)(tr);
        if (!removeTr) return false;
        // Tag the transaction so analytics can report this as `deleteButton` rather
        // than a keyboard delete (both produce a plain ReplaceStep).
        removeTr.setMeta((0, $92ceda184e2df47e$export$84cb2650bbe09e82), 'deleteButton');
        dispatch(removeTr);
        api?.core.actions.focus();
        return true;
    };
const $4d68281089368b28$export$8d571a58cfd57507 = (api, pos)=>{
    api?.core.actions.execute(({ tr: tr })=>{
        const node = tr.doc.nodeAt(pos);
        if (node?.type.name === 'syncBlock') {
            const removeTr = tr.replace(pos, pos + (node?.nodeSize ?? 0));
            if ((0, $anBbz.expValEqualsNoExposure)('platform_editor_sync_block_activation', 'isEnabled', true)) removeTr.setMeta((0, $92ceda184e2df47e$export$84cb2650bbe09e82), 'deleteButton');
            return removeTr;
        }
        return tr;
    });
};
const $4d68281089368b28$export$e44cd24c4e3ac750 = (storeManager, isBodiedSyncBlock, view)=>{
    if (!view) return false;
    const { state: state } = view;
    const syncBlock = (0, $04e29bf458c24792$export$72f89723ce6d6fa3)(state.schema, state.selection);
    if (!syncBlock) return false;
    if (isBodiedSyncBlock) {
        // Signal the unsync intent. This transaction is intercepted by the plugin's
        // filterTransaction, which shows the deletion-confirmation modal and, on confirm,
        // recomputes the actual document change from the live document keyed off the
        // `deletionReason: 'source-block-unsynced'` meta (see handleBodiedSyncBlockRemoval /
        // recomputeUnsyncTransaction). The real unwrap-vs-delete decision therefore lives in the
        // confirm path, not here (EDITOR-8230).
        const content = syncBlock?.node.content;
        const { tr: tr } = state;
        tr.replaceWith(syncBlock.pos, syncBlock.pos + syncBlock.node.nodeSize, content).setMeta('deletionReason', 'source-block-unsynced');
        view.dispatch(tr);
        return true;
    }
    // handle syncBlock unsync
    const syncBlockContent = storeManager.referenceManager.getFromCache(syncBlock.node.attrs.resourceId)?.data?.content;
    if (!syncBlockContent) return false;
    // use defaultSchema for serialization so we can serialize any type of nodes and marks despite current editor's schema might not allow it
    const contentFragment = (0, $aPdNQ.Fragment).fromJSON((0, $4XbfY.defaultSchema), syncBlockContent);
    const contentDOM = (0, $aPdNQ.DOMSerializer).fromSchema((0, $4XbfY.defaultSchema)).serializeFragment(contentFragment);
    return (0, $98a9fe325c1fc315$export$a97704a00c7e213a)(contentDOM, view);
};










var $dp5Fv = parcelRequire("dp5Fv");

var $ezEf7 = parcelRequire("ezEf7");

var $brnfH = parcelRequire("brnfH");

var $6NW7h = parcelRequire("6NW7h");
/**
 * Checks if a node matches or contains the node given by the provided query css selector
 *
 * @param query - CSS selector string
 * @returns true if node matches or contains query or false otherwise
 */ const $3d4bbf22d1dcb0b8$export$a3814e00999abbb7 = (query)=>(node)=>{
        if (!node || !(node instanceof Element)) return false;
        return node.matches(query) || node.querySelector(query) !== null;
    };


var $jw4KW = parcelRequire("jw4KW");

var $bYHr8 = parcelRequire("bYHr8");

var $6X62h = parcelRequire("6X62h");









const $ffc7cbcf63c6d9c3$var$TIMEOUT_DURATION = 30000;
const $ffc7cbcf63c6d9c3$var$pluginKey = new (0, $kCECX.PluginKey)('syncedBlockMenuAndToolbarExperience');
const $ffc7cbcf63c6d9c3$var$SYNCED_BLOCK_BUTTON_TEST_IDS = Object.values((0, $ec0a253b1ada3f34$export$ce5236bf4eef2662));
const $ffc7cbcf63c6d9c3$var$syncedBlockButtonIds = new Set($ffc7cbcf63c6d9c3$var$SYNCED_BLOCK_BUTTON_TEST_IDS);
const $ffc7cbcf63c6d9c3$export$8e0a561331eb68ce = ({ refs: refs, dispatchAnalyticsEvent: dispatchAnalyticsEvent })=>{
    let popupsTargetEl;
    const editorViewRef = {
        current: undefined
    };
    const getPopupsTarget = ()=>{
        if (!popupsTargetEl) popupsTargetEl = refs.popupsMountPoint || refs.wrapperElement || (0, $jw4KW.getPopupContainerFromEditorView)(editorViewRef?.current?.dom);
        return popupsTargetEl;
    };
    const createSourcePrimaryToolbarExperience = new (0, $dp5Fv.Experience)((0, $ezEf7.EXPERIENCE_ID).TOOLBAR_ACTION, {
        action: (0, $krYZG.ACTION).SYNCED_BLOCK_CREATE,
        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).PRIMARY_TOOLBAR,
        dispatchAnalyticsEvent: dispatchAnalyticsEvent,
        checks: [
            new (0, $6NW7h.ExperienceCheckTimeout)({
                durationMs: $ffc7cbcf63c6d9c3$var$TIMEOUT_DURATION
            }),
            $ffc7cbcf63c6d9c3$var$syncedBlockAddedToDomCheck(refs, editorViewRef)
        ]
    });
    const createSourceBlockMenuExperience = new (0, $dp5Fv.Experience)((0, $ezEf7.EXPERIENCE_ID).MENU_ACTION, {
        action: (0, $krYZG.ACTION).SYNCED_BLOCK_CREATE,
        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).BLOCK_MENU,
        dispatchAnalyticsEvent: dispatchAnalyticsEvent,
        checks: [
            new (0, $6NW7h.ExperienceCheckTimeout)({
                durationMs: $ffc7cbcf63c6d9c3$var$TIMEOUT_DURATION
            }),
            $ffc7cbcf63c6d9c3$var$syncedBlockAddedToDomCheck(refs, editorViewRef)
        ]
    });
    const createSourceQuickInsertMenuExperience = new (0, $dp5Fv.Experience)((0, $ezEf7.EXPERIENCE_ID).MENU_ACTION, {
        action: (0, $krYZG.ACTION).SYNCED_BLOCK_CREATE,
        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).QUICK_INSERT,
        dispatchAnalyticsEvent: dispatchAnalyticsEvent,
        checks: [
            new (0, $6NW7h.ExperienceCheckTimeout)({
                durationMs: $ffc7cbcf63c6d9c3$var$TIMEOUT_DURATION
            }),
            $ffc7cbcf63c6d9c3$var$syncedBlockAddedToDomCheck(refs, editorViewRef)
        ]
    });
    const deleteReferenceSyncedBlockExperience = new (0, $dp5Fv.Experience)((0, $ezEf7.EXPERIENCE_ID).TOOLBAR_ACTION, {
        action: (0, $krYZG.ACTION).REFERENCE_SYNCED_BLOCK_DELETE,
        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).SYNCED_BLOCK_TOOLBAR,
        dispatchAnalyticsEvent: dispatchAnalyticsEvent,
        checks: [
            new (0, $6NW7h.ExperienceCheckTimeout)({
                durationMs: $ffc7cbcf63c6d9c3$var$TIMEOUT_DURATION
            }),
            $ffc7cbcf63c6d9c3$var$referenceSyncBlockRemovedFromDomCheck(refs, editorViewRef)
        ]
    });
    const unsyncReferenceSyncedBlockExperience = new (0, $dp5Fv.Experience)((0, $ezEf7.EXPERIENCE_ID).TOOLBAR_ACTION, {
        action: (0, $krYZG.ACTION).REFERENCE_SYNCED_BLOCK_UNSYNC,
        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).SYNCED_BLOCK_TOOLBAR,
        dispatchAnalyticsEvent: dispatchAnalyticsEvent,
        checks: [
            new (0, $6NW7h.ExperienceCheckTimeout)({
                durationMs: $ffc7cbcf63c6d9c3$var$TIMEOUT_DURATION
            }),
            $ffc7cbcf63c6d9c3$var$referenceSyncBlockRemovedFromDomCheck(refs, editorViewRef)
        ]
    });
    const unsyncSourceSyncedBlockExperience = new (0, $dp5Fv.Experience)((0, $ezEf7.EXPERIENCE_ID).TOOLBAR_ACTION, {
        action: (0, $krYZG.ACTION).SYNCED_BLOCK_UNSYNC,
        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).SYNCED_BLOCK_TOOLBAR,
        dispatchAnalyticsEvent: dispatchAnalyticsEvent,
        checks: [
            new (0, $6NW7h.ExperienceCheckTimeout)({
                durationMs: $ffc7cbcf63c6d9c3$var$TIMEOUT_DURATION
            }),
            $ffc7cbcf63c6d9c3$var$syncBlockDeleteConfirmationModalAddedCheck()
        ]
    });
    const deleteSourceSyncedBlockExperience = new (0, $dp5Fv.Experience)((0, $ezEf7.EXPERIENCE_ID).TOOLBAR_ACTION, {
        action: (0, $krYZG.ACTION).SYNCED_BLOCK_DELETE,
        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).SYNCED_BLOCK_TOOLBAR,
        dispatchAnalyticsEvent: dispatchAnalyticsEvent,
        checks: [
            new (0, $6NW7h.ExperienceCheckTimeout)({
                durationMs: $ffc7cbcf63c6d9c3$var$TIMEOUT_DURATION
            }),
            $ffc7cbcf63c6d9c3$var$syncBlockDeleteConfirmationModalAddedCheck()
        ]
    });
    const syncedLocationsExperience = new (0, $dp5Fv.Experience)((0, $ezEf7.EXPERIENCE_ID).TOOLBAR_ACTION, {
        action: (0, $krYZG.ACTION).SYNCED_BLOCK_VIEW_SYNCED_LOCATIONS,
        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).SYNCED_BLOCK_TOOLBAR,
        dispatchAnalyticsEvent: dispatchAnalyticsEvent,
        checks: [
            new (0, $6NW7h.ExperienceCheckTimeout)({
                durationMs: $ffc7cbcf63c6d9c3$var$TIMEOUT_DURATION
            }),
            $ffc7cbcf63c6d9c3$var$syncedLocationsDropdownOpenedCheck()
        ]
    });
    const bindListeners = ()=>{
        const unbindClickListener = (0, $cbY7C.bind)(document, {
            type: 'click',
            listener: (event)=>{
                const target = event.target;
                if (!target) return;
                const button = target.closest('button[data-testid]');
                if (!button || !(button instanceof HTMLButtonElement)) return;
                const testId = button.dataset.testid;
                if (!$ffc7cbcf63c6d9c3$var$isSyncedBlockButtonId(testId)) return;
                if (button.disabled) return;
                $ffc7cbcf63c6d9c3$var$handleButtonClick({
                    testId: testId,
                    button: button,
                    createSourcePrimaryToolbarExperience: createSourcePrimaryToolbarExperience,
                    createSourceBlockMenuExperience: createSourceBlockMenuExperience,
                    createSourceQuickInsertMenuExperience: createSourceQuickInsertMenuExperience,
                    deleteReferenceSyncedBlockExperience: deleteReferenceSyncedBlockExperience,
                    unsyncReferenceSyncedBlockExperience: unsyncReferenceSyncedBlockExperience,
                    unsyncSourceSyncedBlockExperience: unsyncSourceSyncedBlockExperience,
                    deleteSourceSyncedBlockExperience: deleteSourceSyncedBlockExperience,
                    syncedLocationsExperience: syncedLocationsExperience
                });
            },
            options: {
                capture: true
            }
        });
        const unbindKeydownListener = (0, $cbY7C.bind)(document, {
            type: 'keydown',
            listener: (event)=>{
                if ($ffc7cbcf63c6d9c3$var$isEnterKey(event.key)) {
                    const typeaheadPopup = (0, $6X62h.popupWithNestedElement)(getPopupsTarget(), '.fabric-editor-typeahead');
                    if (!typeaheadPopup || !(typeaheadPopup instanceof HTMLElement)) return;
                    const targetElement = typeaheadPopup.querySelector('[role="option"][aria-selected="true"]');
                    if (!targetElement || !(targetElement instanceof HTMLElement)) return;
                    const testId = targetElement.dataset.testid;
                    if (testId === (0, $ec0a253b1ada3f34$export$ce5236bf4eef2662).quickInsertCreate) createSourceQuickInsertMenuExperience.start();
                }
            },
            options: {
                capture: true
            }
        });
        return {
            unbindClickListener: unbindClickListener,
            unbindKeydownListener: unbindKeydownListener
        };
    };
    return new (0, $kpCD8.SafePlugin)({
        key: $ffc7cbcf63c6d9c3$var$pluginKey,
        view: (view)=>{
            editorViewRef.current = view;
            // Track whether listeners have been bound. When the experiment is
            // ON and the document initially has no synced blocks, we defer
            // binding until `update()` detects that `hasSyncedBlocks` has
            // flipped to `true` (e.g. via paste or collab insert). This avoids
            // the ~2-5 ms TBT cost of capture-phase click/keydown handlers on
            // the ~99.97 % of pages that never use synced blocks (EDITOR-6931).
            let listenersBound = false;
            let unbindClickListener;
            let unbindKeydownListener;
            const ensureListenersBound = ()=>{
                if (listenersBound) return;
                listenersBound = true;
                const unbinders = bindListeners();
                unbindClickListener = unbinders.unbindClickListener;
                unbindKeydownListener = unbinders.unbindKeydownListener;
            };
            if ((0, $92ceda184e2df47e$export$cb5a03b39dafc9cc).getState(view.state)?.hasSyncedBlocks) ensureListenersBound();
            return {
                update: (view, prevState)=>{
                    if (!listenersBound && view.state.doc !== prevState.doc && (0, $92ceda184e2df47e$export$cb5a03b39dafc9cc).getState(view.state)?.hasSyncedBlocks) // Bind listeners now that synced blocks are present.
                    ensureListenersBound();
                },
                destroy: ()=>{
                    createSourcePrimaryToolbarExperience.abort({
                        reason: 'editorDestroyed'
                    });
                    createSourceBlockMenuExperience.abort({
                        reason: 'editorDestroyed'
                    });
                    createSourceQuickInsertMenuExperience.abort({
                        reason: 'editorDestroyed'
                    });
                    deleteReferenceSyncedBlockExperience.abort({
                        reason: 'editorDestroyed'
                    });
                    deleteSourceSyncedBlockExperience?.abort({
                        reason: 'editorDestroyed'
                    });
                    unsyncReferenceSyncedBlockExperience?.abort({
                        reason: 'editorDestroyed'
                    });
                    unsyncSourceSyncedBlockExperience?.abort({
                        reason: 'editorDestroyed'
                    });
                    syncedLocationsExperience?.abort({
                        reason: 'editorDestroyed'
                    });
                    unbindClickListener?.();
                    unbindKeydownListener?.();
                }
            };
        }
    });
};
const $ffc7cbcf63c6d9c3$var$isSyncedBlockButtonId = (value)=>{
    return !!value && $ffc7cbcf63c6d9c3$var$syncedBlockButtonIds.has(value);
};
const $ffc7cbcf63c6d9c3$var$handleButtonClick = ({ testId: testId, button: button, createSourcePrimaryToolbarExperience: createSourcePrimaryToolbarExperience, createSourceBlockMenuExperience: createSourceBlockMenuExperience, createSourceQuickInsertMenuExperience: createSourceQuickInsertMenuExperience, deleteReferenceSyncedBlockExperience: deleteReferenceSyncedBlockExperience, unsyncReferenceSyncedBlockExperience: unsyncReferenceSyncedBlockExperience, unsyncSourceSyncedBlockExperience: unsyncSourceSyncedBlockExperience, deleteSourceSyncedBlockExperience: deleteSourceSyncedBlockExperience, syncedLocationsExperience: syncedLocationsExperience })=>{
    switch(testId){
        case (0, $ec0a253b1ada3f34$export$ce5236bf4eef2662).primaryToolbarCreate:
            createSourcePrimaryToolbarExperience.start({
                forceRestart: true
            });
            break;
        case (0, $ec0a253b1ada3f34$export$ce5236bf4eef2662).blockMenuCreate:
            createSourceBlockMenuExperience.start({
                forceRestart: true
            });
            break;
        case (0, $ec0a253b1ada3f34$export$ce5236bf4eef2662).quickInsertCreate:
            createSourceQuickInsertMenuExperience.start({
                forceRestart: true
            });
            break;
        case (0, $ec0a253b1ada3f34$export$ce5236bf4eef2662).syncedBlockToolbarReferenceDelete:
            deleteReferenceSyncedBlockExperience.start({
                forceRestart: true
            });
            break;
        case (0, $ec0a253b1ada3f34$export$ce5236bf4eef2662).syncedBlockToolbarReferenceUnsync:
            unsyncReferenceSyncedBlockExperience?.start({
                forceRestart: true
            });
            break;
        case (0, $ec0a253b1ada3f34$export$ce5236bf4eef2662).syncedBlockToolbarSourceUnsync:
            unsyncSourceSyncedBlockExperience?.start({
                forceRestart: true
            });
            break;
        case (0, $ec0a253b1ada3f34$export$ce5236bf4eef2662).syncedBlockToolbarSourceDelete:
            deleteSourceSyncedBlockExperience?.start({
                forceRestart: true
            });
            break;
        case (0, $ec0a253b1ada3f34$export$ce5236bf4eef2662).syncedBlockToolbarSyncedLocationsTrigger:
            // Only track when opening the dropdown
            if (button.getAttribute('aria-pressed') === 'false') syncedLocationsExperience?.start({
                forceRestart: true
            });
            break;
        case (0, $ec0a253b1ada3f34$export$ce5236bf4eef2662).syncedBlockToolbarSourceOverflowTrigger:
        case (0, $ec0a253b1ada3f34$export$ce5236bf4eef2662).syncedBlockToolbarReferenceOverflowTrigger:
        case (0, $ec0a253b1ada3f34$export$ce5236bf4eef2662).syncedBlockToolbarCopy:
            break;
        default:
            {
                // Exhaustiveness check: if a new SyncedBlockToolbarButtonId is added
                // but not handled above, TypeScript will error here.
                const _exhaustiveCheck = testId;
                return _exhaustiveCheck;
            }
    }
};
const $ffc7cbcf63c6d9c3$var$isEnterKey = (key)=>{
    return key === 'Enter';
};
const $ffc7cbcf63c6d9c3$var$syncedBlockAddedToDomCheck = (refs, editorViewRef)=>new (0, $brnfH.ExperienceCheckDomMutation)({
        onDomMutation: ({ mutations: mutations })=>{
            if (mutations.some($ffc7cbcf63c6d9c3$var$isBodiedSyncBlockAddedInMutation)) return {
                status: 'success'
            };
            return undefined;
        },
        observeConfig: ()=>{
            return [
                {
                    target: editorViewRef?.current?.dom,
                    options: {
                        childList: true
                    }
                },
                // When wrapping a node with breakout mark with sync block, breakout dom is reused
                // hence we need to observe subtree to catch sync block mutation
                {
                    target: (0, $bYHr8.getSelectionAncestorDOM)(editorViewRef?.current),
                    options: {
                        childList: true,
                        subtree: true
                    }
                }
            ];
        }
    });
const $ffc7cbcf63c6d9c3$var$isBodiedSyncBlockAddedInMutation = ({ type: type, addedNodes: addedNodes })=>{
    return type === 'childList' && [
        ...addedNodes
    ].some($ffc7cbcf63c6d9c3$var$isBodiedSyncBlockWithinNode);
};
const $ffc7cbcf63c6d9c3$var$isBodiedSyncBlockWithinNode = (node)=>(0, $3d4bbf22d1dcb0b8$export$a3814e00999abbb7)('[data-prosemirror-node-name="bodiedSyncBlock"]')(node);
const $ffc7cbcf63c6d9c3$var$referenceSyncBlockRemovedFromDomCheck = (refs, editorViewRef)=>new (0, $brnfH.ExperienceCheckDomMutation)({
        onDomMutation: ({ mutations: mutations })=>{
            if (mutations.some($ffc7cbcf63c6d9c3$var$isSyncBlockRemovedInMutation)) return {
                status: 'success'
            };
            return undefined;
        },
        observeConfig: ()=>{
            return [
                {
                    target: editorViewRef?.current?.dom,
                    options: {
                        childList: true
                    }
                },
                {
                    target: (0, $bYHr8.getSelectionAncestorDOM)(editorViewRef?.current),
                    options: {
                        childList: true,
                        subtree: true
                    }
                }
            ];
        }
    });
const $ffc7cbcf63c6d9c3$var$isSyncBlockRemovedInMutation = ({ type: type, removedNodes: removedNodes })=>{
    return type === 'childList' && [
        ...removedNodes
    ].some($ffc7cbcf63c6d9c3$var$isSyncBlockWithinNode);
};
const $ffc7cbcf63c6d9c3$var$isSyncBlockWithinNode = (node)=>(0, $3d4bbf22d1dcb0b8$export$a3814e00999abbb7)('[data-prosemirror-node-name="syncBlock"]')(node);
const $ffc7cbcf63c6d9c3$var$syncBlockDeleteConfirmationModalAddedCheck = ()=>new (0, $brnfH.ExperienceCheckDomMutation)({
        onDomMutation: ({ mutations: mutations })=>{
            if (mutations.some($ffc7cbcf63c6d9c3$var$isDeleteConfirmationModalAddedInMutation)) return {
                status: 'success'
            };
            return undefined;
        },
        observeConfig: ()=>{
            return {
                target: document.body,
                options: {
                    childList: true,
                    subtree: true
                }
            };
        }
    });
const $ffc7cbcf63c6d9c3$var$isDeleteConfirmationModalAddedInMutation = ({ type: type, addedNodes: addedNodes })=>{
    return type === 'childList' && [
        ...addedNodes
    ].some($ffc7cbcf63c6d9c3$var$isDeleteConfirmationModalWithinNode);
};
const $ffc7cbcf63c6d9c3$var$isDeleteConfirmationModalWithinNode = (node)=>(0, $3d4bbf22d1dcb0b8$export$a3814e00999abbb7)('[data-testid="sync-block-delete-confirmation"]')(node);
const $ffc7cbcf63c6d9c3$var$syncedLocationsDropdownOpenedCheck = ()=>new (0, $brnfH.ExperienceCheckDomMutation)({
        onDomMutation: ({ mutations: mutations })=>{
            if (mutations.some($ffc7cbcf63c6d9c3$var$isSyncedLocationsDropdownErrorInMutation)) return {
                status: 'failure'
            };
            if (mutations.some($ffc7cbcf63c6d9c3$var$isSyncedLocationsDropdownAddedInMutation)) return {
                status: 'success'
            };
            return undefined;
        },
        observeConfig: ()=>{
            return {
                target: document.body,
                options: {
                    childList: true,
                    subtree: true
                }
            };
        }
    });
const $ffc7cbcf63c6d9c3$var$isSyncedLocationsDropdownAddedInMutation = ({ type: type, addedNodes: addedNodes })=>{
    return type === 'childList' && [
        ...addedNodes
    ].some($ffc7cbcf63c6d9c3$var$isSyncedLocationsDropdownWithinNode);
};
const $ffc7cbcf63c6d9c3$var$isSyncedLocationsDropdownErrorInMutation = ({ type: type, addedNodes: addedNodes })=>{
    return type === 'childList' && [
        ...addedNodes
    ].some($ffc7cbcf63c6d9c3$var$isSyncedLocationsDropdownErrorWithinNode);
};
const $ffc7cbcf63c6d9c3$var$isSyncedLocationsDropdownWithinNode = (node)=>{
    return !!((0, $3d4bbf22d1dcb0b8$export$a3814e00999abbb7)('[data-testid="synced-locations-dropdown-content"]')(node) || (0, $3d4bbf22d1dcb0b8$export$a3814e00999abbb7)('[data-testid="synced-locations-dropdown-content-no-results"]')(node));
};
const $ffc7cbcf63c6d9c3$var$isSyncedLocationsDropdownErrorWithinNode = (node)=>{
    return !!(0, $3d4bbf22d1dcb0b8$export$a3814e00999abbb7)('[data-testid="synced-locations-dropdown-content-error"]')(node);
};





parcelRequire("cozmU");


var $8i6M6 = parcelRequire("8i6M6");

var $cCXFd = parcelRequire("cCXFd");

















var $3FYPH = parcelRequire("3FYPH");









var $dVKvM = parcelRequire("dVKvM");


var $9KSWX = parcelRequire("9KSWX");









const $c35d561f111ba545$var$SyncedBlockNewLozenge = ({ label: label })=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $9KSWX.default), {
        appearance: (0, $iDrrr.fg)('confluence_fronend_labels_categorization_migration') ? 'discovery' : 'new',
        children: label
    });
const $c35d561f111ba545$var$CreateSyncedBlockDropdownItem = ({ api: api })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { selection: selection, menuTriggerByNode: menuTriggerByNode, mode: mode } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'selection',
        'blockControls',
        'connectivity'
    ], (states)=>({
            selection: states.selectionState?.selection,
            menuTriggerByNode: states.blockControlsState?.menuTriggerByNode ?? undefined,
            mode: states.connectivityState?.mode
        }));
    const isNested = menuTriggerByNode && menuTriggerByNode.rootPos !== menuTriggerByNode.pos;
    const canBeConverted = (0, $cozmU.useMemo)(()=>selection && (0, $04e29bf458c24792$export$a912fa82dfd54783)(selection), [
        selection
    ]);
    if (isNested || !canBeConverted) return null;
    const onClick = ()=>{
        // Insert the synced block, close the block menu, and stop preserving the
        // selection — all in a single transaction, mirroring the block-menu delete
        // item. Stopping preservation is required so the caret that
        // insertSyncedBlock places inside the new block survives; otherwise
        // block-controls restores a whole-node NodeSelection over it, hiding the
        // caret (EDITOR-7949). Then re-focus the editor so the caret is active,
        // but only when the transaction was actually dispatched — otherwise a
        // failed insertion would still steal DOM focus into the editor.
        const dispatched = api?.core?.actions.execute(({ tr: tr })=>{
            // If the insertion fails, bail out without closing the menu or
            // stopping selection preservation — otherwise we would dispatch an
            // effectively-empty transaction and close the menu despite nothing
            // having been inserted.
            const result = api?.syncedBlock.commands.insertSyncedBlock((0, $krYZG.INPUT_METHOD).BLOCK_MENU)({
                tr: tr
            });
            if (!result) return null;
            api?.blockControls?.commands?.toggleBlockMenu({
                closeMenu: true
            })({
                tr: tr
            });
            api?.blockControls?.commands?.stopPreservingSelection()({
                tr: tr
            });
            return tr;
        });
        if (dispatched) api?.core?.actions.focus();
    };
    const isOffline = (0, $jaFVy.isOfflineMode)(mode);
    const lozenge = /*#__PURE__*/ (0, $8aG6j.jsx)($c35d561f111ba545$var$SyncedBlockNewLozenge, {
        label: formatMessage((0, $3FYPH.messages).newLozenge)
    });
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $dVKvM.ToolbarDropdownItem), {
        elemBefore: /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3rarE))), {
            label: "",
            size: "small"
        }),
        onClick: onClick,
        isDisabled: isOffline,
        testId: (0, $ec0a253b1ada3f34$export$ce5236bf4eef2662).blockMenuCreate,
        elemAfterText: lozenge,
        children: formatMessage((0, $3FYPH.messages).syncBlock)
    });
};
const $c35d561f111ba545$var$CopySyncedBlockDropdownItem = ({ api: api })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { mode: mode } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'connectivity'
    ], (states)=>({
            mode: states.connectivityState?.mode
        }));
    const onClick = ()=>{
        api?.core?.actions.execute(api?.syncedBlock.commands.copySyncedBlockReferenceToClipboard((0, $krYZG.INPUT_METHOD).BLOCK_MENU));
        api?.core?.actions.execute(api?.blockControls?.commands?.toggleBlockMenu({
            closeMenu: true
        }));
    };
    const lozenge = /*#__PURE__*/ (0, $8aG6j.jsx)($c35d561f111ba545$var$SyncedBlockNewLozenge, {
        label: formatMessage((0, $3FYPH.messages).newLozenge)
    });
    const copyLabel = (0, $ieeJu.expValEquals)('platform_editor_sync_block_activation', 'isEnabled', true) ? (0, $aI2Eh.syncBlockMessages).copyToSyncLabel : (0, $3FYPH.messages).copySyncedBlock;
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $dVKvM.ToolbarDropdownItem), {
        elemBefore: /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3rarE))), {
            label: "",
            size: "small"
        }),
        onClick: onClick,
        isDisabled: (0, $jaFVy.isOfflineMode)(mode),
        elemAfterText: lozenge,
        children: formatMessage(copyLabel)
    });
};
const $c35d561f111ba545$export$3699afce8ee13fa8 = ({ api: api, enableSourceSyncedBlockCreation: enableSourceSyncedBlockCreation })=>{
    const { menuTriggerByNode: menuTriggerByNode } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'blockControls'
    ], (states)=>({
            menuTriggerByNode: states.blockControlsState?.menuTriggerByNode ?? undefined
        }));
    if (menuTriggerByNode?.nodeType === 'syncBlock' || menuTriggerByNode?.nodeType === 'bodiedSyncBlock') return /*#__PURE__*/ (0, $8aG6j.jsx)($c35d561f111ba545$var$CopySyncedBlockDropdownItem, {
        api: api
    });
    else if (enableSourceSyncedBlockCreation) return /*#__PURE__*/ (0, $8aG6j.jsx)($c35d561f111ba545$var$CreateSyncedBlockDropdownItem, {
        api: api
    });
    else return null;
};


const $e23c7d606d2e1612$export$b1be7b75e24fc24b = (api, enableSourceSyncedBlockCreation)=>{
    return [
        {
            type: 'block-menu-item',
            key: (0, $8i6M6.BLOCK_ACTIONS_CREATE_SYNCED_BLOCK_MENU_ITEM).key,
            parent: {
                type: 'block-menu-section',
                key: (0, $8i6M6.TRANSFORM_MENU_SECTION).key,
                rank: (0, $cCXFd.TRANSFORM_MENU_SECTION_RANK)[(0, $8i6M6.BLOCK_ACTIONS_CREATE_SYNCED_BLOCK_MENU_ITEM).key]
            },
            component: ()=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $c35d561f111ba545$export$3699afce8ee13fa8), {
                    api: api,
                    enableSourceSyncedBlockCreation: enableSourceSyncedBlockCreation
                })
        }
    ];
};


/* DeleteConfirmationModal.tsx generated by @compiled/babel-plugin v3.0.1 */ 









var $ad7Ou = parcelRequire("ad7Ou");











var $7aRdF = parcelRequire("7aRdF");


var $fEPJS = parcelRequire("fEPJS");


var $eQiT1 = parcelRequire("eQiT1");


var $9Umtx = parcelRequire("9Umtx");


var $jq995 = parcelRequire("jq995");


var $aRGok = parcelRequire("aRGok");










var $lfoFx = parcelRequire("lfoFx");


const $571e47d3afda4415$var$modalContentMap = {
    'source-block-deleted': {
        titleMultiple: (0, $aI2Eh.syncBlockMessages).deleteConfirmationModalTitleMultiple,
        titleSingle: (0, $aI2Eh.syncBlockMessages).deletionConfirmationModalTitleSingle,
        descriptionSingle: (0, $aI2Eh.syncBlockMessages).deletionConfirmationModalDescriptionNoRef,
        descriptionMultiple: (0, $aI2Eh.syncBlockMessages).deletionConfirmationModalDescriptionNew,
        confirmButtonLabel: (0, $aI2Eh.syncBlockMessages).deleteConfirmationModalDeleteButton
    },
    'source-block-unpublished': {
        titleMultiple: (0, $aI2Eh.syncBlockMessages).deleteConfirmationModalTitleMultiple,
        titleSingle: (0, $aI2Eh.syncBlockMessages).deletionConfirmationModalTitleSingle,
        descriptionSingle: (0, $aI2Eh.syncBlockMessages).deletionConfirmationModalDescriptionNoRef,
        descriptionMultiple: (0, $aI2Eh.syncBlockMessages).deletionConfirmationModalDescriptionNew,
        confirmButtonLabel: (0, $aI2Eh.syncBlockMessages).deleteConfirmationModalDeleteButton
    },
    'source-block-unsynced': {
        titleMultiple: (0, $aI2Eh.syncBlockMessages).unsyncConfirmationModalTitle,
        titleSingle: (0, $aI2Eh.syncBlockMessages).unsyncConfirmationModalTitle,
        descriptionSingle: (0, $aI2Eh.syncBlockMessages).unsyncConfirmModalDescriptionSingle,
        descriptionMultiple: (0, $aI2Eh.syncBlockMessages).unsyncConfirmModalDescriptionMultipleNew,
        confirmButtonLabel: (0, $aI2Eh.syncBlockMessages).deleteConfirmationModalUnsyncButton
    }
};
const $571e47d3afda4415$var$styles = {
    spinner: "_3SamIHIZbP _2YLqiKIZbP"
};
const $571e47d3afda4415$export$d973532b09e0f2cc = ({ syncBlockStoreManager: syncBlockStoreManager, api: api, editorView: editorView })=>{
    const [isOpen, setIsOpen] = (0, $cozmU.useState)(false);
    const [syncBlockIds, setSyncBlockIds] = (0, $cozmU.useState)(undefined);
    const [referenceCount, setReferenceCount] = (0, $cozmU.useState)(undefined);
    const [deleteReason, setDeleteReason] = (0, $cozmU.useState)('source-block-deleted');
    const { mode: mode, bodiedSyncBlockDeletionStatus: bodiedSyncBlockDeletionStatus, activeFlag: activeFlag } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'connectivity',
        'syncedBlock'
    ], (states)=>({
            mode: states.connectivityState?.mode,
            bodiedSyncBlockDeletionStatus: states.syncedBlockState?.bodiedSyncBlockDeletionStatus,
            activeFlag: states.syncedBlockState?.activeFlag
        }));
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const resolverRef = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef(undefined); // When a source block with no references is deleted, the modal is never shown but
    // onDeleteCompleted still sets bodiedSyncBlockDeletionStatus to 'completed'. This ref signals
    // the useEffect to silently reset the status without trying to close the modal (which was never open).
    const skipModalOnCompletedRef = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef(false);
    const handleClick = (0, $cozmU.useCallback)((confirm)=>()=>{
            if (resolverRef.current) {
                resolverRef.current(confirm);
                resolverRef.current = undefined;
            }
            if (!confirm) {
                setIsOpen(false);
                setReferenceCount(undefined);
            }
            api?.core?.actions.execute(({ tr: tr })=>{
                return tr.setMeta((0, $92ceda184e2df47e$export$cb5a03b39dafc9cc), {
                    bodiedSyncBlockDeletionStatus: confirm ? 'processing' : 'none',
                    activeFlag: false
                });
            }); // The delete menu adds a `danger` decoration that it only clears on mouse leave, which
            // never fires because clicking Delete closes the menu. It stays for the lifetime of this
            // modal so the block being deleted remains highlighted, and confirming drops it along
            // with the node, but cancelling has to clear it or the red highlight is left behind.
            if (!confirm && editorView && (0, $iDrrr.fg)('platform_editor_blocks_patch_7')) api?.decorations?.actions.removeDecoration(editorView.state, editorView.dispatch);
        }, [
        api?.core?.actions,
        api?.decorations?.actions,
        editorView
    ]);
    // Store activeFlag in a ref so confirmationCallback always reads the latest value
    // even if it changes during the await fetchReferenceCountRef call.
    const activeFlagRef = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef(activeFlag);
    activeFlagRef.current = activeFlag; // Use a ref so fetchReferenceCount can be called from confirmationCallback without
    // being added to its dependency array — preventing confirmationCallback from being
    // recreated mid-flight during an await (which would break the promise chain).
    // The assignment during render is intentional — this is a standard React ref-as-latest-value
    // pattern. The reduce over syncBlockIds (typically 1-2 items) is not actually expensive.
    const fetchReferenceCountRef = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef(()=>Promise.resolve(0));
    fetchReferenceCountRef.current = async (syncBlockIds)=>{
        const references = await Promise.all(syncBlockIds.map(async (syncBlockId)=>{
            const result = await syncBlockStoreManager.sourceManager.fetchReferences(syncBlockId.resourceId);
            if (result?.error) // Consider fetch fails as soon as one of the fetches fails
            throw new Error();
            return result.references?.length ?? 0;
        })); // eslint-disable-next-line @atlassian/perf-linting/no-expensive-computations-in-render
        return references.reduce((sum, count)=>sum + count, 0);
    };
    const confirmationCallback = (0, $cozmU.useCallback)(async (syncBlockIds, deleteReason)=>{
        // Fetch references before opening the modal. If none exist, skip the modal
        // entirely and auto-confirm the deletion. On fetch error, default to showing
        // the modal to avoid accidental data loss.
        let count;
        try {
            count = await fetchReferenceCountRef.current(syncBlockIds);
        } catch  {
            count = 1;
        }
        if (count === 0) {
            // No references — auto-confirm without showing the modal.
            // Clear activeFlag to avoid issues with subsequent deletion attempts.
            // We do NOT reset bodiedSyncBlockDeletionStatus here because onDeleteCompleted
            // will set it to 'completed' after the delete call returns. Instead we use a
            // ref to signal that the next 'completed' status should be silently reset
            // without trying to close the modal.
            skipModalOnCompletedRef.current = true;
            api?.core?.actions.execute(({ tr: tr })=>{
                return tr.setMeta((0, $92ceda184e2df47e$export$cb5a03b39dafc9cc), {
                    ...activeFlagRef.current ? {
                        activeFlag: false
                    } : {}
                });
            });
            return true;
        }
        setReferenceCount(count);
        setIsOpen(true);
        setSyncBlockIds(syncBlockIds);
        if (deleteReason) setDeleteReason(deleteReason);
        const confirmedPromise = new Promise((resolve)=>{
            resolverRef.current = resolve;
        });
        if (activeFlagRef.current) api?.core?.actions.execute(({ tr: tr })=>{
            return tr.setMeta((0, $92ceda184e2df47e$export$cb5a03b39dafc9cc), {
                // Clear flag to avoid potential retry deletion of different blocks
                activeFlag: false
            });
        });
        return confirmedPromise;
    }, // fetchReferenceCountRef and activeFlagRef are intentionally omitted — they are refs
    // and never change identity, ensuring confirmationCallback is never recreated mid-flight
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        api?.core?.actions
    ]);
    (0, $cozmU.useEffect)(()=>{
        const unregister = syncBlockStoreManager.sourceManager.registerConfirmationCallback(confirmationCallback);
        return ()=>{
            unregister();
        };
    }, [
        syncBlockStoreManager,
        confirmationCallback
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (skipModalOnCompletedRef.current) {
            if (bodiedSyncBlockDeletionStatus === 'completed') // Deletion was auto-confirmed without showing the modal (no references).
            // Reset the status to 'none' — keep skipModalOnCompletedRef true until
            // we confirm the status has landed as 'none' to guard against the race where
            // the next deletion opens the modal before this transaction is processed.
            api?.core?.actions.execute(({ tr: tr })=>{
                return tr.setMeta((0, $92ceda184e2df47e$export$cb5a03b39dafc9cc), {
                    bodiedSyncBlockDeletionStatus: 'none'
                });
            });
            else if (bodiedSyncBlockDeletionStatus === 'none') skipModalOnCompletedRef.current = false;
            else if (bodiedSyncBlockDeletionStatus === 'processing' && isOpen) // Reset on deletion failure (e.g. network error) to avoid modal stuck in opened state.
            skipModalOnCompletedRef.current = false;
            return;
        }
        if (bodiedSyncBlockDeletionStatus === 'completed' && isOpen) {
            // auto close modal once deletion is successful
            // eslint-disable-next-line @atlassian/perf-linting/no-chain-state-updates -- Ignored via go/ees017 (to be fixed)
            setIsOpen(false);
            api?.core?.actions.execute(({ tr: tr })=>{
                return tr.setMeta((0, $92ceda184e2df47e$export$cb5a03b39dafc9cc), {
                    // Reset deletion status to have a clean state for next deletion
                    bodiedSyncBlockDeletionStatus: 'none'
                });
            });
        }
    }, [
        api?.core?.actions,
        bodiedSyncBlockDeletionStatus,
        isOpen
    ]);
    // References are fetched and set before the modal opens in
    // confirmationCallback, so no additional fetch is needed here.
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $aRGok.default), {
        children: isOpen && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $7aRdF.default), {
            onClose: handleClick(false),
            testId: "sync-block-delete-confirmation",
            height: 184,
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8aG6j.Fragment), {
                children: referenceCount === undefined ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                    xcss: $571e47d3afda4415$var$styles.spinner,
                    children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lfoFx.default), {
                        size: "large"
                    })
                }) : /*#__PURE__*/ (0, $8aG6j.jsx)($571e47d3afda4415$var$ModalContent, {
                    content: $571e47d3afda4415$var$modalContentMap[deleteReason],
                    referenceCount: referenceCount,
                    handleClick: handleClick,
                    formatMessage: formatMessage,
                    isDeleting: bodiedSyncBlockDeletionStatus === 'processing',
                    isDisabled: (0, $jaFVy.isOfflineMode)(mode),
                    deleteReason: deleteReason,
                    sourceCount: syncBlockIds?.length || 0
                })
            })
        })
    });
};
const $571e47d3afda4415$var$ModalContent = ({ content: content, referenceCount: referenceCount, handleClick: handleClick, formatMessage: formatMessage, isDeleting: isDeleting, isDisabled: isDisabled, deleteReason: deleteReason, sourceCount: sourceCount })=>{
    const { titleMultiple: titleMultiple, titleSingle: titleSingle, descriptionSingle: descriptionSingle, descriptionMultiple: descriptionMultiple, confirmButtonLabel: confirmButtonLabel } = content;
    const hasNoReferenceOrFailToFetch = referenceCount === 0;
    const totalLocationCount = deleteReason === 'source-block-deleted' ? referenceCount + sourceCount : referenceCount;
    const isReferenceCountDescriptionEnabled = deleteReason === 'source-block-deleted' && (0, $iDrrr.fg)('platform_editor_blocks_patch_7');
    const descriptionLocationCount = isReferenceCountDescriptionEnabled ? referenceCount : totalLocationCount;
    const descriptionMultipleMessage = isReferenceCountDescriptionEnabled ? (0, $aI2Eh.syncBlockMessages).deletionConfirmationModalDescriptionReferenceCount : descriptionMultiple;
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $8aG6j.Fragment), {
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9Umtx.default), {
                hasCloseButton: true,
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $jq995.default), {
                    appearance: "warning",
                    children: hasNoReferenceOrFailToFetch ? formatMessage(titleSingle) : formatMessage(titleMultiple, {
                        count: totalLocationCount
                    })
                })
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $fEPJS.default), {
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                    children: hasNoReferenceOrFailToFetch ? formatMessage(descriptionSingle) : formatMessage(descriptionMultipleMessage, {
                        syncBlockCount: descriptionLocationCount
                    })
                })
            }),
            /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $eQiT1.default), {
                children: [
                    /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ad7Ou.default), {
                        appearance: "subtle",
                        onClick: handleClick(false),
                        children: formatMessage((0, $aI2Eh.syncBlockMessages).deleteConfirmationModalCancelButton)
                    }),
                    /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ad7Ou.default), {
                        appearance: "warning",
                        onClick: handleClick(true),
                        autoFocus: true,
                        isDisabled: isDisabled,
                        isLoading: isDeleting,
                        testId: `synced-block-delete-confirmation-modal-${deleteReason}-button`,
                        children: formatMessage(confirmButtonLabel)
                    })
                ]
            })
        ]
    });
};


/* Flag.tsx generated by @compiled/babel-plugin v3.0.1 */ 



var $hekY6 = parcelRequire("hekY6");














var $eO7Q2 = parcelRequire("eO7Q2");





var $FKQbh = parcelRequire("FKQbh");


var $a2foB = parcelRequire("a2foB");


var $lqtHz = parcelRequire("lqtHz");


var $f3HCt = parcelRequire("f3HCt");


var $chu6R = parcelRequire("chu6R");


var $lMGh1 = parcelRequire("lMGh1");






const $93a1ff420248a392$var$feedbackFlagStyles = null;
const $93a1ff420248a392$var$flagMap = {
    [(0, $ec0a253b1ada3f34$export$5881677fb314e6d9).CANNOT_DELETE_WHEN_OFFLINE]: {
        title: (0, $aI2Eh.syncBlockMessages).failToDeleteTitle,
        description: (0, $aI2Eh.syncBlockMessages).failToDeleteWhenOfflineDescription,
        type: 'error'
    },
    [(0, $ec0a253b1ada3f34$export$5881677fb314e6d9).CANNOT_EDIT_WHEN_OFFLINE]: {
        title: (0, $aI2Eh.syncBlockMessages).failToEditTitle,
        description: (0, $aI2Eh.syncBlockMessages).failToEditWhenOfflineDescription,
        type: 'error'
    },
    [(0, $ec0a253b1ada3f34$export$5881677fb314e6d9).CANNOT_CREATE_WHEN_OFFLINE]: {
        title: (0, $aI2Eh.syncBlockMessages).failToCreateTitle,
        description: (0, $aI2Eh.syncBlockMessages).failToCreateWhenOfflineDescription,
        type: 'error'
    },
    [(0, $ec0a253b1ada3f34$export$5881677fb314e6d9).FAIL_TO_DELETE]: {
        title: (0, $aI2Eh.syncBlockMessages).cannotDeleteTitle,
        description: (0, $aI2Eh.syncBlockMessages).cannotDeleteDescription,
        type: 'error'
    },
    [(0, $ec0a253b1ada3f34$export$5881677fb314e6d9).SYNC_BLOCK_COPIED]: {
        title: (0, $aI2Eh.syncBlockMessages).syncBlockCopiedTitle,
        type: 'info'
    },
    [(0, $ec0a253b1ada3f34$export$5881677fb314e6d9).UNPUBLISHED_SYNC_BLOCK_PASTED]: {
        title: (0, $aI2Eh.syncBlockMessages).unpublishedSyncBlockPastedTitle,
        description: (0, $aI2Eh.syncBlockMessages).unpublishedSyncBlockPastedDescription,
        type: 'info'
    },
    [(0, $ec0a253b1ada3f34$export$5881677fb314e6d9).CANNOT_CREATE_SYNC_BLOCK]: {
        title: (0, $aI2Eh.syncBlockMessages).cannotCreateSyncBlockTitle,
        description: (0, $aI2Eh.syncBlockMessages).CannotCreateSyncBlockDescription,
        type: 'error'
    },
    [(0, $ec0a253b1ada3f34$export$5881677fb314e6d9).EXTENSION_IN_SYNC_BLOCK]: {
        title: (0, $aI2Eh.syncBlockMessages).extensionInSyncBlockTitle,
        description: (0, $aI2Eh.syncBlockMessages).extensionInSyncBlockDescription,
        type: 'error'
    },
    [(0, $ec0a253b1ada3f34$export$5881677fb314e6d9).INLINE_EXTENSION_IN_SYNC_BLOCK]: {
        title: (0, $aI2Eh.syncBlockMessages).inlineExtensionInSyncBlockTitle,
        description: (0, $aI2Eh.syncBlockMessages).inlineExtensionInSyncBlockDescription,
        type: 'error'
    },
    [(0, $ec0a253b1ada3f34$export$5881677fb314e6d9).DUPLICATE_SOURCE_SYNC_BLOCK]: {
        title: (0, $aI2Eh.syncBlockMessages).duplicateSourceSyncBlockTitle,
        description: (0, $aI2Eh.syncBlockMessages).duplicateSourceSyncBlockDescription,
        type: 'error'
    },
    [(0, $ec0a253b1ada3f34$export$5881677fb314e6d9).SYNC_BLOCK_FEEDBACK_PROMPT]: {
        title: (0, $aI2Eh.syncBlockMessages).feedbackFlagTitle,
        description: (0, $aI2Eh.syncBlockMessages).feedbackFlagDescription,
        type: 'feedback'
    }
};
const $93a1ff420248a392$export$ff27f1a30a9d5c47 = (activeFlag, isSyncBlockActivationEnabled)=>{
    if (!activeFlag || activeFlag.id !== (0, $ec0a253b1ada3f34$export$5881677fb314e6d9).SYNC_BLOCK_COPIED || activeFlag.sourceProduct !== 'confluence-page' || !isSyncBlockActivationEnabled) return undefined;
    return activeFlag.isLivePage || !activeFlag.isSourceContentUnpublished ? (0, $aI2Eh.syncBlockMessages).syncBlockCopiedLivePageDescription : (0, $aI2Eh.syncBlockMessages).syncBlockCopiedUnpublishedDescription;
};
const $93a1ff420248a392$export$48ea269755562084 = ({ api: api, onFeedbackPromptShown: onFeedbackPromptShown, onGiveFeedback: onGiveFeedback })=>{
    const { activeFlag: activeFlag, mode: mode } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'syncedBlock',
        'connectivity'
    ], (states)=>{
        return {
            activeFlag: states.syncedBlockState?.activeFlag,
            mode: states.connectivityState?.mode
        };
    });
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const isFeedbackPromptVisible = activeFlag && activeFlag.id === (0, $ec0a253b1ada3f34$export$5881677fb314e6d9).SYNC_BLOCK_FEEDBACK_PROMPT;
    (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useEffect(()=>{
        if (!isFeedbackPromptVisible || !onFeedbackPromptShown) return;
        try {
            const promptShownResult = onFeedbackPromptShown();
            Promise.resolve(promptShownResult).catch(()=>{});
        } catch  {}
    }, [
        isFeedbackPromptVisible,
        onFeedbackPromptShown
    ]);
    if (!activeFlag) return;
    const { title: defaultTitle, description: defaultDescription, action: action, type: type } = $93a1ff420248a392$var$flagMap[activeFlag.id];
    const { onRetry: onRetry, onDismissed: onDismissedCallback } = activeFlag; // For the unpublished-paste flag, swap to the Jira-flavoured copy when the source
    // is a Jira work item. Other flags don't currently vary by product.
    const isJiraUnpublishedPaste = activeFlag.id === (0, $ec0a253b1ada3f34$export$5881677fb314e6d9).UNPUBLISHED_SYNC_BLOCK_PASTED && activeFlag.sourceProduct === 'jira-work-item';
    const copiedDescription = $93a1ff420248a392$export$ff27f1a30a9d5c47(activeFlag, activeFlag.id === (0, $ec0a253b1ada3f34$export$5881677fb314e6d9).SYNC_BLOCK_COPIED && (0, $ieeJu.expValEquals)('platform_editor_sync_block_activation', 'isEnabled', true));
    const title = isJiraUnpublishedPaste ? (0, $aI2Eh.syncBlockMessages).unpublishedSyncBlockPastedTitleJiraWorkItem : defaultTitle;
    const description = copiedDescription ?? (isJiraUnpublishedPaste ? (0, $aI2Eh.syncBlockMessages).unpublishedSyncBlockPastedDescriptionJiraWorkItem : defaultDescription); // Retry button often involves network request, hence we dismiss the flag in offline mode to avoid retry
    if ((0, $jaFVy.isOfflineMode)(mode) && !!onRetry) {
        api?.core.actions.execute(({ tr: tr })=>{
            tr.setMeta((0, $92ceda184e2df47e$export$cb5a03b39dafc9cc), {
                activeFlag: false
            });
            return tr;
        });
        return;
    }
    const dismissFlag = (shouldFocusEditor)=>{
        api?.core.actions.execute(({ tr: tr })=>{
            onDismissedCallback?.(tr);
            const oldMeta = tr.getMeta((0, $92ceda184e2df47e$export$cb5a03b39dafc9cc));
            tr.setMeta((0, $92ceda184e2df47e$export$cb5a03b39dafc9cc), {
                ...oldMeta,
                activeFlag: false
            });
            return tr;
        });
        if (shouldFocusEditor) api?.core.actions.focus();
    };
    const onDismissed = ()=>dismissFlag(true);
    const typeToActions = ()=>{
        if (type === 'error') {
            if (onRetry) return [
                {
                    content: formatMessage((0, $aI2Eh.syncBlockMessages).deleteRetryButton),
                    onClick: onRetry
                }
            ];
        } else if (type === 'info' && action) return [
            {
                content: formatMessage(action),
                href: (0, $eO7Q2.SYNCED_BLOCKS_DOCUMENTATION_URL),
                target: '_blank',
                rel: 'noopener noreferrer'
            }
        ];
        else if (type === 'feedback' && activeFlag.id === (0, $ec0a253b1ada3f34$export$5881677fb314e6d9).SYNC_BLOCK_FEEDBACK_PROMPT && activeFlag.feedbackContext) {
            const feedbackContext = activeFlag.feedbackContext;
            return [
                {
                    content: formatMessage((0, $aI2Eh.syncBlockMessages).feedbackFlagGiveFeedback),
                    onClick: ()=>{
                        dismissFlag(false);
                        try {
                            const feedbackResult = onGiveFeedback?.(feedbackContext);
                            Promise.resolve(feedbackResult).catch(()=>{});
                        } catch  {}
                    }
                },
                {
                    content: formatMessage((0, $aI2Eh.syncBlockMessages).feedbackFlagNoThanks),
                    onClick: onDismissed
                }
            ];
        }
        return undefined;
    };
    const FlagComponent = type === 'info' ? (0, $a2foB.default) : (0, $FKQbh.default);
    const flag = /*#__PURE__*/ (0, $8aG6j.jsx)(FlagComponent, {
        onDismissed: onDismissed,
        title: formatMessage(title),
        description: description ? formatMessage(description) : undefined,
        id: activeFlag.id,
        testId: activeFlag.id,
        icon: $93a1ff420248a392$var$typeToIcon(type),
        actions: typeToActions()
    });
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lqtHz.FlagGroup), {
        children: type === 'feedback' ? /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            id: activeFlag.id,
            className: (0, $hekY6.default)([
                "_0MlzL8AASz"
            ]),
            children: flag
        }) : flag
    });
};
const $93a1ff420248a392$var$typeToIcon = (type)=>{
    if (type === 'error') return /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lMGh1))), {
        label: "",
        color: "var(--ds-icon-warning, #E06C00)"
    });
    if (type === 'feedback') return /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($f3HCt))), {
        label: "",
        spacing: "spacious",
        color: "var(--ds-icon, #292A2E)"
    });
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($chu6R))), {
        label: "",
        color: "var(--ds-icon-success, #6A9A23)"
    });
};





parcelRequire("cozmU");





var $2xhuI = parcelRequire("2xhuI");



var $gx3UZ = parcelRequire("gx3UZ");


var $4EksL = parcelRequire("4EksL");

var $eaLat = parcelRequire("eaLat");


var $4hfky = parcelRequire("4hfky");





var $7Y8M5 = parcelRequire("7Y8M5");





var $fHs3z = parcelRequire("fHs3z");


var $iDfTs = parcelRequire("iDfTs");


var $gC2EJ = parcelRequire("gC2EJ");


var $8y86q = parcelRequire("8y86q");










/* SyncedLocationDropdown.tsx generated by @compiled/babel-plugin v3.0.1 */ 









var $k12R1 = parcelRequire("k12R1");


var $is1T6 = parcelRequire("is1T6");


var $9erVg = parcelRequire("9erVg");














var $9RT19 = parcelRequire("9RT19");

var $9GNtS = parcelRequire("9GNtS");


var $6oMcp = parcelRequire("6oMcp");


var $lSQgn = parcelRequire("lSQgn");


var $kLlYX = parcelRequire("kLlYX");


var $6spAz = parcelRequire("6spAz");


var $7sJoX = parcelRequire("7sJoX");


var $7vAVv = parcelRequire("7vAVv");


var $hMaHH = parcelRequire("hMaHH");


var $d4GYd = parcelRequire("d4GYd");


var $24dy7 = parcelRequire("24dy7");


var $jrU5N = parcelRequire("jrU5N");


var $lSw2p = parcelRequire("lSw2p");


var $iAaYd = parcelRequire("iAaYd");


var $NlHoa = parcelRequire("NlHoa");


var $bltJZ = parcelRequire("bltJZ");





var $7vK9E = parcelRequire("7vK9E");



var $1l0kj = parcelRequire("1l0kj");

var $dinVW = parcelRequire("dinVW");



















parcelRequire("cozmU");


var $IQ4Dz = parcelRequire("IQ4Dz");

// eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage -- Figma specifies this fixed illustration color, which has no semantic token equivalent across themes.
const $41b8b984dc98014f$var$arrowFill = '#8C8F97';
const $41b8b984dc98014f$export$bc90f0a575a3d90f = ()=>{
    const { colorMode: colorMode } = (0, $IQ4Dz.useThemeObserver)();
    const placeholderFill = colorMode === 'dark' ? "var(--ds-surface-overlay-pressed, #DDDEE1)" : "var(--ds-background-accent-gray-subtlest, #F0F1F2)";
    return /*#__PURE__*/ (0, $8aG6j.jsxs)("svg", {
        width: "274",
        height: "92",
        viewBox: "0 0 274 92",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true",
        focusable: "false",
        "data-testid": "synced-locations-empty-state-illustration",
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsx)("rect", {
                x: "0.41416",
                y: "0.41416",
                width: "115.965",
                height: "90.2868",
                rx: "2.89912",
                stroke: "var(--ds-border, #0B120E24)",
                strokeWidth: "0.82832"
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)("rect", {
                x: "10.7681",
                y: "38.1016",
                width: "30.0956",
                height: "21.0056",
                fill: placeholderFill
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)("rect", {
                x: "43.3486",
                y: "38.1016",
                width: "30.0956",
                height: "21.0056",
                fill: placeholderFill
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)("rect", {
                x: "75.9292",
                y: "38.1016",
                width: "30.0956",
                height: "21.0056",
                fill: placeholderFill
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                d: "M10.8154 26.5352H77.1144V29.1609H10.8154V26.5352Z",
                fill: placeholderFill
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                d: "M7.45483 69.5781H110.166V72.0631H7.45483V69.5781Z",
                fill: placeholderFill
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                d: "M7.45483 75.3789H110.166V77.8639H7.45483V75.3789Z",
                fill: placeholderFill
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                d: "M7.45483 81.1719H82.0036V83.6568H7.45483V81.1719Z",
                fill: placeholderFill
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)("rect", {
                x: "10.8154",
                y: "31.7891",
                width: "17.7235",
                height: "2.6257",
                fill: placeholderFill
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)("rect", {
                x: "6.95492",
                y: "22.6954",
                width: "102.884",
                height: "40.7596",
                rx: "0.984638",
                stroke: "var(--ds-border-focused, #4688EC)",
                strokeWidth: "0.656425"
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)("rect", {
                x: "81.5023",
                y: "20.707",
                width: "22.5506",
                height: "4.96992",
                rx: "0.82832",
                fill: "var(--ds-surface-overlay, #FFFFFF)"
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                d: "M85.2556 22.4161C85.2556 22.3732 85.2208 22.3384 85.1779 22.3384H83.6248C83.5819 22.3384 83.5472 22.3732 83.5472 22.4161V23.9692C83.5472 24.0121 83.5819 24.0468 83.6248 24.0468H84.0908V24.2798H83.6248C83.4533 24.2798 83.3142 24.1407 83.3142 23.9692V22.4161C83.3142 22.2445 83.4533 22.1055 83.6248 22.1055H85.1779C85.3495 22.1055 85.4885 22.2445 85.4885 22.4161V22.7267H85.2556V22.4161Z",
                fill: "var(--ds-icon-subtle, #505258)"
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                d: "M85.4732 23.3029C85.7006 23.5303 85.7006 23.8991 85.4732 24.1266L85.4692 24.1305L85.5375 24.1533C85.5887 24.1704 85.6215 24.2205 85.6166 24.2743C85.6118 24.3281 85.5706 24.3715 85.5171 24.3791L85.1328 24.434C85.0965 24.4392 85.0598 24.427 85.0339 24.4011C85.008 24.3752 84.9958 24.3385 85.001 24.3022L85.0559 23.9179L85.0603 23.8985C85.0745 23.8547 85.1136 23.8226 85.1607 23.8184C85.2145 23.8135 85.2647 23.8463 85.2818 23.8976L85.3045 23.9658L85.3084 23.9619C85.4449 23.8254 85.4449 23.604 85.3084 23.4676L85.1986 23.3578L85.3633 23.1931L85.4732 23.3029ZM84.8801 22.9954C84.9164 22.9902 84.9531 23.0024 84.979 23.0283C85.0049 23.0543 85.0171 23.0909 85.0119 23.1272L84.957 23.5116C84.9494 23.565 84.906 23.6062 84.8522 23.6111C84.7984 23.6159 84.7483 23.5831 84.7312 23.5319L84.7084 23.4636L84.7045 23.4676C84.568 23.604 84.568 23.8254 84.7045 23.9619L84.8143 24.0717L84.6496 24.2364L84.5398 24.1266C84.3123 23.8991 84.3123 23.5303 84.5398 23.3029L84.5437 23.2989L84.4755 23.2762C84.4242 23.2591 84.3914 23.2089 84.3963 23.1551C84.4012 23.1013 84.4423 23.058 84.4958 23.0503L84.8801 22.9954Z",
                fill: "var(--ds-icon-subtle, #505258)"
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)("rect", {
                x: "86.4723",
                y: "22.1289",
                width: "15.9241",
                height: "2.12321",
                fill: placeholderFill
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)("rect", {
                x: "7.53369",
                y: "5.53516",
                width: "47.2626",
                height: "3.93855",
                fill: placeholderFill
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)("rect", {
                x: "24.8138",
                y: "14.1758",
                width: "14.4003",
                height: "1.92004",
                fill: placeholderFill
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)("circle", {
                cx: "10.8929",
                cy: "14.654",
                r: "2.23595",
                fill: placeholderFill,
                stroke: "var(--ds-surface-overlay, #FFFFFF)",
                strokeWidth: "0.328213"
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)("circle", {
                cx: "14.7333",
                cy: "14.654",
                r: "2.23595",
                fill: placeholderFill,
                stroke: "var(--ds-surface-overlay, #FFFFFF)",
                strokeWidth: "0.328213"
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)("circle", {
                cx: "18.5736",
                cy: "14.654",
                r: "2.23595",
                fill: placeholderFill,
                stroke: "var(--ds-surface-overlay, #FFFFFF)",
                strokeWidth: "0.328213"
            }),
            /*#__PURE__*/ (0, $8aG6j.jsxs)("g", {
                clipPath: "url(#synced-locations-arrow-clip)",
                children: [
                    /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                        d: "M153.151 39.5728C153.137 39.1517 151.895 38.7634 151.646 39.1155C151.294 39.6114 151.022 40.1671 150.803 40.9126C150.623 41.7746 150.828 42.0572 150.641 42.6134C150.509 43.089 150.24 43.7061 149.966 44.1967C149.692 44.691 149.411 45.0135 149.31 45.0811C149.281 45.1129 149.261 45.1394 149.246 45.1633C149.238 45.1894 149.22 45.2245 149.202 45.2719C149.184 45.291 149.164 45.3581 149.148 45.3734C149.109 45.4351 149.127 45.4725 148.993 45.5143C148.863 45.5572 148.58 45.5552 148.251 45.4788C147.924 45.4073 147.563 45.2853 147.215 45.1309C146.212 44.7559 145.565 44.449 145.235 44.3075C144.446 43.9591 143.8 43.8021 143.114 43.7547C142.737 43.7292 142.255 44.7498 142.515 45.0242C142.993 45.5205 143.531 45.9211 144.335 46.2984C144.655 46.4366 145.166 47.0275 146.147 47.4648C146.309 47.5326 146.478 47.578 146.665 47.5883C147.458 47.6306 148.351 47.8436 149.302 47.7055C149.781 47.6314 150.2 47.4182 150.458 47.2428C150.575 47.1475 150.67 47.0703 150.733 47.02C150.798 46.9661 150.823 46.9369 150.823 46.9369C150.823 46.9369 150.865 46.8886 150.938 46.8048C151.02 46.7195 151.104 46.5984 151.209 46.4471C151.407 46.1448 151.612 45.7354 151.767 45.3155C152.088 44.4704 152.337 43.5357 152.495 42.983C152.722 42.1549 152.83 41.7576 152.899 41.5105C153.099 40.7718 153.164 40.1758 153.145 39.5792L153.151 39.5728Z",
                        fill: $41b8b984dc98014f$var$arrowFill
                    }),
                    /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                        d: "M122.093 51.2051C122.362 52.3321 123.634 52.0495 123.655 51.0274C123.691 49.5646 123.763 48.06 124.288 46.2549C124.363 46.0014 124.43 45.7703 124.493 45.5579C124.524 45.4498 124.546 45.347 124.571 45.249C124.599 45.152 124.638 45.0621 124.668 44.9738C124.789 44.6166 124.892 44.319 124.99 44.0401C125.239 43.5099 125.419 43.0202 125.904 42.4543C126 42.3327 126.1 42.2 126.203 42.0684C126.323 41.9497 126.445 41.8236 126.572 41.6948C126.698 41.5697 126.829 41.4383 126.961 41.3069C127.092 41.1754 127.253 41.0688 127.399 40.9454C127.7 40.7058 127.999 40.4576 128.34 40.262C128.668 40.0545 128.989 39.8412 129.331 39.6824C129.99 39.3251 130.654 39.0906 131.194 38.8926C131.752 38.7406 132.176 38.5935 132.43 38.5547C132.577 38.5248 132.721 38.4863 132.865 38.4392C132.991 38.3953 133.171 38.3346 133.395 38.2588C133.627 38.2011 133.906 38.1331 134.224 38.0563C134.539 37.9624 134.906 37.9244 135.302 37.8582C135.697 37.7798 136.127 37.7641 136.581 37.7314C136.697 37.7247 136.808 37.7169 136.928 37.7076C137.045 37.7095 137.162 37.7113 137.283 37.7143C137.52 37.7191 137.765 37.7261 138.011 37.7294C138.259 37.7375 138.502 37.7802 138.755 37.8017C139.004 37.8343 139.264 37.8457 139.513 37.9066C139.765 37.9601 140.017 38.0098 140.269 38.0633C140.522 38.1093 140.764 38.2086 141.01 38.2807C141.509 38.4148 141.971 38.635 142.431 38.8345C142.76 38.9675 143.038 39.1502 143.325 39.2909C143.613 39.4278 143.855 39.6082 144.092 39.7667C144.58 40.0635 144.95 40.4149 145.293 40.6974C145.943 41.3089 146.377 41.8043 146.636 42.1759C147.917 43.8828 148.559 45.4067 149.143 46.9622C149.466 47.8095 150.591 47.6859 150.514 46.676C150.477 46.2238 150.46 45.7574 150.339 45.3009C150.285 45.0706 150.233 44.8328 150.18 44.5987C150.128 44.361 150.066 44.1162 149.966 43.8802C149.623 42.9218 149.158 41.8867 148.375 40.8682C148.217 40.6762 148.066 40.3892 147.825 40.0957C147.579 39.8011 147.315 39.4322 146.969 39.0516C146.788 38.8689 146.593 38.6782 146.389 38.4767C146.284 38.3773 146.177 38.2731 146.066 38.1678C145.95 38.0688 145.827 37.9762 145.702 37.8788C145.45 37.6877 145.182 37.4836 144.897 37.2827C144.601 37.1067 144.285 36.9253 143.958 36.7444C143.748 36.6181 143.52 36.5269 143.293 36.4443C143.066 36.3616 142.834 36.2853 142.604 36.2139C140.599 35.6384 138.269 35.4412 136.47 35.5293C135.569 35.5525 134.8 35.6753 134.253 35.7335C133.709 35.8333 133.392 35.8941 133.392 35.8941C133.392 35.8941 133.271 35.9194 133.06 35.9628C132.844 35.9965 132.543 36.0985 132.168 36.2032C131.982 36.258 131.774 36.3185 131.558 36.3805C131.344 36.4596 131.113 36.5455 130.875 36.6378C130.637 36.7338 130.378 36.8158 130.128 36.9368C129.874 37.0568 129.614 37.183 129.351 37.3082C129.081 37.4275 128.822 37.5821 128.557 37.7393C128.296 37.8976 128.022 38.044 127.766 38.2157C127.265 38.5831 126.738 38.9183 126.3 39.3363C126.075 39.5375 125.843 39.7205 125.642 39.9246C125.443 40.1334 125.254 40.337 125.068 40.5294C124.882 40.7218 124.709 40.9101 124.57 41.1081C124.425 41.3003 124.287 41.4824 124.157 41.6469C123.956 41.8915 123.806 42.1428 123.667 42.3814C123.525 42.619 123.391 42.8389 123.266 43.0451C123.041 43.4688 122.884 43.8519 122.73 44.171C122.568 44.4878 122.501 44.784 122.41 45.0283C122.33 45.2721 122.261 45.4787 122.201 45.6554C121.577 47.8403 121.729 49.6415 122.093 51.2051Z",
                        fill: $41b8b984dc98014f$var$arrowFill
                    })
                ]
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)("rect", {
                x: "157.621",
                y: "0.41416",
                width: "115.965",
                height: "90.2868",
                rx: "2.89912",
                stroke: "var(--ds-border, #0B120E24)",
                strokeWidth: "0.82832"
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)("rect", {
                x: "167.975",
                y: "51.3594",
                width: "30.0956",
                height: "21.0056",
                fill: placeholderFill
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)("rect", {
                x: "200.556",
                y: "51.3594",
                width: "30.0956",
                height: "21.0056",
                fill: placeholderFill
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)("rect", {
                x: "233.136",
                y: "51.3594",
                width: "30.0956",
                height: "21.0056",
                fill: placeholderFill
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                d: "M168.022 39.7891H234.321V42.4148H168.022V39.7891Z",
                fill: placeholderFill
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                d: "M164.661 19.8789H267.373V22.3639H164.661V19.8789Z",
                fill: placeholderFill
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                d: "M164.661 25.6719H267.373V28.1568H164.661V25.6719Z",
                fill: placeholderFill
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)("rect", {
                x: "168.022",
                y: "45.0391",
                width: "17.7235",
                height: "2.6257",
                fill: placeholderFill
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)("rect", {
                x: "164.161",
                y: "35.9454",
                width: "102.884",
                height: "40.7596",
                rx: "0.984638",
                stroke: "var(--ds-border-focused, #4688EC)",
                strokeWidth: "0.656425"
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)("rect", {
                x: "238.709",
                y: "33.9648",
                width: "22.5506",
                height: "4.96992",
                rx: "0.82832",
                fill: "var(--ds-surface-overlay, #FFFFFF)"
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                d: "M242.463 35.6739C242.463 35.631 242.428 35.5962 242.385 35.5962H240.832C240.789 35.5962 240.754 35.631 240.754 35.6739V37.227C240.754 37.2699 240.789 37.3047 240.832 37.3047H241.298V37.5376H240.832C240.66 37.5376 240.521 37.3986 240.521 37.227V35.6739C240.521 35.5024 240.66 35.3633 240.832 35.3633H242.385C242.557 35.3633 242.696 35.5024 242.696 35.6739V35.9845H242.463V35.6739Z",
                fill: "var(--ds-icon-subtle, #505258)"
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                d: "M242.68 36.5607C242.908 36.7881 242.908 37.1569 242.68 37.3844L242.676 37.3883L242.745 37.4111C242.796 37.4282 242.829 37.4783 242.824 37.5321C242.819 37.5859 242.778 37.6293 242.724 37.6369L242.34 37.6918C242.304 37.697 242.267 37.6848 242.241 37.6589C242.215 37.633 242.203 37.5963 242.208 37.56L242.263 37.1757L242.267 37.1563C242.282 37.1125 242.321 37.0805 242.368 37.0762C242.422 37.0714 242.472 37.1041 242.489 37.1554L242.512 37.2236L242.516 37.2197C242.652 37.0832 242.652 36.8619 242.516 36.7254L242.406 36.6156L242.571 36.4509L242.68 36.5607ZM242.087 36.2532C242.124 36.2481 242.16 36.2602 242.186 36.2862C242.212 36.3121 242.224 36.3487 242.219 36.385L242.164 36.7694C242.157 36.8228 242.113 36.864 242.059 36.8689C242.006 36.8737 241.955 36.8409 241.938 36.7897L241.916 36.7214L241.912 36.7254C241.775 36.8619 241.775 37.0832 241.912 37.2197L242.021 37.3295L241.857 37.4942L241.747 37.3844C241.519 37.1569 241.519 36.7881 241.747 36.5607L241.751 36.5567L241.683 36.534C241.631 36.5169 241.599 36.4668 241.603 36.4129C241.608 36.3592 241.649 36.3158 241.703 36.3081L242.087 36.2532Z",
                fill: "var(--ds-icon-subtle, #505258)"
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)("rect", {
                x: "243.679",
                y: "35.3867",
                width: "15.9241",
                height: "2.12321",
                fill: placeholderFill
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)("rect", {
                x: "164.74",
                y: "11.332",
                width: "47.2626",
                height: "3.93855",
                fill: placeholderFill
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)("defs", {
                children: /*#__PURE__*/ (0, $8aG6j.jsx)("clipPath", {
                    id: "synced-locations-arrow-clip",
                    children: /*#__PURE__*/ (0, $8aG6j.jsx)("rect", {
                        width: "20.9549",
                        height: "28.3348",
                        transform: "translate(120.479 51.5039) rotate(-73.6651)"
                    })
                })
            })
        ]
    });
};


const $c9326a9d581538d9$var$fadeIn = null;
const $c9326a9d581538d9$var$headingStyles = null;
const $c9326a9d581538d9$var$dropdownItemStyles = null; // logo icon does not fit in ADS IconTile, hence we need custom styles to match with other icons
const $c9326a9d581538d9$var$logoTileStyles = null;
const $c9326a9d581538d9$var$SYNCED_LOCATIONS_DROPDOWN_TEST_ID = 'synced-block-synced-locations-dropdown';
const $c9326a9d581538d9$var$styles = {
    title: "_4bt5LAnQyn _2WAcuGnQyn _1UtDYzZpcK _39HuIbz8Lp _1ANEUSLRg7",
    note: "_1UtDYzKGUX _1ANEUSLRg7",
    lozenge: "_0GTcwRgVvo _4ouGXIfI2J",
    noResultsContainer: "_39xV02doBh _2fwxA5DIqT",
    activationDropdownContent: "_4c065UPgdg _39xV02Hakr",
    activationNoResultsContainer: "_24h04i2Njc _39xV02Hakr _0Of8r2NHnM _1wydGWNHnM",
    activationNoResultsContent: "_2YLqiKIZbP _39xV02Fsop _2fwxA5DIqT",
    dropdownContent: "_4c065UFQfX _39xV027EXf _0NUa3rAef5 _3iDTPbQ4SZ _37wbyuDIqT _0hPCNLDIqT",
    containerWithMinHeight: "_4kiQYAKa7A",
    contentContainer: "_2fBhteZewk _39xV02N91d _4xdlr0FlnN _2WAcuGIZbP",
    errorContainer: "_39xV02doBh _3iDTPbQ4SZ",
    errorIcon: "_3SamIH5UaJ",
    learnMoreLink: "_00uqCY98eZ _3xtjKNYbGa _0H9qDF6wH8",
    requestAccess: "_39xV02Mw9m _1ANEUSLRg7 _0GTcwRgVvo _1UtDYzKGUX"
};
const $c9326a9d581538d9$var$shouldApplyMinHeight = (fetchStatus, itemCount)=>{
    // When there are 1/2 items, dropdown height is less than minHeight 144px
    return !(fetchStatus === 'success' && itemCount > 0);
};
const $c9326a9d581538d9$var$ItemTitle = ({ title: title, formatMessage: formatMessage, onSameDocument: onSameDocument, isSource: isSource, hasAccess: hasAccess, productType: productType })=>{
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $1l0kj.Inline), {
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                as: "span",
                xcss: $c9326a9d581538d9$var$styles.title,
                children: title
            }),
            onSameDocument && /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $iMnC5.Box), {
                as: "span",
                xcss: $c9326a9d581538d9$var$styles.note,
                children: [
                    "\xa0-",
                    ' ',
                    formatMessage(productType === 'confluence-page' ? (0, $aI2Eh.syncBlockMessages).syncedLocationDropdownTitleNoteForConfluencePage : (0, $aI2Eh.syncBlockMessages).syncedLocationDropdownTitleNoteForJiraWorkItem)
                ]
            }),
            isSource && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                as: "span",
                xcss: $c9326a9d581538d9$var$styles.lozenge,
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9KSWX.default), {
                    children: formatMessage((0, $aI2Eh.syncBlockMessages).syncedLocationDropdownSourceLozenge)
                })
            }),
            !hasAccess && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                as: "span",
                xcss: $c9326a9d581538d9$var$styles.requestAccess,
                children: formatMessage((0, $aI2Eh.syncBlockMessages).syncedLocationDropdownRequestAccess)
            })
        ]
    });
};
const $c9326a9d581538d9$var$productIconMap = {
    'confluence-page': (0, $bltJZ.ConfluenceIcon),
    'jira-work-item': (0, $bltJZ.JiraIcon)
};
const $c9326a9d581538d9$var$subTypeIconMap = {
    live: (0, (/*@__PURE__*/$parcel$interopDefault($kLlYX))),
    page: (0, (/*@__PURE__*/$parcel$interopDefault($hMaHH)))
};
const $c9326a9d581538d9$var$getConfluenceSubTypeIcon = (sourceAri, subType)=>{
    try {
        const { type: pageType } = (0, $6oMcp.getPageIdAndTypeFromConfluencePageAri)({
            ari: sourceAri
        });
        if (pageType === 'blogpost') return 0, (/*@__PURE__*/$parcel$interopDefault($d4GYd));
        else return subType && subType in $c9326a9d581538d9$var$subTypeIconMap ? $c9326a9d581538d9$var$subTypeIconMap[subType] : (0, (/*@__PURE__*/$parcel$interopDefault($hMaHH)));
    } catch  {
        return 0, (/*@__PURE__*/$parcel$interopDefault($hMaHH));
    }
};
const $c9326a9d581538d9$var$ProductIcon = ({ product: product })=>{
    const ProductIcon = product ? $c9326a9d581538d9$var$productIconMap[product] ?? (0, $NlHoa.AtlassianIcon) : (0, $NlHoa.AtlassianIcon);
    return /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
        className: (0, $hekY6.default)([
            "_0bjKvD0O7w _0KLXruDMqu _39xV02SPN1 _0jFU0VSPN1 _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT"
        ]),
        children: /*#__PURE__*/ (0, $8aG6j.jsx)(ProductIcon, {
            size: "xxsmall",
            appearance: "neutral"
        })
    });
}; // Map AGG issue-type names to ADS icons. The mapping is by the English `name` returned
const $c9326a9d581538d9$var$jiraIssueTypeIconMap = {
    Task: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($iAaYd))),
        messageKey: 'syncedLocationDropdownIssueTypeTask'
    },
    Bug: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($6spAz))),
        messageKey: 'syncedLocationDropdownIssueTypeBug'
    },
    Story: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($jrU5N))),
        messageKey: 'syncedLocationDropdownIssueTypeStory'
    },
    Epic: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($7vAVv))),
        messageKey: 'syncedLocationDropdownIssueTypeEpic'
    },
    Subtask: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($lSw2p))),
        messageKey: 'syncedLocationDropdownIssueTypeSubtask'
    },
    'Sub-task': {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($lSw2p))),
        messageKey: 'syncedLocationDropdownIssueTypeSubtask'
    }
}; /**
    * Creates an icon component from a custom Jira issue-type `iconUrl` that conforms to the
    * ADS icon component contract expected by `IconTile`. This lets us reuse `IconTile` for
    * custom issue types — ensuring consistent sizing, background, and border-radius with the
    * standard ADS icons used for known issue types (Bug, Story, etc.).
    *
    * The returned component ignores ADS icon props (color, spacing, etc.) because the image
    * is an external raster/SVG asset that doesn't respond to design tokens.
    */ 
const $c9326a9d581538d9$var$customIconCache = new Map();
const $c9326a9d581538d9$var$createCustomIssueTypeIcon = (iconUrl)=>{
    const cached = $c9326a9d581538d9$var$customIconCache.get(iconUrl);
    if (cached) return cached;
    const CustomIssueTypeIcon = ()=>/*#__PURE__*/ (0, $8aG6j.jsx)("img", {
            src: iconUrl,
            alt: "",
            width: "12",
            height: "12"
        });
    CustomIssueTypeIcon.displayName = 'CustomIssueTypeIcon';
    $c9326a9d581538d9$var$customIconCache.set(iconUrl, CustomIssueTypeIcon);
    return CustomIssueTypeIcon;
}; /**
    * Returns the icon to render for a Jira issue type, or `null` when neither an ADS icon
    * mapping nor an AGG-provided `iconUrl` is available so the caller can fall back to a
    * generic product icon.
    *
    * Implemented as a plain function (not a React component) so the `null` check actually
    * narrows — a JSX expression always evaluates to a truthy `ReactElement` object,
    * meaning callers cannot distinguish a "would render nothing" component from one that
    * renders an icon.
    */ 
const $c9326a9d581538d9$var$renderJiraIssueTypeIcon = (issueType, intl)=>{
    const mapped = $c9326a9d581538d9$var$jiraIssueTypeIconMap[issueType.name];
    if (mapped) {
        const label = intl.formatMessage((0, $aI2Eh.syncBlockMessages)[mapped.messageKey]);
        return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lSQgn.default), {
            icon: mapped.icon,
            label: label,
            appearance: 'gray',
            size: "xsmall"
        });
    } // Custom Jira issue types — render inside `IconTile` using a wrapper component so the
    // icon gets the same tile background, border-radius, and sizing as known issue types.
    if (issueType.iconUrl) {
        const CustomIcon = $c9326a9d581538d9$var$createCustomIssueTypeIcon(issueType.iconUrl);
        const label = intl.formatMessage((0, $aI2Eh.syncBlockMessages).syncedLocationDropdownIssueTypeGeneric);
        return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lSQgn.default), {
            icon: CustomIcon,
            label: label,
            appearance: 'gray',
            size: "xsmall"
        });
    }
    return null;
};
const $c9326a9d581538d9$var$ItemIcon = ({ reference: reference, intl: intl })=>{
    const { hasAccess: hasAccess, subType: subType, productType: productType, sourceAri: sourceAri, issueType: issueType } = reference;
    if (productType === 'confluence-page' && hasAccess) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lSQgn.default), {
        icon: $c9326a9d581538d9$var$getConfluenceSubTypeIcon(sourceAri, subType),
        label: "",
        appearance: 'gray',
        size: "xsmall"
    });
     // Render a Jira issue-type icon when we have one.
    // Falls through to the generic product icon when:
    //   - we don't have access (issueType is not surfaced for no-access references),
    //   - AGG returned no `issueType` (partial index, deleted, etc.), or
    //   - the issue type is unrecognised AND has no `iconUrl`.
    if (productType === 'jira-work-item' && hasAccess && issueType) {
        const icon = $c9326a9d581538d9$var$renderJiraIssueTypeIcon(issueType, intl);
        if (icon !== null) return icon;
    } // Generic product fallback for `jira-work-item` (and any future product).
    return /*#__PURE__*/ (0, $8aG6j.jsx)($c9326a9d581538d9$var$ProductIcon, {
        product: productType
    });
};
const $c9326a9d581538d9$export$7233d77a72ff78ae = (referenceData, intl)=>{
    const { formatMessage: formatMessage } = intl;
    const sourceInfoMap = new Map();
    referenceData?.forEach((reference)=>{
        if (!reference) return;
        if (sourceInfoMap.has(reference.sourceAri)) sourceInfoMap.get(reference.sourceAri)?.push(reference);
        else sourceInfoMap.set(reference.sourceAri, [
            reference
        ]);
    });
    for (const references of sourceInfoMap.values())if (references.length > 1) references.forEach((reference, index)=>reference.title = `${reference.title === '' && reference.hasAccess ? formatMessage((0, $aI2Eh.syncBlockMessages).syncedLocationDropdownUntitledPage) : reference.title}: ${formatMessage((0, $aI2Eh.syncBlockMessages).syncedLocationDropdownTitleBlockIndex, {
            index: index + 1
        })}`);
    const sortedReferences = Array.from(sourceInfoMap.values()).flat().sort((a, b)=>{
        if (a.isSource !== b.isSource) return b.isSource ? 1 : -1;
        if (a.hasAccess !== b.hasAccess) return a.hasAccess ? -1 : 1;
        return (a.title || '').localeCompare(b.title || '');
    });
    return sortedReferences;
};
const $c9326a9d581538d9$export$1bd57d4057e7f613 = ({ syncBlockStore: syncBlockStore, resourceId: resourceId, intl: intl, isSource: isSource, localId: localId, api: api, floatingToolbarRenderContext: floatingToolbarRenderContext })=>{
    return /*#__PURE__*/ (0, $8aG6j.jsx)($c9326a9d581538d9$var$EditorPositionedSyncedLocationDropdown, {
        syncBlockStore: syncBlockStore,
        resourceId: resourceId,
        intl: intl,
        isSource: isSource,
        localId: localId,
        api: api,
        floatingToolbarRenderContext: floatingToolbarRenderContext
    });
};
const $c9326a9d581538d9$var$EditorPositionedSyncedLocationDropdown = ({ syncBlockStore: syncBlockStore, resourceId: resourceId, intl: intl, isSource: isSource, localId: localId, api: api, floatingToolbarRenderContext: floatingToolbarRenderContext })=>{
    const triggerTitle = intl.formatMessage((0, $aI2Eh.syncBlockMessages).syncedLocationDropdownTitle);
    const [isOpen, setIsOpen] = (0, $cozmU.useState)(false);
    const content = isOpen ? /*#__PURE__*/ (0, $8aG6j.jsx)($c9326a9d581538d9$var$DropdownContent, {
        syncBlockStore: syncBlockStore,
        resourceId: resourceId,
        intl: intl,
        isSource: isSource,
        localId: localId,
        api: api
    }) : null;
    const toggleOpen = (0, $cozmU.useCallback)(()=>{
        setIsOpen((currentIsOpen)=>!currentIsOpen);
    }, []);
    const closeDropdown = (0, $cozmU.useCallback)(()=>{
        setIsOpen(false);
    }, []);
    const setDisableParentScroll = floatingToolbarRenderContext?.setDisableParentScroll;
    (0, $cozmU.useEffect)(()=>{
        if (!isOpen) return;
        setDisableParentScroll?.(true);
        return ()=>{
            setDisableParentScroll?.(false);
        };
    }, [
        isOpen,
        setDisableParentScroll
    ]);
    const trigger = (0, $cozmU.useMemo)(()=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $4hfky.default), {
            areAnyNewToolbarFlagsEnabled: true,
            testId: (0, $ec0a253b1ada3f34$export$ce5236bf4eef2662).syncedBlockToolbarSyncedLocationsTrigger,
            selected: isOpen,
            iconAfter: /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
                color: "currentColor",
                spacing: "spacious",
                label: "",
                size: "small"
            }),
            onClick: toggleOpen,
            ariaHasPopup: true,
            children: triggerTitle
        }), [
        isOpen,
        toggleOpen,
        triggerTitle
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9GNtS.DropdownContainer), {
        testId: $c9326a9d581538d9$var$SYNCED_LOCATIONS_DROPDOWN_TEST_ID,
        isOpen: isOpen,
        trigger: trigger,
        handleClickOutside: closeDropdown,
        handleEscapeKeydown: closeDropdown,
        mountTo: floatingToolbarRenderContext?.popupsMountPoint,
        boundariesElement: floatingToolbarRenderContext?.popupsBoundariesElement,
        scrollableElement: floatingToolbarRenderContext?.popupsScrollableElement,
        arrowKeyNavigationProviderOptions: {
            type: (0, $9RT19.ArrowKeyNavigationType).MENU
        },
        children: content
    });
};
const $c9326a9d581538d9$export$127208b0973f9135 = ({ syncBlockStore: syncBlockStore, resourceId: resourceId, intl: intl, isSource: isSource, localId: localId, api: api, floatingToolbarRenderContext: floatingToolbarRenderContext })=>{
    const [isOpen, setIsOpen] = (0, $cozmU.useState)(false);
    const { fetchStatus: fetchStatus, referenceData: referenceData } = $c9326a9d581538d9$var$useReferenceData({
        intl: intl,
        isSource: isSource,
        localId: localId,
        resourceId: resourceId,
        syncBlockStore: syncBlockStore
    });
    const referenceCount = (0, $cozmU.useMemo)(()=>referenceData.filter(({ isSource: isSourceItem })=>!isSourceItem).length, [
        referenceData
    ]);
    const tooltipContent = !isOpen && fetchStatus === 'success' && referenceCount === 0 ? intl.formatMessage((0, $aI2Eh.syncBlockMessages).syncedLocationDropdownNoReferencesTooltip) : null;
    const content = isOpen ? /*#__PURE__*/ (0, $8aG6j.jsx)($c9326a9d581538d9$var$DropdownContentWithReferenceData, {
        resourceId: resourceId,
        intl: intl,
        api: api,
        fetchStatus: fetchStatus,
        referenceData: referenceData
    }) : null;
    const toggleOpen = (0, $cozmU.useCallback)(()=>{
        setIsOpen((currentIsOpen)=>!currentIsOpen);
    }, []);
    const closeDropdown = (0, $cozmU.useCallback)(()=>{
        setIsOpen(false);
    }, []);
    const setDisableParentScroll = floatingToolbarRenderContext?.setDisableParentScroll;
    (0, $cozmU.useEffect)(()=>{
        if (!isOpen) return;
        setDisableParentScroll?.(true);
        return ()=>{
            setDisableParentScroll?.(false);
        };
    }, [
        isOpen,
        setDisableParentScroll
    ]);
    const trigger = (0, $cozmU.useMemo)(()=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $4hfky.default), {
            areAnyNewToolbarFlagsEnabled: true,
            testId: (0, $ec0a253b1ada3f34$export$ce5236bf4eef2662).syncedBlockToolbarSyncedLocationsTrigger,
            selected: isOpen,
            iconAfter: /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
                color: "currentColor",
                spacing: "spacious",
                label: "",
                size: "small"
            }),
            onClick: toggleOpen,
            ariaHasPopup: true,
            tooltipContent: tooltipContent ?? undefined,
            children: /*#__PURE__*/ (0, $8aG6j.jsx)($c9326a9d581538d9$var$SyncedLocationTriggerContent, {
                intl: intl,
                fetchStatus: fetchStatus,
                referenceCount: referenceCount
            })
        }), [
        fetchStatus,
        intl,
        isOpen,
        referenceCount,
        toggleOpen,
        tooltipContent
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9GNtS.DropdownContainer), {
        alignDropdownWithParentElement: true,
        alignX: "left",
        testId: $c9326a9d581538d9$var$SYNCED_LOCATIONS_DROPDOWN_TEST_ID,
        isOpen: isOpen,
        trigger: trigger,
        handleClickOutside: closeDropdown,
        handleEscapeKeydown: closeDropdown,
        mountTo: floatingToolbarRenderContext?.popupsMountPoint,
        boundariesElement: floatingToolbarRenderContext?.popupsBoundariesElement,
        scrollableElement: floatingToolbarRenderContext?.popupsScrollableElement,
        arrowKeyNavigationProviderOptions: {
            type: (0, $9RT19.ArrowKeyNavigationType).MENU
        },
        children: content
    });
};
const $c9326a9d581538d9$var$DropdownContent = ({ syncBlockStore: syncBlockStore, resourceId: resourceId, intl: intl, isSource: isSource, localId: localId, api: api })=>{
    const [fetchStatus, setFetchStatus] = (0, $cozmU.useState)('none');
    const [referenceData, setReferenceData] = (0, $cozmU.useState)([]);
    (0, $cozmU.useEffect)(()=>{
        setFetchStatus('loading');
        const getReferenceData = async ()=>{
            const response = await syncBlockStore.fetchReferencesSourceInfo(resourceId, localId, isSource);
            if (response.error) {
                setFetchStatus('error');
                return;
            }
            setReferenceData($c9326a9d581538d9$export$7233d77a72ff78ae(response.references, intl));
            setFetchStatus('success');
        };
        getReferenceData();
    }, [
        syncBlockStore,
        intl,
        isSource,
        localId,
        resourceId
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsx)($c9326a9d581538d9$var$DropdownContentWithReferenceData, {
        resourceId: resourceId,
        intl: intl,
        api: api,
        fetchStatus: fetchStatus,
        referenceData: referenceData
    });
};
const $c9326a9d581538d9$var$useReferenceData = ({ syncBlockStore: syncBlockStore, resourceId: resourceId, intl: intl, isSource: isSource, localId: localId })=>{
    const [isNewSourceBlock] = (0, $cozmU.useState)(()=>isSource && syncBlockStore.sourceManager.isNewSourceBlock(resourceId));
    const [state, setState] = (0, $cozmU.useState)(()=>({
            fetchStatus: isNewSourceBlock ? 'success' : 'loading',
            referenceData: []
        }));
    (0, $cozmU.useEffect)(()=>{
        let isCurrentRequest = true;
        setState({
            fetchStatus: isNewSourceBlock ? 'success' : 'loading',
            referenceData: []
        });
        const getReferenceData = async ()=>{
            const response = await syncBlockStore.fetchReferencesSourceInfo(resourceId, localId, isSource);
            if (!isCurrentRequest) return;
            if (isNewSourceBlock) syncBlockStore.sourceManager.clearNewSourceBlock(resourceId);
            if (response.error) {
                setState({
                    fetchStatus: 'error',
                    referenceData: []
                });
                return;
            }
            setState({
                fetchStatus: 'success',
                referenceData: $c9326a9d581538d9$export$7233d77a72ff78ae(response.references, intl)
            });
        };
        getReferenceData();
        return ()=>{
            isCurrentRequest = false;
        };
    }, [
        syncBlockStore,
        resourceId,
        intl,
        isSource,
        localId,
        isNewSourceBlock
    ]);
    return {
        fetchStatus: state.fetchStatus,
        referenceData: state.referenceData
    };
};
const $c9326a9d581538d9$var$SyncedLocationTriggerContent = ({ intl: intl, fetchStatus: fetchStatus, referenceCount: referenceCount })=>{
    const { formatMessage: formatMessage } = intl;
    const triggerTitle = formatMessage((0, $aI2Eh.syncBlockMessages).syncedLocationDropdownTitle);
    const syncedLocationCount = referenceCount === 0 ? 0 : referenceCount + 1;
    switch(fetchStatus){
        case 'loading':
            return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $1l0kj.Inline), {
                alignBlock: "center",
                space: "space.050",
                children: [
                    triggerTitle,
                    /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lfoFx.default), {
                        size: "small",
                        label: formatMessage((0, $aI2Eh.syncBlockMessages).syncedLocationDropdownLoading)
                    })
                ]
            });
        case 'success':
            {
                const count = syncedLocationCount > 99 ? '99+' : intl.formatNumber(syncedLocationCount);
                return formatMessage((0, $aI2Eh.syncBlockMessages).syncedLocationDropdownTitleWithCount, {
                    count: count
                });
            }
        case 'none':
        case 'error':
            return triggerTitle;
    }
};
const $c9326a9d581538d9$var$DropdownContentWithReferenceData = ({ resourceId: resourceId, intl: intl, api: api, fetchStatus: fetchStatus, referenceData: referenceData })=>{
    const { formatMessage: formatMessage } = intl;
    const handleLocationClick = ()=>{
        api?.analytics?.actions?.fireAnalyticsEvent({
            eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
            action: (0, $krYZG.ACTION).CLICKED,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).SYNCED_BLOCK,
            actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).SYNCED_BLOCK_CLICK_SYNCED_LOCATION,
            attributes: {
                resourceId: resourceId
            }
        });
    };
    const content = ()=>{
        switch(fetchStatus){
            case 'loading':
                return /*#__PURE__*/ (0, $8aG6j.jsx)($c9326a9d581538d9$var$LoadingScreen, {
                    formatMessage: formatMessage
                });
            case 'error':
                return /*#__PURE__*/ (0, $8aG6j.jsx)($c9326a9d581538d9$var$ErrorScreen, {
                    formatMessage: formatMessage
                });
            case 'success':
                if (referenceData.length > 0) return /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
                    "data-testid": "synced-locations-dropdown-content",
                    className: (0, $hekY6.default)([
                        $c9326a9d581538d9$var$styles.contentContainer,
                        "_1nhtpce513 _2VmLUgKGUX"
                    ]),
                    children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9erVg.default), {
                        title: formatMessage((0, $aI2Eh.syncBlockMessages).syncedLocationDropdownHeading, {
                            count: `${referenceData.length > 99 ? '99+' : referenceData.length}`
                        }),
                        children: referenceData.map((reference)=>{
                            const title = reference.title === '' && reference.hasAccess ? formatMessage((0, $aI2Eh.syncBlockMessages).syncedLocationDropdownUntitledPage) : reference.title || reference.url || '';
                            return /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
                                className: (0, $hekY6.default)([
                                    "_0aDwTLgVvo"
                                ]),
                                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lpNn5.default), {
                                    content: title,
                                    children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $is1T6.default), {
                                        elemBefore: /*#__PURE__*/ (0, $8aG6j.jsx)($c9326a9d581538d9$var$ItemIcon, {
                                            reference: reference,
                                            intl: intl
                                        }),
                                        href: reference.url,
                                        target: "_blank",
                                        rel: "noopener noreferrer",
                                        onClick: ()=>handleLocationClick(),
                                        children: /*#__PURE__*/ (0, $8aG6j.jsx)($c9326a9d581538d9$var$ItemTitle, {
                                            title: title,
                                            formatMessage: formatMessage,
                                            onSameDocument: reference.onSameDocument,
                                            isSource: reference.isSource,
                                            hasAccess: reference.hasAccess,
                                            productType: reference.productType
                                        })
                                    }, reference.title)
                                })
                            }, reference.title);
                        })
                    })
                });
                else return /*#__PURE__*/ (0, $8aG6j.jsx)($c9326a9d581538d9$var$NoResultScreen, {
                    formatMessage: formatMessage
                });
        }
    };
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
        xcss: (0, $k12R1.cx)($c9326a9d581538d9$var$styles.dropdownContent, (0, $anBbz.expValEqualsNoExposure)('platform_editor_sync_block_activation', 'isEnabled', true) && fetchStatus === 'success' && referenceData.length === 0 && $c9326a9d581538d9$var$styles.activationDropdownContent, $c9326a9d581538d9$var$shouldApplyMinHeight(fetchStatus, referenceData.length) && $c9326a9d581538d9$var$styles.containerWithMinHeight),
        children: content()
    });
};
const $c9326a9d581538d9$var$LoadingScreen = ({ formatMessage: formatMessage })=>{
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lfoFx.default), {
            label: formatMessage((0, $aI2Eh.syncBlockMessages).syncedLocationDropdownLoading)
        })
    });
};
const $c9326a9d581538d9$var$ErrorScreen = ({ formatMessage: formatMessage })=>{
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $iMnC5.Box), {
        xcss: $c9326a9d581538d9$var$styles.errorContainer,
        testId: "synced-locations-dropdown-content-error",
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                xcss: $c9326a9d581538d9$var$styles.errorIcon,
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($24dy7))), {
                    color: "var(--ds-icon-danger, #C9372C)",
                    spacing: "spacious",
                    label: "",
                    size: "small"
                })
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                as: "p",
                size: "medium",
                children: formatMessage((0, $aI2Eh.syncBlockMessages).syncedLocationDropdownError)
            })
        ]
    });
};
const $c9326a9d581538d9$var$NoResultScreen = ({ formatMessage: formatMessage })=>{
    return (0, $ieeJu.expValEquals)('platform_editor_sync_block_activation', 'isEnabled', true) ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
        xcss: $c9326a9d581538d9$var$styles.activationNoResultsContainer,
        testId: "synced-locations-dropdown-content-no-results",
        children: /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $dinVW.Stack), {
            alignInline: "center",
            xcss: $c9326a9d581538d9$var$styles.activationNoResultsContent,
            space: "space.150",
            children: [
                /*#__PURE__*/ (0, $8aG6j.jsx)((0, $41b8b984dc98014f$export$bc90f0a575a3d90f), {}),
                /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                    as: "p",
                    children: formatMessage((0, $aI2Eh.syncBlockMessages).syncedLocationDropdownActivationNoResults)
                }),
                /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                    as: "p",
                    children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $7vK9E.Anchor), {
                        href: (0, $eO7Q2.SYNCED_BLOCKS_DOCUMENTATION_URL),
                        target: "_blank",
                        rel: "noopener noreferrer",
                        xcss: $c9326a9d581538d9$var$styles.learnMoreLink,
                        children: formatMessage((0, $aI2Eh.syncBlockMessages).syncedLocationDropdownLearnMoreLink)
                    })
                })
            ]
        })
    }) : /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $dinVW.Stack), {
        xcss: $c9326a9d581538d9$var$styles.noResultsContainer,
        space: "space.100",
        testId: "synced-locations-dropdown-content-no-results",
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                as: "p",
                children: formatMessage((0, $aI2Eh.syncBlockMessages).syncedLocationDropdownNoResults)
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                as: "p",
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $7vK9E.Anchor), {
                    href: (0, $eO7Q2.SYNCED_BLOCKS_DOCUMENTATION_URL),
                    target: "_blank",
                    rel: "noopener noreferrer",
                    xcss: $c9326a9d581538d9$var$styles.learnMoreLink,
                    children: formatMessage((0, $aI2Eh.syncBlockMessages).syncedLocationDropdownLearnMoreLink)
                })
            })
        ]
    });
};


const $cd8ed20e91ae803f$export$86ce8f8241c20a3 = (state, intl, api, syncBlockStore, isLivePage, onGiveFeedback)=>{
    const syncBlockObject = (0, $04e29bf458c24792$export$72f89723ce6d6fa3)(state.schema, state.selection);
    if (!syncBlockObject) return;
    if (syncBlockStore.sourceManager.isPendingCreation(syncBlockObject.node.attrs.resourceId)) return;
    const isSyncBlockActivationEnabled = (0, $ieeJu.expValEquals)('platform_editor_sync_block_activation', 'isEnabled', true);
    const syncBlockInstance = syncBlockStore.referenceManager.getFromCache(syncBlockObject.node.attrs.resourceId);
    const isUnsyncedBlock = syncBlockInstance?.error?.type === (0, $79ir6.SyncBlockError).NotFound;
    const isErroredBlock = syncBlockInstance?.error;
    const { schema: { nodes: { bodiedSyncBlock: bodiedSyncBlock } } } = state;
    const isBodiedSyncBlock = (0, $04e29bf458c24792$export$5f971aa95a01794c)(syncBlockObject.node, bodiedSyncBlock);
    const { resourceId: resourceId, localId: localId } = syncBlockObject.node.attrs;
    const { formatMessage: formatMessage } = intl;
    const nodeType = syncBlockObject.node.type;
    const hoverDecoration = api?.decorations?.actions.hoverDecoration;
    const hoverDecorationProps = (nodeType, className)=>({
            onMouseEnter: hoverDecoration?.(nodeType, true, className),
            onMouseLeave: hoverDecoration?.(nodeType, false, className),
            onFocus: hoverDecoration?.(nodeType, true, className),
            onBlur: hoverDecoration?.(nodeType, false, className)
        });
    const items = [];
    if (isUnsyncedBlock) {
        const deleteButton = {
            type: 'button',
            title: formatMessage((0, $2xhuI.default).delete),
            onClick: (0, $4d68281089368b28$export$1c38da93cd68ba6d)(api),
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($iDfTs))),
            testId: (0, $ec0a253b1ada3f34$export$ce5236bf4eef2662).syncedBlockToolbarReferenceDelete,
            ...hoverDecorationProps(nodeType, (0, $7Y8M5.akEditorSelectedNodeClassName))
        };
        items.push(deleteButton);
    } else {
        // When the synced block activation experiment is enabled, the copy action is
        // re-framed as the primary "Copy to sync" action: it shows a visible label and
        // is moved to the first toolbar position (before the synced-location info). See
        // EDITOR-8060.
        const copyButton = {
            id: 'editor.syncedBlock.copy',
            type: 'button',
            appearance: 'subtle',
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($fHs3z))),
            title: isSyncBlockActivationEnabled ? formatMessage((0, $aI2Eh.syncBlockMessages).copyToSyncLabel) : formatMessage((0, $aI2Eh.syncBlockMessages).copySyncBlockLabel),
            showTitle: isSyncBlockActivationEnabled,
            tooltipContent: isSyncBlockActivationEnabled ? undefined : formatMessage((0, $aI2Eh.syncBlockMessages).copySyncedBlockTooltip),
            testId: isSyncBlockActivationEnabled ? (0, $ec0a253b1ada3f34$export$ce5236bf4eef2662).syncedBlockToolbarCopy : undefined,
            onClick: (0, $4d68281089368b28$export$cdf949b884fe546d)(syncBlockStore, (0, $krYZG.INPUT_METHOD).SYNCED_BLOCK_TB, api, isLivePage),
            ...hoverDecorationProps(nodeType, (0, $7Y8M5.akEditorSelectedNodeClassName))
        };
        // In the activation experience the primary "Copy to sync" action leads the
        // toolbar, ahead of the informational synced-location dropdown.
        if (isSyncBlockActivationEnabled) items.push(copyButton);
        if (!isErroredBlock) {
            const syncedLocation = {
                type: 'custom',
                fallback: [],
                render: (_view, _idx, _dispatchAnalyticsEvent, floatingToolbarRenderContext)=>{
                    if (isSyncBlockActivationEnabled) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $c9326a9d581538d9$export$127208b0973f9135), {
                        syncBlockStore: syncBlockStore,
                        resourceId: resourceId,
                        localId: localId,
                        intl: intl,
                        isSource: isBodiedSyncBlock,
                        api: api,
                        floatingToolbarRenderContext: floatingToolbarRenderContext
                    }, `${resourceId}:${localId}:${isBodiedSyncBlock}`);
                    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $c9326a9d581538d9$export$1bd57d4057e7f613), {
                        syncBlockStore: syncBlockStore,
                        resourceId: resourceId,
                        localId: localId,
                        intl: intl,
                        isSource: isBodiedSyncBlock,
                        api: api,
                        floatingToolbarRenderContext: floatingToolbarRenderContext
                    });
                }
            };
            const unsyncButton = {
                type: 'custom',
                fallback: [],
                render: (view)=>{
                    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4hfky.default), {
                        areAnyNewToolbarFlagsEnabled: true,
                        disabled: syncBlockInstance?.data?.status === 'unpublished',
                        icon: /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8y86q))), {
                            label: ""
                        }),
                        title: formatMessage((0, $aI2Eh.syncBlockMessages).unsyncButton),
                        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                        onClick: ()=>(0, $4d68281089368b28$export$e44cd24c4e3ac750)(syncBlockStore, isBodiedSyncBlock, view),
                        testId: isBodiedSyncBlock ? (0, $ec0a253b1ada3f34$export$ce5236bf4eef2662).syncedBlockToolbarSourceUnsync : (0, $ec0a253b1ada3f34$export$ce5236bf4eef2662).syncedBlockToolbarReferenceUnsync
                    });
                }
            };
            items.push(syncedLocation, unsyncButton);
        }
        // Outside the activation experience the copy button keeps its original
        // (icon-only, secondary) position after the synced-location info.
        if (!isSyncBlockActivationEnabled) items.push(copyButton);
        const disabled = !syncBlockStore.referenceManager.getSyncBlockURL(syncBlockObject.node.attrs.resourceId);
        if (!isBodiedSyncBlock) {
            const editSourceButton = {
                id: 'editor.syncedBlock.editSource',
                type: 'button',
                disabled: disabled,
                appearance: 'subtle',
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($gC2EJ))),
                title: formatMessage((0, $aI2Eh.syncBlockMessages).editSourceLabel),
                showTitle: false,
                tooltipContent: disabled ? formatMessage((0, $aI2Eh.syncBlockMessages).editSourceTooltipDisabled) : formatMessage((0, $aI2Eh.syncBlockMessages).editSourceTooltip),
                onClick: (0, $4d68281089368b28$export$3a389eb361f43fd)(syncBlockStore, api),
                ...hoverDecorationProps(nodeType, (0, $7Y8M5.akEditorSelectedNodeClassName))
            };
            items.push(editSourceButton);
        }
        if (!isSyncBlockActivationEnabled) {
            const separator = {
                type: 'separator'
            };
            const deleteButton = {
                id: 'editor.syncedBlock.delete',
                type: 'button',
                appearance: 'danger',
                title: formatMessage((0, $2xhuI.default).delete),
                showTitle: false,
                tooltipContent: formatMessage((0, $2xhuI.default).delete),
                onClick: (0, $4d68281089368b28$export$1c38da93cd68ba6d)(api),
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($iDfTs))),
                testId: isBodiedSyncBlock ? (0, $ec0a253b1ada3f34$export$ce5236bf4eef2662).syncedBlockToolbarSourceDelete : (0, $ec0a253b1ada3f34$export$ce5236bf4eef2662).syncedBlockToolbarReferenceDelete,
                ...hoverDecorationProps(nodeType)
            };
            items.push(separator, deleteButton);
        } else {
            // testId is required to show focus on trigger button on ESC key press
            // see hideOnEsc in platform/packages/editor/editor-plugin-floating-toolbar/src/ui/Dropdown.tsx
            const testId = isBodiedSyncBlock ? (0, $ec0a253b1ada3f34$export$ce5236bf4eef2662).syncedBlockToolbarSourceOverflowTrigger : (0, $ec0a253b1ada3f34$export$ce5236bf4eef2662).syncedBlockToolbarReferenceOverflowTrigger;
            const overflowMenuConfig = [
                {
                    type: 'overflow-dropdown',
                    testId: testId,
                    options: [
                        ...isSyncBlockActivationEnabled && onGiveFeedback ? [
                            {
                                title: formatMessage((0, $gx3UZ.toolbarInsertBlockMessages).feedbackDialog),
                                icon: /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($f3HCt))), {
                                    label: ""
                                }),
                                onClick: ()=>{
                                    api?.core.actions.execute(({ tr: tr })=>tr.setSelection(new (0, $4EksL.GapCursorSelection)(tr.doc.resolve(syncBlockObject.pos + syncBlockObject.node.nodeSize), (0, $eaLat.Side).RIGHT)));
                                    onGiveFeedback({
                                        blockType: isBodiedSyncBlock ? 'source' : 'reference',
                                        entryPoint: 'overflow-menu'
                                    });
                                    return true;
                                }
                            }
                        ] : [],
                        {
                            title: formatMessage((0, $2xhuI.default).delete),
                            onClick: (0, $4d68281089368b28$export$1c38da93cd68ba6d)(api),
                            icon: /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($iDfTs))), {
                                label: ""
                            }),
                            testId: isBodiedSyncBlock ? (0, $ec0a253b1ada3f34$export$ce5236bf4eef2662).syncedBlockToolbarSourceDelete : (0, $ec0a253b1ada3f34$export$ce5236bf4eef2662).syncedBlockToolbarReferenceDelete,
                            ...hoverDecorationProps(nodeType)
                        }
                    ]
                }
            ];
            items.push(...overflowMenuConfig);
        }
    }
    const getDomRef = (editorView)=>{
        const domAtPos = editorView.domAtPos.bind(editorView);
        const element = (0, $bjg0G.findDomRefAtPos)(syncBlockObject.pos, domAtPos);
        return element;
    };
    return {
        title: 'Synced Block floating controls',
        getDomRef: getDomRef,
        nodeType: nodeType,
        items: items,
        scrollable: true,
        groupLabel: formatMessage((0, $aI2Eh.syncBlockMessages).syncBlockGroup),
        visible: api?.connectivity?.sharedState.currentState()?.mode !== 'offline'
    };
};


/* quick-insert.tsx generated by @compiled/babel-plugin v3.0.1 */ 


parcelRequire("cozmU");








var $5HBT9 = parcelRequire("5HBT9");


var $jGK9e = parcelRequire("jGK9e");












const $0cbbe85ea6426dbe$var$lozengeWrapperStyles = null;
const $0cbbe85ea6426dbe$export$69e699948916d30c = (config, api, syncBlockStore)=>{
    return ({ formatMessage: formatMessage })=>{
        if (!config?.enableSourceCreation) return [];
        const syncBlockTitle = (0, $ieeJu.expValEquals)('platform_editor_sync_block_activation', 'isEnabled', true) ? (0, $5HBT9.messages).syncedBlockQuickInsertTitle : (0, $5HBT9.messages).syncBlock;
        return [
            {
                id: 'syncBlock',
                title: formatMessage(syncBlockTitle),
                description: formatMessage((0, $5HBT9.messages).syncedBlockDescription),
                priority: 400,
                keywords: [
                    'synced',
                    'block',
                    'synced-block',
                    'sync',
                    'sync-block',
                    'auto',
                    'update',
                    'excerpt',
                    'connect',
                    'create'
                ],
                isDisabledOffline: true,
                keyshortcut: '',
                lozenge: /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
                    className: (0, $hekY6.default)([
                        "_3YEZNOdnbC _2O5VijdnbC _3iDTPbccYA"
                    ]),
                    children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9KSWX.default), {
                        appearance: (0, $iDrrr.fg)('confluence_fronend_labels_categorization_migration') ? 'discovery' : 'new',
                        children: formatMessage((0, $5HBT9.messages).newLozenge)
                    })
                }),
                icon: ()=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $jGK9e.IconSyncBlock), {
                        label: formatMessage(syncBlockTitle)
                    }),
                action: (insert, state)=>{
                    return (0, $4d68281089368b28$export$fbc30658d812c800)({
                        tr: state.tr,
                        syncBlockStore: syncBlockStore,
                        typeAheadInsert: insert,
                        fireAnalyticsEvent: api?.analytics?.actions.fireAnalyticsEvent,
                        inputMethod: (0, $krYZG.INPUT_METHOD).QUICK_INSERT
                    });
                },
                testId: (0, $ec0a253b1ada3f34$export$ce5236bf4eef2662).quickInsertCreate
            }
        ];
    };
};





parcelRequire("cozmU");





var $7SMXM = parcelRequire("7SMXM");


var $dCkbP = parcelRequire("dCkbP");


var $dXqu3 = parcelRequire("dXqu3");




















var $I2MTF = parcelRequire("I2MTF");





const $12a7d30445e0ce19$export$eab12d03f28497e4 = ({ api: api, syncBlockStore: syncBlockStore })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { editorDisabled: editorDisabled } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'editorDisabled'
    ], (states)=>({
            editorDisabled: states.editorDisabledState?.editorDisabled
        }));
    const onSelect = (0, $cozmU.useCallback)(({ editorView: editorView, insert: insert, source: source })=>(0, $4d68281089368b28$export$fbc30658d812c800)({
            tr: editorView.state.tr,
            syncBlockStore: syncBlockStore,
            typeAheadInsert: insert,
            fireAnalyticsEvent: api?.analytics?.actions.fireAnalyticsEvent,
            inputMethod: source ?? (0, $krYZG.INPUT_METHOD).QUICK_INSERT
        }), [
        api,
        syncBlockStore
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $I2MTF.QuickInsertMenuItem), {
        iconBefore: /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3rarE))), {
            label: ""
        }),
        isDisabled: editorDisabled,
        onSelect: onSelect,
        title: formatMessage((0, $5HBT9.messages).syncedBlockQuickInsertTitle)
    });
};


const $384df5d448cd347c$export$90150d61f16ca941 = ({ api: api, syncBlockStore: syncBlockStore })=>[
        {
            key: (0, $dCkbP.SYNCED_BLOCK_MENU_ITEM).key,
            type: (0, $dCkbP.SYNCED_BLOCK_MENU_ITEM).type,
            parents: [
                {
                    key: (0, $dCkbP.STRUCTURE_SECTION).key,
                    type: (0, $dCkbP.STRUCTURE_SECTION).type,
                    rank: (0, $dXqu3.STRUCTURE_SECTION_RANK)[(0, $dCkbP.SYNCED_BLOCK_MENU_ITEM).key]
                }
            ],
            match: (0, $7SMXM.createQuickInsertMatcher)(({ formatMessage: formatMessage })=>({
                    description: formatMessage((0, $5HBT9.messages).syncedBlockDescription),
                    keywords: [
                        'synced',
                        'block',
                        'synced-block',
                        'sync',
                        'sync-block',
                        'auto',
                        'update',
                        'excerpt',
                        'connect',
                        'create'
                    ],
                    shortcut: '',
                    title: formatMessage((0, $5HBT9.messages).syncedBlockQuickInsertTitle)
                })),
            component: ()=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $12a7d30445e0ce19$export$eab12d03f28497e4), {
                    api: api,
                    syncBlockStore: syncBlockStore
                })
        }
    ];


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 



var $lOiVq = parcelRequire("lOiVq");





var $WnqKg = parcelRequire("WnqKg");




const $b9206e5f8eb43fd0$var$getSourceSyncBlockPlaceholderStyles = (placeholderText)=>/*#__PURE__*/ (0, $lOiVq.css)({
        // Emptiness is signalled by the node view via the `empty` class, which is derived from the
        // ProseMirror document. Keeping this visual state in CSS means typing, deletion, undo/redo,
        // and remote changes update it without decorations.
        //
        // This deliberately does NOT inspect the rendered DOM shape. The paragraph inside an empty
        // block routinely gains extra children that are not user content — the selection marker's
        // cursor widget (`.ProseMirror-widget`), ProseMirror's `.ProseMirror-separator` hack node,
        // and the `.ProseMirror-trailingBreak`. An earlier `:has(.ProseMirror-trailingBreak:only-child)`
        // form treated those decorations as content and hid the placeholder whenever the user placed
        // a cursor in the block and then blurred the editor. See EDITOR-8327.
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
        [`.ProseMirror .${(0, $95bQO.BodiedSyncBlockSharedCssClassName).prefix}.${(0, $95bQO.BodiedSyncBlockSharedCssClassName).empty} .${(0, $95bQO.BodiedSyncBlockSharedCssClassName).content}[contenteditable="true"] > p:only-child`]: {
            position: 'relative',
            '&::before': {
                // JSON.stringify produces a quoted and escaped CSS string.
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
                content: placeholderText,
                position: 'absolute',
                boxSizing: 'border-box',
                color: "var(--ds-text-subtlest, #6B6E76)",
                font: 'inherit',
                insetInlineStart: 0,
                width: '100%',
                overflow: 'hidden',
                pointerEvents: 'none',
                textOverflow: 'ellipsis',
                userSelect: 'none',
                whiteSpace: 'nowrap'
            }
        }
    });
const $b9206e5f8eb43fd0$export$286cc38c7d222ebf = ()=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const placeholderStyles = (0, $cozmU.useMemo)(()=>$b9206e5f8eb43fd0$var$getSourceSyncBlockPlaceholderStyles(JSON.stringify(formatMessage((0, $WnqKg.placeholderTextMessages).sourceSyncBlockPlaceholderText))), [
        formatMessage
    ]);
    return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $lOiVq.Global), {
        styles: placeholderStyles
    });
};











const $bb91247d9c925f3a$export$f8d6f80345184030 = ({ syncBlockStoreManager: syncBlockStoreManager, api: api })=>{
    const { mode: mode } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'connectivity'
    ], (states)=>({
            mode: states.connectivityState?.mode
        }));
    const isOnline = !(0, $jaFVy.isOfflineMode)(mode);
    (0, $cozmU.useEffect)(()=>{
        const useRealTimeSubscriptions = isOnline;
        syncBlockStoreManager.referenceManager.setRealTimeSubscriptionsEnabled(useRealTimeSubscriptions);
    }, [
        syncBlockStoreManager,
        isOnline
    ]);
    return null;
};





parcelRequire("cozmU");


var $3nacY = parcelRequire("3nacY");

var $hVLmg = parcelRequire("hVLmg");


var $7T88d = parcelRequire("7T88d");

var $5AKbu = parcelRequire("5AKbu");























var $6t3CY = parcelRequire("6t3CY");

var $lslMH = parcelRequire("lslMH");






const $378948e6d1a6f43a$export$954568e298a26ab0 = ({ api: api })=>{
    const intl = (0, $kSwu1.useIntl)();
    const { selection: selection, mode: mode } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'selection',
        'connectivity'
    ], (states)=>({
            selection: states.selectionState?.selection,
            mode: states.connectivityState?.mode
        }));
    // for toolbar button, we allow both creating a new synced block
    // and converting existing block to synced block
    const canBeConverted = Boolean(selection && (0, $04e29bf458c24792$export$a912fa82dfd54783)(selection));
    const canInsertEmptyBlock = Boolean(selection?.empty);
    const isDisabled = Boolean((0, $jaFVy.isOfflineMode)(mode) || !canBeConverted && !canInsertEmptyBlock);
    const onClick = (0, $cozmU.useCallback)(()=>{
        // Insert the synced block and stop preserving the selection in a single
        // transaction so the caret that insertSyncedBlock places inside the new
        // block survives (EDITOR-7949). The toolbar is not normally opened via the
        // block menu, but stopping preservation is defensive and keeps behaviour
        // consistent with the block-menu create item should preservation ever be
        // active (e.g. a block is selected via block-controls). Then re-focus so
        // the caret is active, but only when the transaction was actually
        // dispatched — otherwise a failed insertion would still steal DOM focus
        // into the editor (mirrors CreateSyncedBlockDropdownItem).
        const dispatched = api?.core?.actions.execute(({ tr: tr })=>{
            const result = api?.syncedBlock.commands.insertSyncedBlock((0, $krYZG.INPUT_METHOD).SYNCED_BLOCK_TB)({
                tr: tr
            });
            if (!result) return null;
            api?.blockControls?.commands?.stopPreservingSelection()({
                tr: tr
            });
            return tr;
        });
        if (dispatched) api?.core?.actions.focus();
    }, [
        api
    ]);
    const message = intl.formatMessage((0, $aI2Eh.syncBlockMessages).syncBlockLabel);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lslMH.ToolbarTooltip), {
        content: message,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $6t3CY.ToolbarButton), {
            label: message,
            iconBefore: /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3rarE))), {
                size: "small",
                label: ""
            }),
            isDisabled: isDisabled,
            testId: (0, $ec0a253b1ada3f34$export$ce5236bf4eef2662).primaryToolbarCreate,
            onClick: onClick
        })
    });
};


const $8a20a116451ec71e$var$SYNCED_BLOCK_PRIMARY_TOOLBAR_GROUP = {
    type: (0, $3nacY.SYNCED_BLOCK_GROUP).type,
    key: (0, $3nacY.SYNCED_BLOCK_GROUP).key,
    component: ({ children: children })=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $7T88d.Show), {
            above: "md",
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $5AKbu.ToolbarButtonGroup), {
                children: children
            })
        }),
    parents: [
        {
            type: (0, $3nacY.INSERT_BLOCK_SECTION).type,
            key: (0, $3nacY.INSERT_BLOCK_SECTION).key,
            rank: (0, $hVLmg.INSERT_BLOCK_SECTION_RANK)[(0, $3nacY.SYNCED_BLOCK_GROUP).key]
        }
    ]
};
const $8a20a116451ec71e$export$a758406ca53b86a5 = (api, enableSourceSyncedBlockCreation)=>{
    if (!enableSourceSyncedBlockCreation) return [];
    return [
        $8a20a116451ec71e$var$SYNCED_BLOCK_PRIMARY_TOOLBAR_GROUP,
        {
            type: (0, $3nacY.SYNCED_BLOCK_BUTTON).type,
            key: (0, $3nacY.SYNCED_BLOCK_BUTTON).key,
            component: ()=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $378948e6d1a6f43a$export$954568e298a26ab0), {
                    api: api
                }),
            parents: [
                {
                    type: (0, $3nacY.SYNCED_BLOCK_GROUP).type,
                    key: (0, $3nacY.SYNCED_BLOCK_GROUP).key,
                    rank: (0, $hVLmg.SYNCED_BLOCK_SECTION_RANK)[(0, $3nacY.SYNCED_BLOCK_BUTTON).key]
                }
            ]
        }
    ];
};


/**
 * EDITOR-6929 / PR-G: Guard contentComponent rendering.
 * When `hasSyncedBlocks` is false return null
 * to avoid mounting SyncBlockRefresher, DeleteConfirmationModal, and Flag —
 * their hooks (useSharedPluginStateWithSelector) would execute selectors on
 * every transaction for no benefit on the ~99.98% of pages with zero synced
 * blocks.
 */ const $5d3a78d9c2d2a5c7$var$LazySyncedBlockUI = ({ syncBlockStore: syncBlockStoreManager, api: api, editorView: editorView, onFeedbackPromptShown: onFeedbackPromptShown, onGiveFeedback: onGiveFeedback })=>{
    const hasSyncBlocks = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'syncedBlock'
    ], (states)=>states.syncedBlockState?.hasSyncedBlocks);
    if (!hasSyncBlocks) return null;
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $8aG6j.Fragment), {
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $bb91247d9c925f3a$export$f8d6f80345184030), {
                syncBlockStoreManager: syncBlockStoreManager,
                api: api
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $571e47d3afda4415$export$d973532b09e0f2cc), {
                syncBlockStoreManager: syncBlockStoreManager,
                api: api,
                editorView: editorView
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $93a1ff420248a392$export$48ea269755562084), {
                api: api,
                onFeedbackPromptShown: onFeedbackPromptShown,
                onGiveFeedback: onGiveFeedback
            })
        ]
    });
};
const $5d3a78d9c2d2a5c7$export$4567b5886e253c5a = ({ config: config, api: api })=>{
    const refs = {};
    const viewMode = api?.editorViewMode?.sharedState.currentState()?.mode;
    const syncBlockStore = new (0, $5I78X.SyncBlockStoreManager)(config?.syncBlockDataProvider, viewMode, config?.__livePage);
    syncBlockStore.setFireAnalyticsEvent(api?.analytics?.actions?.fireAnalyticsEvent);
    // --- Memoized getSharedState (EDITOR-6929 / PR-F) ---
    // Cache the last returned shared state object. On each call, perform a
    // shallow comparison of all fields against the cached value. If nothing
    // changed, return the cached reference so SharedStateAPI subscribers
    // (React components) skip re-rendering.
    let cachedSharedState;
    api?.blockMenu?.actions.registerBlockMenuComponents((0, $e23c7d606d2e1612$export$b1be7b75e24fc24b)(api, config?.enableSourceCreation ?? false));
    api?.toolbar?.actions.registerComponents((0, $8a20a116451ec71e$export$a758406ca53b86a5)(api, config?.enableSourceCreation ?? false));
    const isRegisteredSlashCommandEnabled = (0, $4o0zT.isExperimentEnabled)('platform_editor_slash_command');
    if (isRegisteredSlashCommandEnabled && config?.enableSourceCreation) api?.uiControlRegistry?.actions.register((0, $384df5d448cd347c$export$90150d61f16ca941)({
        api: api,
        syncBlockStore: syncBlockStore
    }));
    return {
        name: 'syncedBlock',
        nodes () {
            return [
                {
                    name: 'syncBlock',
                    node: (0, $5Z7gB.syncBlock)
                },
                {
                    name: 'bodiedSyncBlock',
                    node: (0, $c0Rae.bodiedSyncBlock)
                }
            ];
        },
        pmPlugins () {
            return [
                {
                    name: 'syncedBlockPlugin',
                    plugin: (params)=>(0, $92ceda184e2df47e$export$ae829ec7b2625219)(config, params, syncBlockStore, api)
                },
                {
                    name: 'menuAndToolbarExperiencesPlugin',
                    plugin: ()=>(0, $ffc7cbcf63c6d9c3$export$8e0a561331eb68ce)({
                            refs: refs,
                            dispatchAnalyticsEvent: (payload)=>api?.analytics?.actions?.fireAnalyticsEvent(payload)
                        })
                }
            ];
        },
        commands: {
            copySyncedBlockReferenceToClipboard: (inputMethod)=>(0, $4d68281089368b28$export$c461f640005976aa)(syncBlockStore, inputMethod, api, config?.__livePage),
            insertSyncedBlock: (inputMethod)=>({ tr: tr })=>{
                    if (!config?.enableSourceCreation) return null;
                    return (0, $4d68281089368b28$export$fbc30658d812c800)({
                        tr: tr,
                        syncBlockStore: syncBlockStore,
                        fireAnalyticsEvent: api?.analytics?.actions.fireAnalyticsEvent,
                        inputMethod: inputMethod
                    }) || null;
                }
        },
        actions: {
            flushBodiedSyncBlocks: ()=>{
                return (0, $38d1d0a193cd4295$export$809659ed37baae65)(syncBlockStore);
            },
            flushSyncedBlocks: ()=>{
                return (0, $38d1d0a193cd4295$export$42389f194734952a)(syncBlockStore);
            },
            discardUnpublishedSyncBlocks: ()=>{
                return (0, $38d1d0a193cd4295$export$e79742b5511b2d66)(syncBlockStore);
            }
        },
        pluginsOptions: {
            ...!isRegisteredSlashCommandEnabled && {
                quickInsert: (0, $0cbbe85ea6426dbe$export$69e699948916d30c)(config, api, syncBlockStore)
            },
            floatingToolbar: (state, intl)=>{
                // When registered slash-command support is on and the document has no synced blocks,
                // skip the toolbar config entirely to avoid the per-selection-change
                // cost of findSyncBlockOrBodiedSyncBlock (EDITOR-6931).
                if (!(0, $92ceda184e2df47e$export$cb5a03b39dafc9cc).getState(state)?.hasSyncedBlocks) return undefined;
                return (0, $cd8ed20e91ae803f$export$86ce8f8241c20a3)(state, intl, api, syncBlockStore, config?.__livePage, config?.onGiveFeedback);
            }
        },
        contentComponent: ({ containerElement: containerElement, wrapperElement: wrapperElement, popupsMountPoint: popupsMountPoint, editorView: editorView })=>{
            refs.containerElement = containerElement || undefined;
            refs.popupsMountPoint = popupsMountPoint || undefined;
            refs.wrapperElement = wrapperElement || undefined;
            return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $8aG6j.Fragment), {
                children: [
                    (0, $ieeJu.expValEquals)('platform_editor_sync_block_activation', 'isEnabled', true) && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $b9206e5f8eb43fd0$export$286cc38c7d222ebf), {}),
                    /*#__PURE__*/ (0, $8aG6j.jsx)($5d3a78d9c2d2a5c7$var$LazySyncedBlockUI, {
                        syncBlockStore: syncBlockStore,
                        api: api,
                        editorView: editorView,
                        onFeedbackPromptShown: config?.onFeedbackPromptShown,
                        onGiveFeedback: config?.onGiveFeedback
                    })
                ]
            });
        },
        getSharedState: (editorState)=>{
            if (!editorState) return;
            const pluginState = (0, $92ceda184e2df47e$export$cb5a03b39dafc9cc).getState(editorState);
            const { activeFlag: activeFlag, syncBlockStore: currentSyncBlockStore, bodiedSyncBlockDeletionStatus: bodiedSyncBlockDeletionStatus, retryCreationPosMap: retryCreationPosMap, hasSyncedBlocks: hasSyncedBlocks, hasUnsavedBodiedSyncBlockChanges: hasUnsavedBodiedSyncBlockChanges } = pluginState;
            // --- EDITOR-6929 / PR-F: return a stable reference when all
            // fields are unchanged to prevent unnecessary React re-renders. ---
            if (cachedSharedState !== undefined && cachedSharedState.activeFlag === activeFlag && cachedSharedState.syncBlockStore === currentSyncBlockStore && cachedSharedState.bodiedSyncBlockDeletionStatus === bodiedSyncBlockDeletionStatus && cachedSharedState.retryCreationPosMap === retryCreationPosMap && cachedSharedState.hasSyncedBlocks === hasSyncedBlocks && cachedSharedState.hasUnsavedBodiedSyncBlockChanges === hasUnsavedBodiedSyncBlockChanges) return cachedSharedState;
            const nextSharedState = {
                activeFlag: activeFlag,
                syncBlockStore: currentSyncBlockStore,
                bodiedSyncBlockDeletionStatus: bodiedSyncBlockDeletionStatus,
                retryCreationPosMap: retryCreationPosMap,
                hasSyncedBlocks: hasSyncedBlocks,
                hasUnsavedBodiedSyncBlockChanges: hasUnsavedBodiedSyncBlockChanges
            };
            cachedSharedState = nextSharedState;
            return nextSharedState;
        },
        // Destroy the SyncBlockStoreManager on editor unmount to cancel
        // pending timers, subscriptions, and in-flight fetches.
        destroy () {
            syncBlockStore.destroy();
        }
    };
};
module.exports["syncedBlockPlugin"] = $5d3a78d9c2d2a5c7$export$4567b5886e253c5a;

});

parcelRegister("3rarE", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::84739518118048ed21db64d5f304c13b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $280bfedcae88aedb$var$_react = $280bfedcae88aedb$var$_interopRequireDefault((parcelRequire("cozmU")));

var $280bfedcae88aedb$var$_baseNew = $280bfedcae88aedb$var$_interopRequireDefault((parcelRequire("gElAV")));
function $280bfedcae88aedb$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "BlockSynced".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/block-synced
 * Usage guidance:
 * Reserved for syncing content blocks in Editor experiences.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $280bfedcae88aedb$var$BlockSyncedIcon = (props)=>/*#__PURE__*/ $280bfedcae88aedb$var$_react.default.createElement($280bfedcae88aedb$var$_baseNew.default, Object.assign({
        name: "BlockSyncedIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M13.5 3a.5.5 0 0 0-.5-.5H3a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h3V15H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v2h-1.5z"/><path fill="currentcolor" d="M14.9 8.71a3.75 3.75 0 0 1 0 5.303l-.024.026.439.146a.75.75 0 0 1-.13 1.454l-2.476.354a.75.75 0 0 1-.848-.849l.353-2.474.029-.125a.75.75 0 0 1 1.425-.006l.147.44.025-.026a2.25 2.25 0 0 0 0-3.183l-.707-.707 1.06-1.06zm-3.818-1.98a.75.75 0 0 1 .85.849l-.354 2.475a.75.75 0 0 1-1.454.13l-.147-.44-.025.026a2.25 2.25 0 0 0 0 3.183l.707.707-1.06 1.06-.708-.707a3.75 3.75 0 0 1 0-5.303l.026-.026-.44-.146a.75.75 0 0 1 .13-1.454z"/>`
    }, props));
$280bfedcae88aedb$var$BlockSyncedIcon.displayName = 'BlockSyncedIcon';
var $280bfedcae88aedb$var$_default = module.exports.default = $280bfedcae88aedb$var$BlockSyncedIcon;

});


//# sourceMappingURL=FullPageEditorComponent.ef7dfbc6.js.map
